import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  HeartHandshake, Users, Calendar, DollarSign, Settings, LogOut,
  TrendingUp, Clock, CheckCircle, AlertCircle, Plus, FileText,
  UserPlus, Briefcase, BarChart3, Eye, Check, X, Edit, Trash2,
  FileCheck, AlertTriangle, Download, ChevronDown, ChevronUp, 
  ClipboardCheck, PenTool, CalendarDays, ChevronLeft, ChevronRight,
  RefreshCw, MapPin, MessageCircle, Send, Mail, Wallet, CreditCard,
  Building, Lightbulb, ShoppingCart, ArrowUpRight, ArrowDownLeft,
  Wifi, WifiOff, Archive, MessageSquare, Filter, Upload, Shield, Camera, User, Save, Banknote,
  ClipboardList, CheckSquare, Square, Tag, Gift, Percent, Star, Image, Share2, Copy,
  Video, BookOpen, GraduationCap, Play, PlayCircle, UserX, ScrollText, FileWarning, MailX, PhoneOff, 
  MessageSquare as SmsIcon, Receipt, Heart, Truck, IdCard, Package, Bell, UserCog, Award, Inbox, Headphones, Zap, Car, Activity, Phone,
  Sparkles, Shirt, Volume2, HandMetal, Target, UserCheck
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { 
  analyticsAPI, applicationsAPI, workersAPI, bookingsAPI, 
  servicesAPI, payrollAPI, schedulesAPI, clockAPI, calendarAPI, messagingAPI,
  fundsAPI, timeEntryAPI, payrollRunAPI, onboardingAPI, emailAPI, jobsAPI, archiveAPI, notesAPI, paymentsAPI, couponsAPI, galleryAPI, referralsAPI, educationAPI, reviewsAPI, policiesAPI, documentsAPI, assignmentEmailsAPI, contactAPI,
  receiptsAPI, tipsAPI, courierAPI, filesAPI
} from '../services/api';
import api from '../services/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Checkbox } from '../components/ui/checkbox';
import { toast } from 'sonner';
import useChatWebSocket from '../hooks/useChatWebSocket';
import useNotificationSound from '../hooks/useNotificationSound';
import ArchiveTab from '../components/owner/ArchiveTab';
import NotesModal, { NoteIconButton } from '../components/owner/NotesModal';
import NotificationBell from '../components/NotificationBell';
import JobBoardTab from '../components/owner/JobBoardTab';
import CompletedFormsTab from '../components/owner/CompletedFormsTab';
import AddWorkerModal from '../components/owner/AddWorkerModal';
import DeclinedJobsTab from '../components/owner/DeclinedJobsTab';
import CreateBookingModal from '../components/owner/CreateBookingModal';
import ServicesTab from '../components/owner/ServicesTab';
import BookingsTab from '../components/owner/BookingsTab';
import CouponsTab from '../components/owner/CouponsTab';
import GalleryTab from '../components/owner/GalleryTab';
import PoliciesTab from '../components/owner/PoliciesTab';
import EvaluationsTab from '../components/owner/EvaluationsTab';
import FailedEmailsTab from '../components/owner/FailedEmailsTab';
import CallOutsManagementTab from '../components/owner/CallOutsManagementTab';
import SMSLogsTab from '../components/owner/SMSLogsTab';
import DisputesTab from '../components/owner/DisputesTab';
import AuditLogsTab from '../components/owner/AuditLogsTab';
import ActivityLogsTab from '../components/owner/ActivityLogsTab';
import SystemTestCenter from '../components/owner/SystemTestCenter';
import CustomRequestsTab from '../components/owner/CustomRequestsTab';
import ReceiptsTab from '../components/owner/ReceiptsTab';
import TipsTab from '../components/owner/TipsTab';
import CourierTab from '../components/owner/CourierTab';
import ServiceFormsTab from '../components/owner/ServiceFormsTab';
import NotificationPreferences from '../components/owner/NotificationPreferences';
import FormTemplatesTab from '../components/owner/FormTemplatesTab';
import IDCardsTab from '../components/owner/IDCardsTab';
import AddOnsTab from '../components/owner/AddOnsTab';
import NotesSummaryTab from '../components/owner/NotesSummaryTab';
import CustomerFilesTab from '../components/owner/CustomerFilesTab';
import MessagesTab from '../components/owner/MessagesTab';
import ApplicationsTab from '../components/owner/ApplicationsTab';
import PayrollTab from '../components/owner/PayrollTab';
import WorkersTab from '../components/owner/WorkersTab';
import TimeRecordsTab from '../components/owner/TimeRecordsTab';
import PaymentsTab from '../components/owner/PaymentsTab';
import FundsTab from '../components/owner/FundsTab';
import OverviewTab from '../components/owner/OverviewTab';
import EducationTab from '../components/owner/EducationTab';
import EmailTab from '../components/owner/EmailTab';
import OnboardingTab from '../components/owner/OnboardingTab';
import FeedbackTab from '../components/owner/FeedbackTab';
import ReportsTab from '../components/owner/ReportsTab';
import PackagesTab from '../components/owner/PackagesTab';
import ReminderSettingsTab from '../components/owner/ReminderSettingsTab';
import AutoArchiveSettingsTab from '../components/owner/AutoArchiveSettingsTab';
import EmailTemplatesTab from '../components/owner/EmailTemplatesTab';
import OwnerProfileTab from '../components/owner/OwnerProfileTab';
import CertificationCoursesTab from '../components/owner/CertificationCoursesTab';
import CareersTab from '../components/owner/CareersTab';
import IncidentsTab from '../components/owner/IncidentsTab';
import CustomerPoliciesSection from '../components/owner/CustomerPoliciesSection';
import UploadsTab from '../components/owner/UploadsTab';
import PhotoGalleryTab from '../components/owner/PhotoGalleryTab';
import TimeOverrideControl from '../components/owner/TimeOverrideControl';
import SupportCenterTab from '../components/owner/SupportCenterTab';
import EmailSettingsTab from '../components/owner/EmailSettingsTab';
import CommunicationCenterTab from '../components/owner/CommunicationCenterTab';
import RidesTab from '../components/owner/RidesTab';
import DriverPayoutsTab from '../components/owner/DriverPayoutsTab';
import MasterScheduleTab from '../components/owner/MasterScheduleTab';
import PricingSettingsTab from '../components/owner/PricingSettingsTab';
import LeadsCRMTab from '../components/owner/LeadsCRMTab';
import PhoneBookingTab from '../components/owner/PhoneBookingTab';
import VisitorAnalyticsTab from '../components/owner/VisitorAnalyticsTab';
import TodaySchedule from '../components/owner/TodaySchedule';
import CustomerReviewsTab from '../components/owner/CustomerReviewsTab';
import PickUpJobsTab from '../components/owner/PickUpJobsTab';
import VideoCallModal from '../components/common/VideoCallModal';
import IncomingCallModal from '../components/common/IncomingCallModal';
import SupportButton from '../components/common/SupportButton';
import ContactsList from '../components/common/ContactsList';
import BottomNavBar from '../components/common/BottomNavBar';
import OwnerMoreMenu from '../components/owner/OwnerMoreMenu';
import ServiceWorkflowRouter from '../components/worker/ServiceWorkflowRouter';

const OwnerDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = window.location;
  
  // Initialize activeTab from URL query param or default to 'overview'
  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(location.search);
    return params.get('tab') || 'overview';
  });
  const [loading, setLoading] = useState(true);
  
  // Notification sound hook
  const { playNewBooking, playNewApplication, playSuccess, playNewRide, requestPermission, notificationsEnabled } = useNotificationSound();
  const prevBookingsCount = useRef(0);
  const prevAppsCount = useRef(0);
  const prevRidesCount = useRef(0);
  const isInitialLoad = useRef(true);
  
  // Data states
  const [analytics, setAnalytics] = useState(null);
  const [applications, setApplications] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [services, setServices] = useState([]);
  const [payStubs, setPayStubs] = useState([]);
  const [pendingTimeRecords, setPendingTimeRecords] = useState([]);
  const [selectedTimeRecord, setSelectedTimeRecord] = useState(null);
  
  // Onboarding states
  const [onboardingTracker, setOnboardingTracker] = useState(null);
  const [selectedOnboardingWorker, setSelectedOnboardingWorker] = useState(null);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);
  const [showDocUploadModal, setShowDocUploadModal] = useState(false);
  const [uploadingDocType, setUploadingDocType] = useState(null);
  
  // Job Board states
  const [pendingJobApprovals, setPendingJobApprovals] = useState([]);
  const [allWorkersHours, setAllWorkersHours] = useState([]);
  const [selectedWorkerProfile, setSelectedWorkerProfile] = useState(null);
  const [showWorkerProfileModal, setShowWorkerProfileModal] = useState(false);
  const [workerFile, setWorkerFile] = useState(null);
  const [showWorkerFileModal, setShowWorkerFileModal] = useState(false);
  const [workerFileLoading, setWorkerFileLoading] = useState(false);
  const [jobBoard, setJobBoard] = useState({ jobs: [], stats: {} });
  const [jobBoardFilter, setJobBoardFilter] = useState('all');
  const [editingJob, setEditingJob] = useState(null);
  const [showJobEditModal, setShowJobEditModal] = useState(false);
  const [showWorkerPreview, setShowWorkerPreview] = useState(false);
  
  // Owner Job Workflow Modal states
  const [showOwnerWorkflowModal, setShowOwnerWorkflowModal] = useState(false);
  const [ownerWorkflowJob, setOwnerWorkflowJob] = useState(null);
  
  // Multi-select states for bulk operations
  const [selectedServices, setSelectedServices] = useState([]);
  const [servicesSelectMode, setServicesSelectMode] = useState(false);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [jobsSelectMode, setJobsSelectMode] = useState(false);
  const [selectedPayStubs, setSelectedPayStubs] = useState([]);
  const [payStubsSelectMode, setPayStubsSelectMode] = useState(false);
  
  // Worker Payment Details states
  const [editingPaymentDetails, setEditingPaymentDetails] = useState(false);
  const [paymentDetailsForm, setPaymentDetailsForm] = useState({
    preferred_method: 'direct_deposit',
    bank_name: '',
    routing_number: '',
    account_number: '',
    account_type: 'checking',
    check_payee_name: '',
    check_address: '',
    check_city: '',
    check_state: '',
    check_zip: ''
  });
  const [savingPaymentDetails, setSavingPaymentDetails] = useState(false);
  
  // Payments tab states
  const [paymentsData, setPaymentsData] = useState({ payments: [], summary: {}, total: 0 });
  const [paymentsFilter, setPaymentsFilter] = useState('all');
  const [paymentsLoading, setPaymentsLoading] = useState(false);
  const [showPaymentEditModal, setShowPaymentEditModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [paymentEditData, setPaymentEditData] = useState({ cash_amount: '', payment_method: '', notes: '' });
  
  // Coupons tab states
  const [coupons, setCoupons] = useState([]);
  const [couponsLoading, setCouponsLoading] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [editingCoupon, setEditingCoupon] = useState(null);
  const [couponForm, setCouponForm] = useState({
    code: '',
    description: '',
    discount_type: 'percentage',
    discount_value: 10,
    min_order_amount: 0,
    max_uses: null,
    max_uses_per_customer: 1,
    valid_from: '',
    valid_until: '',
    is_active: true
  });
  
  // Schedule/Calendar states
  const [scheduleView, setScheduleView] = useState('week'); // 'day', 'week', or 'hours'
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [calendarBookings, setCalendarBookings] = useState({});
  const [daySchedule, setDaySchedule] = useState(null);
  const [workerSchedule, setWorkerSchedule] = useState(null);
  const [showWorkerScheduleModal, setShowWorkerScheduleModal] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [rescheduleData, setRescheduleData] = useState({ new_date: '', new_time: '', reason: '' });
  const [rescheduleConflicts, setRescheduleConflicts] = useState([]);
  const [weeklyHoursData, setWeeklyHoursData] = useState(null);
  const [loadingWeeklyHours, setLoadingWeeklyHours] = useState(false);
  
  // Gallery states
  const [pendingPhotos, setPendingPhotos] = useState([]);
  const [approvedPhotos, setApprovedPhotos] = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(false);
  
  // Referrals states
  const [pendingReferrals, setPendingReferrals] = useState([]);
  
  // Customer Feedback/Reviews states
  const [pendingReviews, setPendingReviews] = useState([]);
  const [approvedReviews, setApprovedReviews] = useState([]);
  const [reviewStats, setReviewStats] = useState(null);
  const [feedbackLoading, setFeedbackLoading] = useState(false);
  
  // Contact Submissions states
  const [contactSubmissions, setContactSubmissions] = useState([]);
  const [contactSubmissionsLoading, setContactSubmissionsLoading] = useState(false);
  const [contactStatusFilter, setContactStatusFilter] = useState('all');
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [showSubmissionModal, setShowSubmissionModal] = useState(false);
  
  // Education/Training states
  const [trainingCourses, setTrainingCourses] = useState([]);
  const [trainingProgress, setTrainingProgress] = useState([]);
  const [trainingStats, setTrainingStats] = useState(null);
  const [trainingLoading, setTrainingLoading] = useState(false);
  const [showCourseModal, setShowCourseModal] = useState(false);
  const [editingCourse, setEditingCourse] = useState(null);
  const [courseForm, setCourseForm] = useState({
    title: '',
    description: '',
    category: 'rules',
    video_url: '',
    duration_minutes: 10,
    thumbnail_url: '',
    is_required: true,
    is_active: true
  });
  const [selectedCourseFilter, setSelectedCourseFilter] = useState('all');
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showCourseDetailModal, setShowCourseDetailModal] = useState(false);
  const [showAssignCourseModal, setShowAssignCourseModal] = useState(false);
  const [assigningCourse, setAssigningCourse] = useState(null);
  
  // Email states
  const [emailRecipientType, setEmailRecipientType] = useState('all_workers');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailMessage, setEmailMessage] = useState('');
  const [emailRecipients, setEmailRecipients] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [emailLogs, setEmailLogs] = useState([]);
  const [sendingEmail, setSendingEmail] = useState(false);
  
  // Owner's "My Work" states - for when owner does work themselves
  const [ownerAssignedJobs, setOwnerAssignedJobs] = useState([]);
  const [ownerClockStatus, setOwnerClockStatus] = useState(null); // { isClockedIn, booking, clockedInAt }
  const [ownerCashPendingJobs, setOwnerCashPendingJobs] = useState([]);
  const [clockingIn, setClockingIn] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [showCashVerifyModal, setShowCashVerifyModal] = useState(false);
  const [cashVerifyBooking, setCashVerifyBooking] = useState(null);
  const [cashVerifyNotes, setCashVerifyNotes] = useState('');
  const [processingCashVerify, setProcessingCashVerify] = useState(false);
  
  // Multi-select states for bulk actions
  const [selectedWorkerIds, setSelectedWorkerIds] = useState([]);
  const [selectedBookingIds, setSelectedBookingIds] = useState([]);
  const [selectedEmailIds, setSelectedEmailIds] = useState([]);
  const [bulkSelectMode, setBulkSelectMode] = useState({ workers: false, bookings: false, emails: false });
  
  // Modal states
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showWorkerModal, setShowWorkerModal] = useState(false);
  const [showAddWorkerModal, setShowAddWorkerModal] = useState(false);
  const [advancedWorkerMode, setAdvancedWorkerMode] = useState(false);
  const [workerDocuments, setWorkerDocuments] = useState({ id_document: null, certifications: [], background_check: null });
  const [showApplicationDetail, setShowApplicationDetail] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [expandedApplications, setExpandedApplications] = useState({});
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedWorker, setSelectedWorker] = useState(null);
  
  // Worker Assignment Email Preview state
  const [emailPreviewModal, setEmailPreviewModal] = useState({
    open: false,
    booking: null,
    worker: null,
    preview: null,
    loading: false,
    editedSubject: '',
    editedContent: ''
  });
  
  // Manual booking creation state
  const [showCreateBookingModal, setShowCreateBookingModal] = useState(false);
  const [newBooking, setNewBooking] = useState({
    service_type: 'errands',
    service_name: '',
    scheduled_date: '',
    scheduled_time: '',
    duration_hours: 4,
    hourly_rate: 25,
    is_urgent: false,
    customer_name: '',
    customer_email: '',
    customer_phone: '',
    address: '',
    city: '',
    state: '',
    zip_code: '',
    notes: ''
  });
  
  // Create Ride modal state
  const [showCreateRideModal, setShowCreateRideModal] = useState(false);
  const [newRide, setNewRide] = useState({
    customer_name: '',
    customer_email: '',
    customer_phone: '',
    pickup_address: '',
    pickup_city: '',
    pickup_state: 'NC',
    pickup_zip: '',
    dropoff_address: '',
    dropoff_city: '',
    dropoff_state: 'NC',
    dropoff_zip: '',
    scheduled_date: '',
    scheduled_time: '',
    notes: '',
    ride_type: 'standard',
    passengers: 1
  });
  
  // Notification preferences modal state
  const [showNotificationPrefs, setShowNotificationPrefs] = useState(false);
  
  // Messaging state
  const [supportConversations, setSupportConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [conversationMessages, setConversationMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [sendingMessage, setSendingMessage] = useState(false);
  const [unreadSupportCount, setUnreadSupportCount] = useState(0);
  const [bookingConversations, setBookingConversations] = useState([]);
  const [messageViewType, setMessageViewType] = useState('support'); // 'support', 'booking', 'direct', 'group'
  const [showNewMessageModal, setShowNewMessageModal] = useState(false);
  const [allUsers, setAllUsers] = useState({ customers: [], workers: [] });
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const [newConversationMessage, setNewConversationMessage] = useState('');
  
  // Video/Voice Call state
  const [activeCall, setActiveCall] = useState(null);
  const [incomingCall, setIncomingCall] = useState(null);
  const [showCallModal, setShowCallModal] = useState(false);
  
  // Group chat state
  const [showGroupChatModal, setShowGroupChatModal] = useState(false);
  const [groupChatName, setGroupChatName] = useState('');
  const [groupChatParticipants, setGroupChatParticipants] = useState([]);
  const [groupConversations, setGroupConversations] = useState([]);
  
  // Booking details state
  const [showBookingDetailsModal, setShowBookingDetailsModal] = useState(false);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [loadingBookingDetails, setLoadingBookingDetails] = useState(false);
  const [bookingStatusTab, setBookingStatusTab] = useState('all'); // 'all', 'new', 'assigned', 'in_progress', 'completed'
  
  // Funds management state
  const [funds, setFunds] = useState({
    available_balance: 0,
    pending_balance: 0,
    total_received: 0,
    total_expenses: 0,
    transactions: []
  });
  const [fundsWorkers, setFundsWorkers] = useState({ workers: [], summary: {} });
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferData, setTransferData] = useState({
    type: 'expense',
    category: '',
    amount: '',
    description: '',
    recipient: ''
  });
  const [expenseCategories] = useState([
    { id: 'payroll', label: 'Pay Payroll', icon: Users },
    { id: 'supplies', label: 'Buy Supplies', icon: ShoppingCart },
    { id: 'rent', label: 'Building Rent', icon: Building },
    { id: 'utilities', label: 'Utilities (Lights, Water)', icon: Lightbulb },
    { id: 'overhead', label: 'Overhead Costs', icon: CreditCard },
    { id: 'other', label: 'Other Expense', icon: Wallet }
  ]);
  
  // Manual time entry state
  const [showManualTimeModal, setShowManualTimeModal] = useState(false);
  const [manualTimeEntry, setManualTimeEntry] = useState({
    worker_id: '',
    booking_id: '',
    date: new Date().toISOString().split('T')[0],
    clock_in_time: '09:00',
    clock_out_time: '17:00',
    notes: ''
  });
  
  // Message summary state
  const [messageSummary, setMessageSummary] = useState({
    open: 0,
    working: 0,
    closed: 0
  });
  const [messageFilter, setMessageFilter] = useState('all'); // 'all', 'open', 'working', 'closed'
  
  // Rejection modal state
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectingAppId, setRejectingAppId] = useState(null);
  const [rejectionReason, setRejectionReason] = useState('');
  const [rejectionReasons, setRejectionReasons] = useState([]);
  
  const [workerEditData, setWorkerEditData] = useState({
    phone: '',
    address: '',
    hourly_rate: 25,
    is_active: true
  });
  const [newWorker, setNewWorker] = useState({
    email: '',
    full_name: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zip_code: '',
    service_types: [],
    hourly_rate: 25,
    certifications: [],
    experience_years: 0,
    is_verified: true
  });
  const [newService, setNewService] = useState({
    name: '',
    description: '',
    service_type: 'errands',
    hourly_rate: 25,
    package_type: 'hourly',
    recurring_discount: 0,
    duration_hours: 2
  });
  const [editingService, setEditingService] = useState(null);
  const [showEditServiceModal, setShowEditServiceModal] = useState(false);

  // Archive states
  const [archiveSummary, setArchiveSummary] = useState({ deleted_workers: 0, deleted_jobs: 0, completed_jobs: 0, cancelled_bookings: 0, deleted_transactions: 0, deleted_applications: 0, archived_conversations: 0, archived_paystubs: 0, paid_paystubs: 0, total: 0 });
  const [archiveTab, setArchiveTab] = useState('completed'); // 'workers', 'jobs', 'completed', 'cancelled', 'transactions', 'applications', 'conversations', 'paystubs', 'services', 'policies', 'coupons'
  const [deletedWorkers, setDeletedWorkers] = useState([]);
  const [deletedJobs, setDeletedJobs] = useState([]);
  const [completedJobs, setCompletedJobs] = useState([]);
  const [cancelledBookings, setCancelledBookings] = useState([]);
  const [deletedTransactions, setDeletedTransactions] = useState([]);
  const [deletedApplications, setDeletedApplications] = useState([]);
  const [archivedConversations, setArchivedConversations] = useState([]);
  const [archivedPaystubs, setArchivedPaystubs] = useState([]);
  const [archivedEmails, setArchivedEmails] = useState([]);
  const [archiveLoading, setArchiveLoading] = useState(false);
  
  // Additional archive states for services, policies, coupons
  const [deletedServices, setDeletedServices] = useState([]);
  const [deletedPolicies, setDeletedPolicies] = useState([]);
  const [deletedCoupons, setDeletedCoupons] = useState([]);
  const [archivedReceipts, setArchivedReceipts] = useState([]);
  const [archivedTips, setArchivedTips] = useState([]);
  const [archivedCourierJobs, setArchivedCourierJobs] = useState([]);
  const [archivedIDCards, setArchivedIDCards] = useState([]);

  // Policies states
  const [policies, setPolicies] = useState([]);
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [editingPolicy, setEditingPolicy] = useState(null);
  const [policyForm, setPolicyForm] = useState({
    title: '',
    content: '',
    category: 'general',
    is_required_reading: false,
    priority: 0
  });
  const [policyStats, setPolicyStats] = useState(null);

  // Notes modal state
  const [notesModal, setNotesModal] = useState({ open: false, entityType: '', entityId: '', entityName: '' });
  const [noteCounts, setNoteCounts] = useState({});

  const fetchArchiveData = useCallback(async () => {
    setArchiveLoading(true);
    try {
      const summaryRes = await archiveAPI.getSummary();
      setArchiveSummary(summaryRes.data);
      
      // Fetch based on active tab
      if (archiveTab === 'workers') {
        const res = await archiveAPI.getDeletedWorkers();
        setDeletedWorkers(res.data.workers || []);
      } else if (archiveTab === 'jobs') {
        const res = await archiveAPI.getDeletedJobs();
        setDeletedJobs(res.data.jobs || []);
      } else if (archiveTab === 'completed') {
        const res = await archiveAPI.getCompletedJobs();
        setCompletedJobs(res.data.jobs || []);
      } else if (archiveTab === 'cancelled') {
        const res = await archiveAPI.getCancelledBookings();
        setCancelledBookings(res.data.bookings || []);
      } else if (archiveTab === 'transactions') {
        const res = await archiveAPI.getDeletedTransactions();
        setDeletedTransactions(res.data.transactions || []);
      } else if (archiveTab === 'applications') {
        const res = await archiveAPI.getDeletedApplications();
        setDeletedApplications(res.data.applications || []);
      } else if (archiveTab === 'conversations') {
        const res = await archiveAPI.getArchivedConversations();
        setArchivedConversations(res.data.conversations || []);
      } else if (archiveTab === 'paystubs') {
        const res = await archiveAPI.getArchivedPaystubs();
        setArchivedPaystubs(res.data.paystubs || []);
      } else if (archiveTab === 'emails') {
        const res = await archiveAPI.getArchivedEmails();
        setArchivedEmails(res.data.emails || []);
      } else if (archiveTab === 'services') {
        // Fetch inactive/deleted services
        const res = await servicesAPI.getAll();
        const inactive = (res.data || []).filter(s => !s.is_active);
        setDeletedServices(inactive);
      } else if (archiveTab === 'policies') {
        // Fetch inactive/deleted policies
        const res = await policiesAPI.getAll(null, false);
        const inactive = (res.data || []).filter(p => !p.is_active);
        setDeletedPolicies(inactive);
      } else if (archiveTab === 'coupons') {
        // Fetch inactive/deleted coupons
        const res = await couponsAPI.getAll();
        const inactive = (res.data || []).filter(c => !c.is_active);
        setDeletedCoupons(inactive);
      } else if (archiveTab === 'receipts') {
        // Fetch archived receipts
        const res = await receiptsAPI.getArchived();
        setArchivedReceipts(res.data || []);
      } else if (archiveTab === 'tips') {
        // Fetch archived tips
        const res = await tipsAPI.getArchived();
        setArchivedTips(res.data || []);
      } else if (archiveTab === 'courier') {
        // Fetch archived courier jobs
        const res = await courierAPI.getArchivedJobs();
        setArchivedCourierJobs(res.data || []);
      } else if (archiveTab === 'idcards') {
        // Fetch archived ID cards
        const res = await archiveAPI.getArchivedIDCards();
        setArchivedIDCards(res.data.cards || []);
      }
    } catch (err) {
      console.error('Failed to fetch archive data:', err);
    } finally {
      setArchiveLoading(false);
    }
  }, [archiveTab]);

  const handleRestoreReceipt = async (receiptId) => {
    try {
      await receiptsAPI.restore(receiptId);
      toast.success('Receipt restored');
      fetchArchiveData();
    } catch (err) {
      toast.error('Failed to restore receipt');
    }
  };

  const handleRestoreTip = async (tipId) => {
    try {
      await tipsAPI.restore(tipId);
      toast.success('Tip restored');
      fetchArchiveData();
    } catch (err) {
      toast.error('Failed to restore tip');
    }
  };

  const handleRestoreCourierJob = async (jobId) => {
    try {
      await courierAPI.restoreJob(jobId);
      toast.success('Courier job restored');
      fetchArchiveData();
    } catch (err) {
      toast.error('Failed to restore courier job');
    }
  };

  const handleRestoreIDCard = async (cardId) => {
    try {
      await archiveAPI.restoreIDCard(cardId);
      toast.success('ID card restored');
      fetchArchiveData();
    } catch (err) {
      toast.error('Failed to restore ID card');
    }
  };

  const handlePermanentDeleteIDCard = async (cardId) => {
    if (!window.confirm('Are you sure you want to permanently delete this ID card? This cannot be undone.')) return;
    try {
      await archiveAPI.permanentDeleteIDCard(cardId);
      toast.success('ID card permanently deleted');
      fetchArchiveData();
    } catch (err) {
      toast.error('Failed to delete ID card');
    }
  };

  const fetchAllData = useCallback(async () => {
    try {
      const [analyticsRes, appsRes, workersRes, bookingsRes, servicesRes, payRes] = await Promise.all([
        analyticsAPI.getDashboard(),
        applicationsAPI.getAll(),
        workersAPI.getAll(),
        bookingsAPI.getAll({ include_rides: true }),  // Include rides in unified booking view
        servicesAPI.getAllIncludingInactive(), // Include inactive services for owner management
        payrollAPI.getStubs()
      ]);
      setAnalytics(analyticsRes.data);
      setApplications(appsRes.data);
      setWorkers(workersRes.data);
      setBookings(bookingsRes.data);
      setServices(servicesRes.data);
      setPayStubs(payRes.data);
      
      // Play notification sounds for new items (skip initial load)
      if (!isInitialLoad.current) {
        const newBookingsCount = bookingsRes.data?.filter(b => !b.is_ride)?.length || 0;
        const newAppsCount = appsRes.data?.length || 0;
        const newRidesCount = bookingsRes.data?.filter(b => b.is_ride)?.length || 0;
        
        if (newBookingsCount > prevBookingsCount.current) {
          const showToast = playNewBooking();
          if (showToast) {
            toast.info(`🔔 New booking received!`, { duration: 4000 });
          }
        }
        
        if (newAppsCount > prevAppsCount.current) {
          const showToast = playNewApplication();
          if (showToast) {
            toast.info(`📋 New application received!`, { duration: 4000 });
          }
        }
        
        if (newRidesCount > prevRidesCount.current) {
          const showToast = playNewRide();
          if (showToast) {
            toast.info(`🚗 New ride request!`, { duration: 4000 });
          }
        }
      }
      
      // Update previous counts
      prevBookingsCount.current = bookingsRes.data?.filter(b => !b.is_ride)?.length || 0;
      prevAppsCount.current = appsRes.data?.length || 0;
      prevRidesCount.current = bookingsRes.data?.filter(b => b.is_ride)?.length || 0;
      isInitialLoad.current = false;
      
      // Fetch pending time records
      try {
        const timeRecordsRes = await clockAPI.getPendingApproval();
        setPendingTimeRecords(timeRecordsRes.data || []);
      } catch (e) {
        // No pending time records
      }
      
      // Fetch pending job approvals
      try {
        const jobApprovalsRes = await jobsAPI.getPendingApprovals();
        setPendingJobApprovals(jobApprovalsRes.data || []);
      } catch {
        // Silently ignore - feature may not be available
      }
      
      // Fetch full job board
      try {
        const jobBoardRes = await jobsAPI.getJobBoard();
        setJobBoard(jobBoardRes.data || { jobs: [], stats: {} });
      } catch {
        // Silently ignore - feature may not be available
      }
      
      // Fetch all workers hours
      try {
        const workersHoursRes = await jobsAPI.getAllWorkersHours();
        setAllWorkersHours(workersHoursRes.data || []);
      } catch {
        // Silently ignore - feature may not be available
      }
    } catch (error) {
      // Failed to fetch data
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  // Fetch archive data when archive tab is active
  useEffect(() => {
    if (activeTab === 'archive') {
      fetchArchiveData();
    }
  }, [activeTab, archiveTab, fetchArchiveData]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // ===== OWNER'S "MY WORK" FUNCTIONS =====
  
  // Fetch owner's assigned jobs (where owner is the worker)
  const fetchOwnerAssignedJobs = useCallback(async () => {
    try {
      // Get bookings assigned to owner (user.id as worker_id)
      const response = await bookingsAPI.getAll({ worker_id: user?.id });
      const assignedJobs = response.data.filter(b => 
        b.worker_id === user?.id && 
        ['confirmed', 'in_progress', 'pending'].includes(b.status)
      );
      setOwnerAssignedJobs(assignedJobs);
      
      // Filter cash pending jobs
      const cashPending = assignedJobs.filter(b => 
        b.payment_method === 'cash' && b.payment_status === 'cash_pending'
      );
      setOwnerCashPendingJobs(cashPending);
      
      // Check clock status
      const clockedIn = assignedJobs.find(b => b.status === 'in_progress');
      if (clockedIn) {
        setOwnerClockStatus({
          isClockedIn: true,
          booking: clockedIn,
          clockedInAt: clockedIn.clock_in_time
        });
      } else {
        setOwnerClockStatus({ isClockedIn: false, booking: null, clockedInAt: null });
      }
    } catch (error) {
      console.error('Failed to fetch owner assigned jobs:', error);
    }
  }, [user?.id]);

  // Handle special tab actions (like opening modals from mobile nav)
  useEffect(() => {
    if (activeTab === 'addworker') {
      setShowAddWorkerModal(true);
      setActiveTab('workers'); // Switch to workers tab as background
    }
    if (activeTab === 'postjob') {
      // Navigate to careers tab and trigger job post
      setActiveTab('careers');
    }
  }, [activeTab]);

  // Get current location for clock in/out
  useEffect(() => {
    if (activeTab === 'clockinout' || activeTab === 'myjobs') {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setCurrentLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          },
          (error) => {
            toast.error('Please enable location services for clock in/out');
          }
        );
      }
      fetchOwnerAssignedJobs();
    }
  }, [activeTab, fetchOwnerAssignedJobs]);

  // Handle owner clock in
  const handleOwnerClockIn = async (bookingId) => {
    if (!currentLocation) {
      toast.error('Please enable location services');
      return;
    }
    
    setClockingIn(true);
    try {
      await clockAPI.clockIn({
        booking_id: bookingId,
        latitude: currentLocation.lat,
        longitude: currentLocation.lng
      });
      toast.success('Clocked in successfully!');
      fetchOwnerAssignedJobs();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Clock in failed');
    } finally {
      setClockingIn(false);
    }
  };

  // Handle owner clock out
  const handleOwnerClockOut = async (bookingId) => {
    if (!currentLocation) {
      toast.error('Please enable location services');
      return;
    }
    
    setClockingIn(true);
    try {
      await clockAPI.clockOut({
        booking_id: bookingId,
        latitude: currentLocation.lat,
        longitude: currentLocation.lng,
        signature_data: `Owner: ${user?.full_name}`,
        signature_name: user?.full_name || 'Owner',
        is_self_signed: true,
        self_sign_reason: 'Owner completing own work'
      });
      toast.success('Clocked out successfully!');
      fetchOwnerAssignedJobs();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Clock out failed');
    } finally {
      setClockingIn(false);
    }
  };

  // Handle owner cash payment verification
  const handleOwnerCashVerify = async (received) => {
    if (!cashVerifyBooking) return;
    
    setProcessingCashVerify(true);
    try {
      await bookingsAPI.verifyCashPayment(cashVerifyBooking.id, {
        received: received,
        notes: cashVerifyNotes.trim() || null
      });
      
      if (received) {
        toast.success('Cash payment verified! You may now proceed with the service.');
      } else {
        toast.warning('Booking cancelled due to non-payment. Customer has been notified.');
      }
      
      setShowCashVerifyModal(false);
      setCashVerifyBooking(null);
      setCashVerifyNotes('');
      fetchOwnerAssignedJobs();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to verify cash payment');
    } finally {
      setProcessingCashVerify(false);
    }
  };

  // ===== END OWNER'S "MY WORK" FUNCTIONS =====

  // Handle assigning owner to a booking (self-assignment)
  const handleAssignToOwner = async (booking) => {
    try {
      // Assign the owner (current user) as the worker
      await bookingsAPI.assignWorker(booking.id, user.id);
      toast.success(`You've been assigned to "${booking.service_name}"!`, {
        description: 'Go to "My Assigned Jobs" to view and start the job.'
      });
      
      // Refresh data
      fetchAllData();
      fetchOwnerAssignedJobs();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to assign booking to yourself');
    }
  };

  // Handle batch assigning owner to multiple bookings
  const handleBatchAssignToOwner = async (bookingIds) => {
    if (!bookingIds || bookingIds.length === 0) return;
    
    const loadingToast = toast.loading(`Assigning ${bookingIds.length} bookings to you...`);
    let successCount = 0;
    let failCount = 0;
    
    for (const bookingId of bookingIds) {
      try {
        await bookingsAPI.assignWorker(bookingId, user.id);
        successCount++;
      } catch (error) {
        failCount++;
        console.error(`Failed to assign booking ${bookingId}:`, error);
      }
    }
    
    toast.dismiss(loadingToast);
    
    if (successCount > 0) {
      toast.success(`Successfully assigned ${successCount} booking(s) to you!`, {
        description: 'Go to "My Assigned Jobs" to view and start work.'
      });
    }
    if (failCount > 0) {
      toast.error(`Failed to assign ${failCount} booking(s)`);
    }
    
    // Clear selection and refresh
    setSelectedBookingIds([]);
    fetchAllData();
    fetchOwnerAssignedJobs();
  };

  // Messaging functions
  const fetchSupportConversations = useCallback(async () => {
    try {
      const response = await messagingAPI.getSupportConversations();
      setSupportConversations(response.data);
      const totalUnread = response.data.reduce((sum, c) => sum + (c.unread_count || 0), 0);
      setUnreadSupportCount(totalUnread);
    } catch (error) {
      // Failed to fetch support conversations
    }
  }, []);

  const fetchConversationMessages = useCallback(async (conversationId) => {
    try {
      const response = await messagingAPI.getConversation(conversationId);
      setConversationMessages(response.data.messages);
    } catch (error) {
      // Failed to fetch messages
    }
  }, []);

  const handleSelectConversation = (conv) => {
    setSelectedConversation(conv);
    fetchConversationMessages(conv.id);
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !selectedConversation) return;
    
    setSendingMessage(true);
    try {
      // Use owner endpoint for booking and direct conversations
      if (messageViewType === 'booking' || messageViewType === 'direct') {
        await messagingAPI.sendMessageAsOwner(selectedConversation.id, newMessage.trim());
      } else {
        await messagingAPI.sendMessage(selectedConversation.id, newMessage.trim());
      }
      setNewMessage('');
      fetchConversationMessages(selectedConversation.id);
      if (messageViewType === 'support') {
        fetchSupportConversations();
      } else if (messageViewType === 'direct') {
        fetchDirectConversations();
      } else if (messageViewType === 'group') {
        fetchGroupConversations();
      } else {
        fetchBookingConversations();
      }
    } catch (error) {
      toast.error('Failed to send message');
    } finally {
      setSendingMessage(false);
    }
  };

  // Fetch booking conversations
  const fetchBookingConversations = useCallback(async () => {
    try {
      const response = await messagingAPI.getBookingConversations();
      setBookingConversations(response.data);
    } catch (error) {
      // Failed to fetch booking conversations
    }
  }, []);

  // Fetch direct conversations
  const [directConversations, setDirectConversations] = useState([]);
  const fetchDirectConversations = useCallback(async () => {
    try {
      const response = await messagingAPI.getDirectConversations();
      setDirectConversations(response.data);
    } catch (error) {
      // Failed to fetch direct conversations
    }
  }, []);

  // Fetch group conversations
  const fetchGroupConversations = useCallback(async () => {
    try {
      const response = await messagingAPI.getConversations();
      const groups = (response.data || []).filter(c => c.conversation_type === 'group');
      setGroupConversations(groups);
    } catch (error) {
      // Failed to fetch group conversations
    }
  }, []);

  // Fetch all users for new message modal
  const fetchAllUsers = useCallback(async () => {
    try {
      const response = await messagingAPI.getAllUsers();
      // API returns flat list of users, need to separate by role
      const users = response.data || [];
      const workers = users.filter(u => u.role === 'worker');
      const customers = users.filter(u => u.role === 'customer');
      setAllUsers({ workers, customers });
    } catch (error) {
      // Failed to fetch users
    }
  }, []);

  // Poll for new messages when viewing conversations
  useEffect(() => {
    if (activeTab === 'messages') {
      fetchSupportConversations();
      fetchBookingConversations();
      fetchDirectConversations();
      fetchGroupConversations();
      fetchAllUsers();
      const interval = setInterval(() => {
        fetchSupportConversations();
        fetchBookingConversations();
        fetchDirectConversations();
        fetchGroupConversations();
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [activeTab, fetchSupportConversations, fetchBookingConversations, fetchDirectConversations, fetchGroupConversations, fetchAllUsers]);

  // Create group chat
  const handleCreateGroupChat = async () => {
    if (!groupChatName.trim() || groupChatParticipants.length === 0) {
      toast.error('Please enter a group name and select at least one participant');
      return;
    }
    
    try {
      await messagingAPI.createGroupChat({
        name: groupChatName.trim(),
        participant_ids: groupChatParticipants,
        initial_message: `Group "${groupChatName}" created`
      });
      toast.success('Group chat created successfully');
      setShowGroupChatModal(false);
      setGroupChatName('');
      setGroupChatParticipants([]);
      fetchGroupConversations();
      setMessageViewType('group');
    } catch (error) {
      toast.error('Failed to create group chat');
    }
  };

  // Start new conversation
  const handleStartNewConversation = async () => {
    if (!selectedRecipient || !newConversationMessage.trim()) {
      toast.error('Please select a recipient and enter a message');
      return;
    }
    
    try {
      await messagingAPI.startDirectConversation(
        selectedRecipient.id,
        selectedRecipient.type,
        newConversationMessage.trim()
      );
      toast.success('Message sent!');
      setShowNewMessageModal(false);
      setSelectedRecipient(null);
      setNewConversationMessage('');
      setMessageViewType('direct');
      fetchDirectConversations();
    } catch (error) {
      toast.error('Failed to send message');
    }
  };

  useEffect(() => {
    if (selectedConversation) {
      const fetchMessages = (messageViewType === 'booking' || messageViewType === 'direct')
        ? () => messagingAPI.getConversationMessagesOwner(selectedConversation.id).then(res => setConversationMessages(res.data))
        : () => fetchConversationMessages(selectedConversation.id);
      
      fetchMessages();
      const interval = setInterval(fetchMessages, 5000);
      return () => clearInterval(interval);
    }
  }, [selectedConversation?.id, messageViewType, fetchConversationMessages]);

  // Delete conversation handler
  const handleDeleteConversation = async (conversationId) => {
    if (!window.confirm('Are you sure you want to delete this conversation? This action cannot be undone.')) {
      return;
    }
    
    try {
      await messagingAPI.deleteConversation(conversationId);
      toast.success('Conversation deleted');
      if (selectedConversation?.id === conversationId) {
        setSelectedConversation(null);
        setConversationMessages([]);
      }
      fetchSupportConversations();
      fetchBookingConversations();
    } catch (error) {
      toast.error('Failed to delete conversation');
    }
  };

  // Fetch booking details
  const handleViewBookingDetails = async (bookingId) => {
    setLoadingBookingDetails(true);
    setShowBookingDetailsModal(true);
    try {
      const response = await bookingsAPI.getDetails(bookingId);
      setBookingDetails(response.data);
    } catch (error) {
      toast.error('Failed to load booking details');
      setShowBookingDetailsModal(false);
    } finally {
      setLoadingBookingDetails(false);
    }
  };

  // Fetch funds data
  const fetchFundsData = useCallback(async () => {
    try {
      const [overviewRes, workersRes] = await Promise.all([
        fundsAPI.getOverview(),
        fundsAPI.getWorkersSummary()
      ]);
      setFunds(overviewRes.data);
      setFundsWorkers(workersRes.data);
    } catch (error) {
      // Silent fail - funds data optional
    }
  }, []);

  // Fetch message summary
  const fetchMessageSummary = useCallback(async () => {
    try {
      const response = await messagingAPI.getMessageSummary();
      setMessageSummary(response.data);
    } catch (error) {
      // Silent fail - message summary optional
    }
  }, []);

  // Update conversation status
  const handleUpdateConversationStatus = async (conversationId, status) => {
    try {
      await messagingAPI.updateConversationStatus(conversationId, status);
      toast.success(`Conversation marked as ${status}`);
      fetchSupportConversations();
      fetchBookingConversations();
      fetchDirectConversations();
      fetchMessageSummary();
    } catch (error) {
      toast.error('Failed to update status');
    }
  };

  // Create manual time entry
  const handleCreateManualTimeEntry = async () => {
    if (!manualTimeEntry.worker_id || !manualTimeEntry.booking_id) {
      toast.error('Please select a worker and booking');
      return;
    }
    
    try {
      await timeEntryAPI.createManualEntry(
        manualTimeEntry.worker_id,
        manualTimeEntry.booking_id,
        manualTimeEntry.date,
        manualTimeEntry.clock_in_time,
        manualTimeEntry.clock_out_time,
        manualTimeEntry.notes
      );
      toast.success('Time entry created successfully');
      setShowManualTimeModal(false);
      setManualTimeEntry({
        worker_id: '',
        booking_id: '',
        date: new Date().toISOString().split('T')[0],
        clock_in_time: '09:00',
        clock_out_time: '17:00',
        notes: ''
      });
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create time entry');
    }
  };

  // Create expense / fund transfer
  const handleCreateExpense = async () => {
    if (!transferData.category || !transferData.amount) {
      toast.error('Please fill in category and amount');
      return;
    }
    
    try {
      await fundsAPI.createExpense(
        transferData.category,
        parseFloat(transferData.amount),
        transferData.description || `${transferData.category} expense`,
        transferData.recipient
      );
      toast.success(`Expense of $${transferData.amount} recorded`);
      setShowTransferModal(false);
      setTransferData({ type: 'expense', category: '', amount: '', description: '', recipient: '' });
      fetchFundsData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to record expense');
    }
  };

  // Run payroll
  const [payrollPeriod, setPayrollPeriod] = useState({
    start: new Date(new Date().setDate(new Date().getDate() - 14)).toISOString().split('T')[0],
    end: new Date().toISOString().split('T')[0]
  });
  const [runningPayroll, setRunningPayroll] = useState(false);
  
  // Payroll calculator state
  const [calcWorker, setCalcWorker] = useState('manual');
  const [calcHours, setCalcHours] = useState(40);
  const [calcRate, setCalcRate] = useState(25);
  const [calcOvertime, setCalcOvertime] = useState(0);
  const [calcBonus, setCalcBonus] = useState(0);
  const [calcPeriodStart, setCalcPeriodStart] = useState('');
  const [calcPeriodEnd, setCalcPeriodEnd] = useState('');
  const [calcNotes, setCalcNotes] = useState('');
  
  // Pay worker modal state
  const [payWorkerModal, setPayWorkerModal] = useState({ open: false, stub: null });
  const [paymentMethod, setPaymentMethod] = useState('direct_deposit');
  const [paymentNotes, setPaymentNotes] = useState('');

  const handleRunPayroll = async () => {
    setRunningPayroll(true);
    try {
      const response = await payrollRunAPI.runPayroll(payrollPeriod.start, payrollPeriod.end);
      toast.success(`Created ${response.data.pay_stubs.length} pay stubs - Total: $${response.data.total_payroll.toFixed(2)}`);
      fetchPayStubs();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to run payroll');
    } finally {
      setRunningPayroll(false);
    }
  };

  const handleSaveManualStub = async () => {
    const worker = workers.find(w => w.id === calcWorker);
    const workerName = worker ? worker.full_name : 'Manual Entry';
    
    try {
      await payrollRunAPI.createManualStub({
        worker_id: calcWorker,
        worker_name: workerName,
        hours_worked: calcHours,
        hourly_rate: calcRate,
        overtime_hours: calcOvertime,
        bonus: calcBonus,
        pay_period_start: calcPeriodStart,
        pay_period_end: calcPeriodEnd,
        notes: calcNotes || null
      });
      toast.success('Pay stub saved successfully');
      fetchPayStubs();
      // Reset form
      setCalcNotes('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to save pay stub');
    }
  };

  const handlePayWorkerWithMethod = async () => {
    if (!payWorkerModal.stub) return;
    try {
      await payrollRunAPI.payWorker(payWorkerModal.stub.id, paymentMethod, paymentNotes);
      toast.success(`Paid $${payWorkerModal.stub.net_pay?.toFixed(2)} via ${paymentMethod.replace('_', ' ')}`);
      setPayWorkerModal({ open: false, stub: null });
      setPaymentMethod('direct_deposit');
      setPaymentNotes('');
      fetchPayStubs();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Payment failed');
    }
  };

  const fetchPayStubs = useCallback(async () => {
    try {
      const response = await payrollRunAPI.getStubs();
      setPayStubs(response.data);
    } catch (error) {
      // Failed to fetch pay stubs
    }
  }, []);

  const fetchOnboardingTracker = useCallback(async () => {
    try {
      const response = await onboardingAPI.getTracker();
      setOnboardingTracker(response.data);
    } catch (error) {
      // Failed to fetch onboarding tracker
    }
  }, []);

  const handlePayWorker = async (stub) => {
    // Open payment modal instead of direct payment
    setPayWorkerModal({ open: true, stub });
  };

  // Fetch funds and message summary when tab changes
  useEffect(() => {
    if (activeTab === 'funds') {
      fetchFundsData();
    }
    if (activeTab === 'messages') {
      fetchMessageSummary();
    }
    if (activeTab === 'payroll') {
      fetchPayStubs();
    }
    if (activeTab === 'onboarding') {
      fetchOnboardingTracker();
    }
    if (activeTab === 'email') {
      // Fetch email logs when switching to email tab
      emailAPI.getEmailLogs().then(res => setEmailLogs(res.data)).catch(() => {});
    }
  }, [activeTab, fetchFundsData, fetchMessageSummary, fetchPayStubs, fetchOnboardingTracker]);

  const handleApproveApplication = async (appId) => {
    try {
      const response = await applicationsAPI.approve(appId);
      toast.success(`Application approved! Temp password: ${response.data.temp_password}`);
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to approve application');
    }
  };

  const handleDeleteApplication = async (appId, appName) => {
    if (!window.confirm(`Delete application from ${appName}? This will move it to archive.`)) return;
    try {
      await applicationsAPI.delete(appId);
      toast.success('Application moved to archive');
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to delete application');
    }
  };

  const handleRejectApplication = async (appId) => {
    // First fetch rejection reasons if not loaded
    if (rejectionReasons.length === 0) {
      try {
        const res = await applicationsAPI.getRejectionReasons();
        setRejectionReasons(res.data.reasons || []);
      } catch (e) {
        // Use defaults if fetch fails
        setRejectionReasons([
          { id: 'incomplete_documents', label: 'Incomplete Documents' },
          { id: 'expired_credentials', label: 'Expired Credentials/Certifications' },
          { id: 'failed_background', label: 'Failed Background Check' },
          { id: 'insufficient_experience', label: 'Insufficient Experience' },
          { id: 'position_filled', label: 'Position Already Filled' },
          { id: 'location_mismatch', label: 'Location Outside Service Area' },
          { id: 'availability_mismatch', label: "Availability Doesn't Match Needs" },
          { id: 'other', label: 'Other Reason' }
        ]);
      }
    }
    setRejectingAppId(appId);
    setRejectionReason('');
    setShowRejectModal(true);
  };

  const confirmRejectApplication = async () => {
    if (!rejectionReason) {
      toast.error('Please select a rejection reason');
      return;
    }
    try {
      await applicationsAPI.reject(rejectingAppId, rejectionReason);
      toast.success('Application rejected - notification email sent');
      setShowRejectModal(false);
      setRejectingAppId(null);
      setRejectionReason('');
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to reject application');
    }
  };

  // Time Record Approval Functions
  const handleApproveTimeRecord = async (recordId) => {
    try {
      await clockAPI.approve(recordId, '');
      toast.success('Time record approved for payroll');
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to approve time record');
    }
  };

  const handleRejectTimeRecord = async (recordId) => {
    const reason = prompt('Enter rejection reason:');
    if (!reason) return;
    
    try {
      await clockAPI.reject(recordId, reason);
      toast.success('Time record rejected');
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to reject time record');
    }
  };

  const formatDateTime = (isoString) => {
    if (!isoString) return 'N/A';
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  const handleCreateService = async (e) => {
    e.preventDefault();
    try {
      await servicesAPI.create(newService);
      toast.success('Service created successfully!');
      setShowServiceModal(false);
      setNewService({
        name: '',
        description: '',
        service_type: 'errands',
        hourly_rate: 25,
        package_type: 'hourly',
        recurring_discount: 0,
        duration_hours: 2
      });
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create service');
    }
  };

  const handleEditService = (service) => {
    setEditingService({
      id: service.id,
      name: service.name,
      description: service.description || '',
      service_type: service.service_type,
      hourly_rate: service.hourly_rate,
      package_type: service.package_type,
      recurring_discount: service.recurring_discount || 0,
      duration_hours: service.duration_hours || 2
    });
    setShowEditServiceModal(true);
  };

  const [updatingService, setUpdatingService] = useState(false);
  const handleUpdateService = async (e) => {
    e.preventDefault();
    if (!editingService || updatingService) return;
    setUpdatingService(true);
    try {
      await servicesAPI.update(editingService.id, {
        name: editingService.name,
        description: editingService.description,
        service_type: editingService.service_type,
        hourly_rate: editingService.hourly_rate,
        package_type: editingService.package_type,
        recurring_discount: editingService.recurring_discount,
        duration_hours: editingService.duration_hours
      });
      toast.success('Service updated successfully!');
      setShowEditServiceModal(false);
      setEditingService(null);
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update service');
    } finally {
      setUpdatingService(false);
    }
  };

  const handleDeleteService = async (serviceId) => {
    if (!confirm('Delete this service? It will be moved to Archive.')) return;
    try {
      await servicesAPI.delete(serviceId);
      toast.success('Service deleted');
      fetchAllData();
    } catch (error) {
      toast.error('Failed to delete service');
    }
  };

  const handleAssignWorker = async (workerId) => {
    try {
      // First assign the worker
      await bookingsAPI.assignWorker(selectedBooking.id, workerId);
      toast.success('Worker assigned successfully!');
      setShowAssignModal(false);
      
      // Then fetch email preview
      setEmailPreviewModal(prev => ({ ...prev, loading: true, open: true }));
      try {
        const previewRes = await assignmentEmailsAPI.getPreview(selectedBooking.id, workerId);
        setEmailPreviewModal({
          open: true,
          booking: selectedBooking,
          worker: { id: workerId },
          preview: previewRes.data,
          loading: false,
          editedSubject: previewRes.data.subject,
          editedContent: previewRes.data.html_content
        });
      } catch (previewError) {
        console.error('Failed to get email preview:', previewError);
        toast.error('Worker assigned but failed to generate email preview');
        setEmailPreviewModal(prev => ({ ...prev, open: false, loading: false }));
      }
      
      setSelectedBooking(null);
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to assign worker');
    }
  };
  
  const handleSendAssignmentEmail = async () => {
    if (!emailPreviewModal.preview) return;
    
    try {
      await assignmentEmailsAPI.sendEmail(
        emailPreviewModal.preview.booking_id,
        emailPreviewModal.preview.worker_id,
        emailPreviewModal.editedSubject,
        emailPreviewModal.editedContent,
        true // send copy to owner
      );
      toast.success('Confirmation email sent to customer!');
      setEmailPreviewModal({ open: false, booking: null, worker: null, preview: null, loading: false, editedSubject: '', editedContent: '' });
    } catch (error) {
      const errorDetail = error.response?.data?.detail;
      
      // Handle quota/rate limit errors specifically
      if (error.response?.status === 429 || errorDetail?.is_quota_error) {
        toast.error('Email service is temporarily unavailable. The email has been queued for retry.', {
          duration: 5000
        });
      } else if (typeof errorDetail === 'object' && errorDetail?.message) {
        toast.error(errorDetail.message);
      } else {
        toast.error(errorDetail || 'Failed to send email. Please try again.');
      }
    }
  };

  // Booking Action Modal State
  const [bookingActionModal, setBookingActionModal] = useState({
    open: false,
    bookingId: null,
    action: null, // 'confirm', 'start', 'complete', 'cancel'
    booking: null
  });
  const [actionFormData, setActionFormData] = useState({
    notes: '',
    notify_customer: true,
    send_confirmation_email: true,
    price_override: null,
    estimated_duration: null,
    cancellation_reason: '',
    completion_notes: '',
    before_photos: [],
    after_photos: [],
    offer_reschedule: false,
    reschedule_date: '',
    reschedule_time: ''
  });

  const handleBookingAction = async (bookingId, status, requireReason = false) => {
    // Find the booking
    const booking = bookings.find(b => b.id === bookingId);
    
    // Open modal for proper workflow instead of instant action
    setBookingActionModal({
      open: true,
      bookingId,
      action: status === 'confirmed' ? 'confirm' : 
              status === 'in_progress' ? 'start' : 
              status === 'completed' ? 'complete' : 
              status === 'cancelled' ? 'cancel' : status,
      booking
    });
    setActionFormData({
      notes: '',
      notify_customer: true,
      send_confirmation_email: true,
      price_override: booking?.total_amount || null,
      estimated_duration: booking?.duration_hours || 2,
      cancellation_reason: '',
      completion_notes: '',
      before_photos: [],
      after_photos: [],
      offer_reschedule: false,
      reschedule_date: '',
      reschedule_time: ''
    });
  };

  const executeBookingAction = async () => {
    const { bookingId, action } = bookingActionModal;
    
    try {
      // If reschedule is selected, change the action
      const isReschedule = action === 'cancel' && actionFormData.offer_reschedule && 
                           (actionFormData.reschedule_date || actionFormData.reschedule_time);
      
      const payload = {
        status: isReschedule ? 'confirmed' :  // Reschedule keeps it confirmed
                action === 'confirm' ? 'confirmed' : 
                action === 'start' ? 'in_progress' : 
                action === 'complete' ? 'completed' : 
                action === 'cancel' ? 'cancelled' : action,
        notes: actionFormData.notes,
        notify_customer: actionFormData.notify_customer,
        reason: actionFormData.cancellation_reason || actionFormData.notes
      };

      // Add reschedule data if provided
      if (isReschedule) {
        payload.reschedule_date = actionFormData.reschedule_date;
        payload.reschedule_time = actionFormData.reschedule_time;
        payload.reason = `Rescheduled: ${actionFormData.cancellation_reason || 'Schedule change'}`;
      }

      // Add price override if changed
      if (actionFormData.price_override && action === 'confirm') {
        payload.total_amount = parseFloat(actionFormData.price_override);
      }

      await bookingsAPI.manage(bookingId, payload);
      
      // Send confirmation email if requested
      if (action === 'confirm' && actionFormData.send_confirmation_email) {
        try {
          await api.post(`/assignment-emails/booking/${bookingId}/send`);
        } catch (e) {
          console.log('Email send attempted');
        }
      }
      
      toast.success(
        isReschedule ? `Booking rescheduled to ${actionFormData.reschedule_date} ${actionFormData.reschedule_time}!` :
        action === 'confirm' ? 'Booking confirmed! Customer notified.' :
        action === 'start' ? 'Job started! Clock-in recorded.' :
        action === 'complete' ? 'Job completed! Ready for payment.' :
        action === 'cancel' ? 'Booking cancelled. Customer notified.' : 'Booking updated!'
      );
      
      setBookingActionModal({ open: false, bookingId: null, action: null, booking: null });
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update booking');
    }
  };

  const handleDeleteBooking = async (booking) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to permanently delete this ${booking.status} booking?\n\n` +
      `Service: ${booking.service_name}\n` +
      `Reference: ${booking.reference_number || booking.id?.slice(0, 8)}\n` +
      `Customer: ${booking.customer_name || booking.guest_name || 'N/A'}\n\n` +
      `This action cannot be undone.`
    );
    
    if (!confirmDelete) return;
    
    try {
      await bookingsAPI.delete(booking.id, 'Owner requested deletion');
      toast.success('Booking deleted successfully');
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to delete booking');
    }
  };

  const handleGeneratePayroll = async () => {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
    
    try {
      const response = await payrollAPI.generate(start, end);
      toast.success(response.data.message);
      fetchAllData();
    } catch (error) {
      toast.error('Failed to generate payroll');
    }
  };

  const handleApprovePayStub = async (stubId) => {
    try {
      await payrollAPI.approveStub(stubId);
      toast.success('Pay stub approved');
      fetchAllData();
    } catch (error) {
      toast.error('Failed to approve pay stub');
    }
  };

  const handleEditWorker = (worker) => {
    setSelectedWorker(worker);
    setWorkerEditData({
      phone: worker.phone || '',
      address: worker.address || '',
      hourly_rate: worker.hourly_rate || 25,
      is_active: worker.is_active !== false
    });
    setShowWorkerModal(true);
  };

  const handleUpdateWorker = async (e) => {
    e.preventDefault();
    try {
      await workersAPI.update(selectedWorker.id, workerEditData);
      toast.success('Worker updated successfully!');
      setShowWorkerModal(false);
      setSelectedWorker(null);
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update worker');
    }
  };

  const handleCreateWorker = async (e) => {
    e.preventDefault();
    if (newWorker.service_types.length === 0) {
      toast.error('Please select at least one service type');
      return;
    }
    try {
      const response = await workersAPI.createManual(newWorker);
      toast.success(`Worker created! Temp password: ${response.data.temp_password}`);
      setShowAddWorkerModal(false);
      setNewWorker({
        email: '',
        full_name: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        zip_code: '',
        service_types: [],
        hourly_rate: 25,
        certifications: [],
        experience_years: 0,
        is_verified: true
      });
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create worker');
    }
  };

  const handleSendOffer = async (workerId, workerName, hasPendingOffer = false) => {
    let discardPrevious = false;
    
    if (hasPendingOffer) {
      const choice = window.confirm(
        `${workerName} has a pending offer letter.\n\n` +
        `Click OK to DISCARD the previous offer and send a NEW one.\n` +
        `Click Cancel to just RESEND a reminder for the existing offer.`
      );
      discardPrevious = choice;
    }
    
    try {
      await workersAPI.sendOffer(workerId, discardPrevious);
      if (discardPrevious) {
        toast.success(`New offer letter sent to ${workerName}! (Previous offer cancelled)`);
      } else {
        toast.success(`Offer letter sent to ${workerName}!`);
      }
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send offer letter');
    }
  };

  const handleDeleteWorker = async (workerId, workerName = null) => {
    const confirmMsg = workerName 
      ? `Are you sure you want to delete ${workerName}? This will move them to archive.`
      : 'Are you sure you want to delete this worker? This will move them to archive.';
    
    if (!window.confirm(confirmMsg)) {
      return;
    }
    
    try {
      await workersAPI.delete(workerId);
      toast.success('Worker moved to archive');
      fetchAllData();
      // Refresh weekly hours if in that view
      if (scheduleView === 'hours' && weeklyHoursData) {
        fetchWeeklyHours(weeklyHoursData.week_start);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to delete worker');
    }
  };

  const handleViewWorkerFile = async (workerId) => {
    setWorkerFileLoading(true);
    setEditingPaymentDetails(false);
    try {
      const res = await workersAPI.getWorkerFile(workerId);
      setWorkerFile(res.data);
      // Initialize payment details form with existing data
      const pd = res.data.payment_details || {};
      setPaymentDetailsForm({
        preferred_method: pd.preferred_method || 'direct_deposit',
        bank_name: pd.bank_name || '',
        routing_number: '', // Don't pre-fill sensitive data
        account_number: '', // Don't pre-fill sensitive data
        account_type: pd.account_type || 'checking',
        check_payee_name: pd.check_payee_name || res.data.worker?.full_name || '',
        check_address: pd.check_address || res.data.worker?.address || '',
        check_city: pd.check_city || res.data.worker?.city || '',
        check_state: pd.check_state || res.data.worker?.state || '',
        check_zip: pd.check_zip || res.data.worker?.zip_code || ''
      });
      setShowWorkerFileModal(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to load worker file');
    } finally {
      setWorkerFileLoading(false);
    }
  };

  const handleSavePaymentDetails = async () => {
    if (!workerFile?.worker?.id) return;
    setSavingPaymentDetails(true);
    try {
      await workersAPI.updatePaymentDetails(workerFile.worker.id, paymentDetailsForm);
      toast.success('Payment details saved successfully');
      setEditingPaymentDetails(false);
      // Refresh worker file to show updated data
      const res = await workersAPI.getWorkerFile(workerFile.worker.id);
      setWorkerFile(res.data);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to save payment details');
    } finally {
      setSavingPaymentDetails(false);
    }
  };

  // ============== BULK DELETE FUNCTIONS ==============
  
  const toggleWorkerSelection = (workerId) => {
    setSelectedWorkerIds(prev => 
      prev.includes(workerId) ? prev.filter(id => id !== workerId) : [...prev, workerId]
    );
  };

  const toggleBookingSelection = (bookingId) => {
    setSelectedBookingIds(prev => 
      prev.includes(bookingId) ? prev.filter(id => id !== bookingId) : [...prev, bookingId]
    );
  };

  const toggleEmailSelection = (emailId) => {
    setSelectedEmailIds(prev => 
      prev.includes(emailId) ? prev.filter(id => id !== emailId) : [...prev, emailId]
    );
  };

  const handleBulkDeleteWorkers = async () => {
    if (selectedWorkerIds.length === 0) return;
    if (!window.confirm(`Delete ${selectedWorkerIds.length} worker(s)? They will be moved to archive.`)) return;
    
    try {
      for (const workerId of selectedWorkerIds) {
        await workersAPI.delete(workerId);
      }
      toast.success(`${selectedWorkerIds.length} worker(s) deleted`);
      setSelectedWorkerIds([]);
      setBulkSelectMode(prev => ({ ...prev, workers: false }));
      fetchAllData();
    } catch (error) {
      toast.error('Failed to delete some workers');
    }
  };

  const handleBulkDeleteBookings = async () => {
    if (selectedBookingIds.length === 0) return;
    if (!window.confirm(`Cancel ${selectedBookingIds.length} booking(s)?`)) return;
    
    try {
      for (const bookingId of selectedBookingIds) {
        await bookingsAPI.cancel(bookingId);
      }
      toast.success(`${selectedBookingIds.length} booking(s) cancelled`);
      setSelectedBookingIds([]);
      setBulkSelectMode(prev => ({ ...prev, bookings: false }));
      fetchAllData();
    } catch (error) {
      toast.error('Failed to cancel some bookings');
    }
  };

  const handleBulkDeleteEmails = async () => {
    if (selectedEmailIds.length === 0) return;
    if (!window.confirm(`Delete ${selectedEmailIds.length} email log(s)?`)) return;
    
    try {
      await archiveAPI.bulkDeleteEmails(selectedEmailIds);
      toast.success(`${selectedEmailIds.length} email(s) deleted`);
      setSelectedEmailIds([]);
      setBulkSelectMode(prev => ({ ...prev, emails: false }));
      // Refresh email logs
      const logsRes = await emailAPI.getEmailLogs();
      setEmailLogs(logsRes.data || []);
    } catch (error) {
      toast.error('Failed to delete some emails');
    }
  };

  // ============== PAYMENTS FUNCTIONS ==============

  const fetchPayments = useCallback(async () => {
    setPaymentsLoading(true);
    try {
      const params = {};
      if (paymentsFilter !== 'all') {
        params.status = paymentsFilter;
      }
      const res = await paymentsAPI.getAll(params);
      setPaymentsData(res.data);
    } catch (error) {
      console.error('Failed to fetch payments:', error);
    } finally {
      setPaymentsLoading(false);
    }
  }, [paymentsFilter]);

  // Fetch payments when payments tab is active
  useEffect(() => {
    if (activeTab === 'payments') {
      fetchPayments();
    }
  }, [activeTab, paymentsFilter, fetchPayments]);

  // Coupons functions
  const fetchCoupons = useCallback(async () => {
    setCouponsLoading(true);
    try {
      const res = await couponsAPI.getAll();
      setCoupons(res.data || []);
    } catch (error) {
      console.error('Failed to fetch coupons:', error);
    } finally {
      setCouponsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'coupons') {
      fetchCoupons();
    }
  }, [activeTab, fetchCoupons]);

  const handleCreateCoupon = async () => {
    try {
      if (!couponForm.code || !couponForm.description) {
        toast.error('Please fill in all required fields');
        return;
      }
      await couponsAPI.create({
        ...couponForm,
        max_uses: couponForm.max_uses ? parseInt(couponForm.max_uses) : null,
        valid_from: couponForm.valid_from || null,
        valid_until: couponForm.valid_until || null
      });
      toast.success('Coupon created successfully!');
      setShowCouponModal(false);
      setCouponForm({
        code: '',
        description: '',
        discount_type: 'percentage',
        discount_value: 10,
        min_order_amount: 0,
        max_uses: null,
        max_uses_per_customer: 1,
        valid_from: '',
        valid_until: '',
        is_active: true
      });
      fetchCoupons();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create coupon');
    }
  };

  const handleUpdateCoupon = async () => {
    if (!editingCoupon) return;
    try {
      await couponsAPI.update(editingCoupon.id, {
        ...couponForm,
        max_uses: couponForm.max_uses ? parseInt(couponForm.max_uses) : null,
        valid_from: couponForm.valid_from || null,
        valid_until: couponForm.valid_until || null
      });
      toast.success('Coupon updated successfully!');
      setShowCouponModal(false);
      setEditingCoupon(null);
      setCouponForm({
        code: '',
        description: '',
        discount_type: 'percentage',
        discount_value: 10,
        min_order_amount: 0,
        max_uses: null,
        max_uses_per_customer: 1,
        valid_from: '',
        valid_until: '',
        is_active: true
      });
      fetchCoupons();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update coupon');
    }
  };

  const handleDeleteCoupon = async (couponId) => {
    if (!confirm('Are you sure you want to delete this coupon?')) return;
    try {
      await couponsAPI.delete(couponId);
      toast.success('Coupon deleted');
      fetchCoupons();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to delete coupon');
    }
  };

  const openEditCouponModal = (coupon) => {
    setEditingCoupon(coupon);
    setCouponForm({
      code: coupon.code,
      description: coupon.description,
      discount_type: coupon.discount_type,
      discount_value: coupon.discount_value,
      min_order_amount: coupon.min_order_amount || 0,
      max_uses: coupon.max_uses || '',
      max_uses_per_customer: coupon.max_uses_per_customer || 1,
      valid_from: coupon.valid_from ? coupon.valid_from.split('T')[0] : '',
      valid_until: coupon.valid_until ? coupon.valid_until.split('T')[0] : '',
      is_active: coupon.is_active
    });
    setShowCouponModal(true);
  };

  // Gallery functions
  const fetchGalleryPhotos = useCallback(async () => {
    setGalleryLoading(true);
    try {
      const [pendingRes, approvedRes] = await Promise.all([
        galleryAPI.getPending(),
        galleryAPI.getApproved()
      ]);
      setPendingPhotos(pendingRes.data || []);
      setApprovedPhotos(approvedRes.data || []);
    } catch (error) {
      console.error('Failed to fetch gallery photos:', error);
    } finally {
      setGalleryLoading(false);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'gallery') {
      fetchGalleryPhotos();
    }
  }, [activeTab, fetchGalleryPhotos]);

  const handleApprovePhoto = async (photoId, isFeatured = false) => {
    try {
      await galleryAPI.approvePhoto(photoId, isFeatured);
      toast.success('Photo approved!');
      fetchGalleryPhotos();
    } catch (error) {
      toast.error('Failed to approve photo');
    }
  };

  const handleRejectPhoto = async (photoId) => {
    if (!confirm('Are you sure you want to reject this photo? It will be deleted.')) return;
    try {
      await galleryAPI.rejectPhoto(photoId);
      toast.success('Photo rejected');
      fetchGalleryPhotos();
    } catch (error) {
      toast.error('Failed to reject photo');
    }
  };

  const handleToggleFeatured = async (photoId) => {
    try {
      const result = await galleryAPI.toggleFeatured(photoId);
      toast.success(result.data.message);
      fetchGalleryPhotos();
    } catch (error) {
      toast.error('Failed to update featured status');
    }
  };

  // Customer Feedback/Reviews functions
  const fetchFeedbackData = useCallback(async () => {
    setFeedbackLoading(true);
    try {
      const [pendingRes, publicRes, statsRes] = await Promise.all([
        reviewsAPI.getPending(),
        reviewsAPI.getPublic(false, null, 100),
        reviewsAPI.getStats()
      ]);
      setPendingReviews(pendingRes.data || []);
      setApprovedReviews(publicRes.data?.reviews || []);
      setReviewStats(statsRes.data);
    } catch (error) {
      console.error('Failed to fetch feedback:', error);
    } finally {
      setFeedbackLoading(false);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'feedback') {
      fetchFeedbackData();
    }
  }, [activeTab, fetchFeedbackData]);

  const handleApproveReview = async (reviewId, isFeatured = false) => {
    try {
      await reviewsAPI.approve(reviewId, isFeatured);
      toast.success('Review approved!');
      fetchFeedbackData();
    } catch (error) {
      toast.error('Failed to approve review');
    }
  };

  const handleRejectReview = async (reviewId) => {
    if (!confirm('Are you sure you want to reject this review?')) return;
    try {
      await reviewsAPI.reject(reviewId);
      toast.success('Review rejected');
      fetchFeedbackData();
    } catch (error) {
      toast.error('Failed to reject review');
    }
  };

  const handleDeleteReview = async (reviewId) => {
    if (!confirm('Are you sure you want to permanently delete this review?')) return;
    try {
      await reviewsAPI.delete(reviewId);
      toast.success('Review deleted');
      fetchFeedbackData();
    } catch (error) {
      toast.error('Failed to delete review');
    }
  };

  const handleToggleReviewFeatured = async (reviewId) => {
    try {
      const result = await reviewsAPI.toggleFeatured(reviewId);
      toast.success(result.data.message);
      fetchFeedbackData();
    } catch (error) {
      toast.error('Failed to update featured status');
    }
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star 
        key={`star-${i}`} 
        className={`w-4 h-4 ${i < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} 
      />
    ));
  };

  // Contact Submissions functions
  const fetchContactSubmissions = useCallback(async () => {
    setContactSubmissionsLoading(true);
    try {
      const status = contactStatusFilter === 'all' ? null : contactStatusFilter;
      const response = await contactAPI.getSubmissions(status);
      setContactSubmissions(response.data || []);
    } catch (error) {
      console.error('Failed to fetch contact submissions:', error);
    } finally {
      setContactSubmissionsLoading(false);
    }
  }, [contactStatusFilter]);

  useEffect(() => {
    if (activeTab === 'contactsubmissions') {
      fetchContactSubmissions();
    }
  }, [activeTab, fetchContactSubmissions]);

  const handleUpdateSubmissionStatus = async (submissionId, newStatus, notes = '') => {
    try {
      await contactAPI.updateStatus(submissionId, newStatus, notes);
      toast.success(`Status updated to ${newStatus}`);
      fetchContactSubmissions();
      setShowSubmissionModal(false);
    } catch (error) {
      toast.error('Failed to update status');
    }
  };

  const getContactStatusColor = (status) => {
    switch (status) {
      case 'new': return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
      case 'in_progress': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
      case 'responded': return 'bg-green-500/20 text-green-400 border-green-500/30';
      case 'closed': return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
      default: return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
    }
  };

  // Education/Training functions
  const fetchTrainingData = useCallback(async () => {
    setTrainingLoading(true);
    try {
      const [coursesRes, progressRes, statsRes] = await Promise.all([
        educationAPI.getCourses(selectedCourseFilter === 'all' ? null : selectedCourseFilter),
        educationAPI.getAllProgress(),
        educationAPI.getOverviewStats()
      ]);
      setTrainingCourses(coursesRes.data || []);
      setTrainingProgress(progressRes.data || []);
      setTrainingStats(statsRes.data);
    } catch (error) {
      console.error('Failed to fetch training data:', error);
    } finally {
      setTrainingLoading(false);
    }
  }, [selectedCourseFilter]);

  useEffect(() => {
    if (activeTab === 'education') {
      fetchTrainingData();
    }
  }, [activeTab, fetchTrainingData]);

  const handleCreateCourse = async () => {
    try {
      if (!courseForm.title || !courseForm.video_url) {
        toast.error('Please fill in title and video URL');
        return;
      }
      await educationAPI.createCourse(courseForm);
      toast.success('Training course created!');
      setShowCourseModal(false);
      setCourseForm({
        title: '',
        description: '',
        category: 'rules',
        video_url: '',
        duration_minutes: 10,
        thumbnail_url: '',
        is_required: true,
        is_active: true
      });
      fetchTrainingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create course');
    }
  };

  const handleUpdateCourse = async () => {
    if (!editingCourse) return;
    try {
      await educationAPI.updateCourse(editingCourse.id, courseForm);
      toast.success('Course updated!');
      setShowCourseModal(false);
      setEditingCourse(null);
      fetchTrainingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update course');
    }
  };

  const handleDeleteCourse = async (courseId) => {
    if (!confirm('Delete this course? All progress will be lost.')) return;
    try {
      await educationAPI.deleteCourse(courseId);
      toast.success('Course deleted');
      fetchTrainingData();
    } catch (error) {
      toast.error('Failed to delete course');
    }
  };

  const openEditCourseModal = (course) => {
    setEditingCourse(course);
    setCourseForm({
      title: course.title,
      description: course.description,
      category: course.category,
      video_url: course.video_url,
      duration_minutes: course.duration_minutes,
      thumbnail_url: course.thumbnail_url || '',
      is_required: course.is_required,
      is_active: course.is_active
    });
    setShowCourseModal(true);
  };

  const handleAssignCourseToWorker = async (workerId) => {
    if (!assigningCourse) return;
    try {
      await educationAPI.assignCourse(workerId, assigningCourse.id);
      toast.success('Course assigned!');
      setShowAssignCourseModal(false);
      setAssigningCourse(null);
      fetchTrainingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to assign course');
    }
  };

  const handleAssignCourseToAll = async () => {
    if (!assigningCourse) return;
    try {
      const res = await educationAPI.assignBulk(assigningCourse.id, null, true);
      toast.success(res.data.message);
      setShowAssignCourseModal(false);
      setAssigningCourse(null);
      fetchTrainingData();
    } catch (error) {
      toast.error('Failed to assign course');
    }
  };

  const getCategoryLabel = (cat) => {
    const labels = {
      rules: 'Company Rules',
      rides: 'Rides',
      courier: 'Courier',
      laundry: 'Laundry',
      errands: 'Errands & Tasks',
      safety: 'Safety',
      customer_service: 'Customer Service'
    };
    return labels[cat] || cat;
  };

  const getCategoryColor = (cat) => {
    const colors = {
      rules: 'bg-[#D4AF37]/10 text-blue-800',
      rides: 'bg-purple-100 text-purple-800',
      courier: 'bg-blue-100 text-blue-800',
      laundry: 'bg-pink-100 text-pink-800',
      errands: 'bg-pink-100 text-pink-800',
      safety: 'bg-[var(--error)]/15 text-[var(--error)]',
      customer_service: 'bg-orange-100 text-orange-800'
    };
    return colors[cat] || 'bg-[var(--background-subtle)] text-[var(--text-primary)]';
  };

  // Policies functions
  const fetchPolicies = useCallback(async () => {
    try {
      const [policiesRes, statsRes] = await Promise.all([
        policiesAPI.getAll(null, false),
        policiesAPI.getRequiredStats()
      ]);
      setPolicies(policiesRes.data || []);
      setPolicyStats(statsRes.data || null);
    } catch (error) {
      console.error('Failed to fetch policies:', error);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'policies') {
      fetchPolicies();
    }
  }, [activeTab, fetchPolicies]);

  const handleCreatePolicy = async () => {
    try {
      if (!policyForm.title || !policyForm.content) {
        toast.error('Please fill in title and content');
        return;
      }
      await policiesAPI.create(policyForm);
      toast.success('Policy created!');
      setShowPolicyModal(false);
      setPolicyForm({ title: '', content: '', category: 'general', is_required_reading: false, priority: 0 });
      fetchPolicies();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create policy');
    }
  };

  const handleUpdatePolicy = async () => {
    if (!editingPolicy) return;
    try {
      await policiesAPI.update(editingPolicy.id, policyForm);
      toast.success('Policy updated!');
      setShowPolicyModal(false);
      setEditingPolicy(null);
      fetchPolicies();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update policy');
    }
  };

  const handleDeletePolicy = async (policyId) => {
    if (!confirm('Delete this policy? All acknowledgements will be lost.')) return;
    try {
      await policiesAPI.delete(policyId);
      toast.success('Policy deleted');
      fetchPolicies();
    } catch (error) {
      toast.error('Failed to delete policy');
    }
  };

  const handleTogglePolicyActive = async (policy) => {
    try {
      await policiesAPI.update(policy.id, { is_active: !policy.is_active });
      toast.success(policy.is_active ? 'Policy deactivated' : 'Policy activated');
      fetchPolicies();
    } catch (error) {
      toast.error('Failed to update policy');
    }
  };

  const openEditPolicyModal = (policy) => {
    setEditingPolicy(policy);
    setPolicyForm({
      title: policy.title,
      content: policy.content,
      category: policy.category,
      is_required_reading: policy.is_required_reading,
      priority: policy.priority
    });
    setShowPolicyModal(true);
  };

  const getPolicyCategoryLabel = (cat) => {
    const labels = {
      general: 'General',
      safety: 'Safety',
      conduct: 'Conduct',
      procedures: 'Procedures',
      benefits: 'Benefits'
    };
    return labels[cat] || cat;
  };

  const getPolicyCategoryColor = (cat) => {
    const colors = {
      general: 'bg-[var(--background-subtle)] text-[var(--text-primary)]',
      safety: 'bg-[var(--error)]/15 text-[var(--error)]',
      conduct: 'bg-[#D4AF37]/10 text-blue-800',
      procedures: 'bg-[var(--success)]/15 text-[var(--success)]',
      benefits: 'bg-[#F4C2C2]/15 text-purple-800'
    };
    return colors[cat] || 'bg-[var(--background-subtle)] text-[var(--text-primary)]';
  };

  const handleDownloadInvoice = async (bookingId) => {
    try {
      const response = await paymentsAPI.getInvoice(bookingId);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `invoice_${bookingId.slice(0, 8).toUpperCase()}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      toast.success('Invoice downloaded');
    } catch (error) {
      toast.error('Failed to download invoice');
    }
  };

  const handleDownloadReceipt = async (bookingId) => {
    try {
      const response = await paymentsAPI.getReceipt(bookingId);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `receipt_${bookingId.slice(0, 8).toUpperCase()}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      toast.success('Receipt downloaded');
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error('No payments found for this booking');
      } else {
        toast.error('Failed to download receipt');
      }
    }
  };

  const handleUpdatePayment = async () => {
    if (!selectedPayment) return;
    try {
      await paymentsAPI.update(selectedPayment.id, {
        cash_amount: paymentEditData.cash_amount ? parseFloat(paymentEditData.cash_amount) : null,
        payment_method: paymentEditData.payment_method || null,
        notes: paymentEditData.notes || null
      });
      toast.success('Payment updated');
      setShowPaymentEditModal(false);
      setSelectedPayment(null);
      setPaymentEditData({ cash_amount: '', payment_method: '', notes: '' });
      fetchPayments();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update payment');
    }
  };

  const handleDeletePayment = async (bookingId, serviceName) => {
    if (!window.confirm(`Delete payment record for "${serviceName}"? This will move it to archive.`)) return;
    try {
      await paymentsAPI.delete(bookingId);
      toast.success('Payment moved to archive');
      fetchPayments();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to delete payment');
    }
  };

  // ============== SCHEDULE & CALENDAR FUNCTIONS ==============

  const getWeekDates = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Monday
    const monday = new Date(date.setDate(diff));
    const week = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(monday);
      d.setDate(monday.getDate() + i);
      week.push(d.toISOString().split('T')[0]);
    }
    return week;
  };

  const fetchCalendarData = useCallback(async (startDate, endDate) => {
    try {
      const response = await calendarAPI.getBookings(startDate, endDate);
      setCalendarBookings(response.data.bookings_by_date || {});
    } catch (error) {
      // Failed to fetch calendar data
    }
  }, []);

  const fetchDaySchedule = useCallback(async (date) => {
    try {
      const response = await calendarAPI.getDaySchedule(date);
      setDaySchedule(response.data);
    } catch (error) {
      // Failed to fetch day schedule
    }
  }, []);

  // Get Monday of the week for a given date
  const getWeekMonday = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust for Sunday
    const monday = new Date(date.setDate(diff));
    return monday.toISOString().split('T')[0];
  };

  const fetchWeeklyHours = useCallback(async (weekStart) => {
    setLoadingWeeklyHours(true);
    try {
      const response = await schedulesAPI.getWeeklyHours(weekStart);
      setWeeklyHoursData(response.data);
    } catch (error) {
      console.error('Failed to fetch weekly hours:', error);
      toast.error('Failed to load weekly hours data');
    } finally {
      setLoadingWeeklyHours(false);
    }
  }, []);

  const handleBlockWorker = async (workerId, weekStart, isBlocked) => {
    try {
      if (isBlocked) {
        await schedulesAPI.unblockWorkerWeek(workerId, weekStart);
        toast.success('Worker unblocked for this week');
      } else {
        await schedulesAPI.blockWorkerWeek(workerId, weekStart);
        toast.success('Worker blocked from taking more jobs this week');
      }
      // Refresh the data
      fetchWeeklyHours(weekStart);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update worker status');
    }
  };

  const fetchWorkerSchedule = async (workerId) => {
    try {
      const response = await calendarAPI.getWorkerSchedule(workerId);
      setWorkerSchedule(response.data);
    } catch (error) {
      toast.error('Failed to load worker schedule');
    }
  };

  const handleOpenWorkerSchedule = (worker) => {
    setSelectedWorker(worker);
    fetchWorkerSchedule(worker.id);
    setShowWorkerScheduleModal(true);
  };

  const handleOpenReschedule = (booking) => {
    setSelectedBooking(booking);
    setRescheduleData({
      new_date: booking.scheduled_date,
      new_time: booking.scheduled_time,
      reason: ''
    });
    setRescheduleConflicts([]);
    setShowRescheduleModal(true);
  };

  const handleCheckConflicts = async () => {
    if (!selectedBooking || !selectedBooking.worker_id) {
      return;
    }
    
    // Find worker profile by user_id
    const worker = workers.find(w => w.user_id === selectedBooking.worker_id);
    if (!worker) return;
    
    try {
      const response = await calendarAPI.checkWorkerConflicts(
        worker.id,
        rescheduleData.new_date,
        rescheduleData.new_time,
        selectedBooking.duration_hours || 2,
        selectedBooking.id
      );
      setRescheduleConflicts(response.data.conflicts || []);
      return response.data.has_conflict;
    } catch (error) {
      return false;
    }
  };

  const handleReschedule = async () => {
    if (!selectedBooking) return;
    
    try {
      const response = await bookingsAPI.reschedule(selectedBooking.id, {
        new_date: rescheduleData.new_date,
        new_time: rescheduleData.new_time,
        reason: rescheduleData.reason,
        notify_customer: true
      });
      
      if (response.data.success) {
        toast.success('Booking rescheduled successfully');
        setShowRescheduleModal(false);
        setSelectedBooking(null);
        fetchAllData();
      } else {
        setRescheduleConflicts(response.data.conflicts || []);
        toast.error(response.data.message || 'Conflicts detected');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to reschedule booking');
    }
  };

  const navigateDate = (direction) => {
    const current = new Date(selectedDate);
    if (scheduleView === 'day') {
      current.setDate(current.getDate() + direction);
    } else {
      current.setDate(current.getDate() + (direction * 7));
    }
    setSelectedDate(current.toISOString().split('T')[0]);
  };

  // Load schedule data when tab changes
  useEffect(() => {
    if (activeTab === 'schedule') {
      if (scheduleView === 'week') {
        const weekDates = getWeekDates(selectedDate);
        fetchCalendarData(weekDates[0], weekDates[6]);
      } else if (scheduleView === 'hours') {
        // Calculate Monday for the selected date
        const date = new Date(selectedDate);
        const day = date.getDay();
        const diff = date.getDate() - day + (day === 0 ? -6 : 1);
        const monday = new Date(date.setDate(diff));
        const weekMonday = monday.toISOString().split('T')[0];
        fetchWeeklyHours(weekMonday);
      } else {
        fetchDaySchedule(selectedDate);
      }
    }
  }, [activeTab, selectedDate, scheduleView, fetchCalendarData, fetchDaySchedule, fetchWeeklyHours]);

  const toggleWorkerServiceType = (type) => {
    setNewWorker(prev => ({
      ...prev,
      service_types: prev.service_types.includes(type)
        ? prev.service_types.filter(t => t !== type)
        : [...prev.service_types, type]
    }));
  };

  const toggleApplicationExpand = (appId) => {
    setExpandedApplications(prev => ({
      ...prev,
      [appId]: !prev[appId]
    }));
  };

  const getDocumentLabel = (docType) => {
    const labels = {
      id_document: 'ID Document',
      drivers_license: 'Drivers License',
      vehicle_registration: 'Vehicle Registration/Title',
      auto_insurance: 'Auto Insurance',
      background_check: 'Background Check',
      w9_form: 'W-9 Tax Form',
      direct_deposit: 'Direct Deposit',
      i9_form: 'I-9 Form'
    };
    return labels[docType] || docType;
  };

  const isDocumentExpiring = (expirationDate) => {
    if (!expirationDate) return false;
    const expDate = new Date(expirationDate);
    const today = new Date();
    const daysUntilExpiry = Math.floor((expDate - today) / (1000 * 60 * 60 * 24));
    return daysUntilExpiry <= 30 && daysUntilExpiry >= 0;
  };

  const isDocumentExpired = (expirationDate) => {
    if (!expirationDate) return false;
    const expDate = new Date(expirationDate);
    const today = new Date();
    return expDate < today;
  };

  // Job Approval Functions
  const handleApproveJob = async (jobId, workerId, workerName) => {
    try {
      await jobsAPI.approveJob(jobId, { worker_id: workerId, approved: true });
      toast.success(`Job approved and assigned to ${workerName}`);
      fetchAllData();
      
      // After approval, show email preview modal
      setEmailPreviewModal(prev => ({ ...prev, loading: true, open: true }));
      try {
        const previewRes = await assignmentEmailsAPI.getPreview(jobId, workerId);
        setEmailPreviewModal({
          open: true,
          booking: { id: jobId },
          worker: { id: workerId, full_name: workerName },
          preview: previewRes.data,
          loading: false,
          editedSubject: previewRes.data.subject,
          editedContent: previewRes.data.html_content
        });
      } catch (previewError) {
        console.error('Failed to get email preview:', previewError);
        toast.info('Job approved but could not generate email preview');
        setEmailPreviewModal(prev => ({ ...prev, open: false, loading: false }));
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to approve job');
    }
  };

  const handleDenyJob = async (jobId, workerId) => {
    try {
      await jobsAPI.approveJob(jobId, { worker_id: workerId, approved: false, reason: 'Denied by owner' });
      toast.success('Job claim denied. Job is back in available pool.');
      fetchAllData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to deny job');
    }
  };

  const handleManualAssign = async (jobId, workerId) => {
    try {
      await jobsAPI.assignJob(jobId, { worker_id: workerId, override_cap: false });
      toast.success('Job assigned successfully');
      fetchAllData();
      
      // Show email preview modal after manual assignment
      setEmailPreviewModal(prev => ({ ...prev, loading: true, open: true }));
      try {
        const previewRes = await assignmentEmailsAPI.getPreview(jobId, workerId);
        setEmailPreviewModal({
          open: true,
          booking: { id: jobId },
          worker: { id: workerId },
          preview: previewRes.data,
          loading: false,
          editedSubject: previewRes.data.subject,
          editedContent: previewRes.data.html_content
        });
      } catch (previewError) {
        console.error('Failed to get email preview:', previewError);
        toast.info('Worker assigned but could not generate email preview');
        setEmailPreviewModal(prev => ({ ...prev, open: false, loading: false }));
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to assign job');
    }
  };

  const handlePostJob = async (jobId) => {
    try {
      await jobsAPI.postJob(jobId);
      toast.success('Job posted to board');
      fetchAllData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to post job');
    }
  };

  const handlePostAllJobs = async () => {
    try {
      const res = await jobsAPI.postAllPending();
      toast.success(res.data.message);
      fetchAllData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to post jobs');
    }
  };

  const handleViewWorkerProfile = async (workerId) => {
    try {
      const res = await jobsAPI.getWorkerProfileSummary(workerId);
      setSelectedWorkerProfile(res.data);
      setShowWorkerProfileModal(true);
    } catch (err) {
      toast.error('Failed to load worker profile');
    }
  };

  const handleDeleteJob = async (jobId, jobName) => {
    if (!window.confirm(`Are you sure you want to delete this job?\n\n${jobName || 'This job'}\n\nThis action cannot be undone.`)) {
      return;
    }
    try {
      await jobsAPI.deleteJob(jobId);
      toast.success('Job deleted successfully');
      setShowJobEditModal(false);
      fetchAllData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to delete job');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Collapsible sidebar categories state - persist to localStorage
  const [collapsedCategories, setCollapsedCategories] = useState(() => {
    try {
      const saved = localStorage.getItem('owner_sidebar_collapsed');
      return saved ? JSON.parse(saved) : {};
    } catch (e) {
      return {};
    }
  });
  
  const toggleCategory = (category) => {
    setCollapsedCategories(prev => {
      const newState = {
        ...prev,
        [category]: !prev[category]
      };
      try {
        localStorage.setItem('owner_sidebar_collapsed', JSON.stringify(newState));
      } catch (e) {
        console.error('Error saving sidebar state:', e);
      }
      return newState;
    });
  };

  // Define pending counts before they're used in tabCategories
  const pendingBookings = bookings.filter(b => b.status === 'pending');

  // Organized tabs by category (alphabetical within each)
  const tabCategories = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: BarChart3,
      tabs: [
        { id: 'overview', label: 'Overview', icon: BarChart3 },
        { id: 'myprofile', label: 'My Profile', icon: UserCog },
        { id: 'reports', label: 'Reports', icon: TrendingUp },
        { id: 'visitor-analytics', label: 'Website Traffic', icon: Eye },
      ]
    },
    {
      id: 'mywork',
      label: 'My Work',
      icon: PlayCircle,
      tabs: [
        { id: 'quickbook', label: 'Book a Service', icon: Plus },
        { id: 'pickupjobs', label: 'Pick Up Jobs', icon: HandMetal },
        { id: 'myjobs', label: 'My Assigned Jobs', icon: Briefcase },
        { id: 'clockinout', label: 'Clock In/Out', icon: Clock },
        { id: 'cashverify', label: 'Verify Cash Payments', icon: DollarSign },
      ]
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: Users,
      tabs: [
        // Inquiry & Request Phase
        { id: 'divider-inquiry', label: 'Inquiries & Requests', isDivider: true },
        { id: 'leads', label: 'Leads & CRM', icon: Target },
        { id: 'contactsubmissions', label: 'Contact Submissions', icon: Inbox },
        { id: 'customrequests', label: 'Custom Requests', icon: Lightbulb },
        { id: 'messages', label: 'Messages', icon: MessageCircle, badge: unreadSupportCount },
        { id: 'support', label: 'Support Center', icon: Headphones },
        // Booking Phase
        { id: 'divider-booking', label: 'Booking', isDivider: true },
        { id: 'phone', label: 'Phone Booking', icon: Phone },
        { id: 'schedule', label: 'Schedule', icon: Calendar },
        { id: 'bookings', label: 'Bookings', icon: Calendar, badge: pendingBookings?.length || 0 },
        // Post-Service Phase
        { id: 'divider-postservice', label: 'Post-Service', isDivider: true },
        { id: 'reviews', label: 'Customer Reviews', icon: Star },
        { id: 'feedback', label: 'Customer Feedback', icon: Star },
        { id: 'disputes', label: 'Disputes', icon: AlertTriangle },
        // Records
        { id: 'divider-records', label: 'Records', isDivider: true },
        { id: 'customerfiles', label: 'Customer Files', icon: Users },
        { id: 'uploads', label: 'File Uploads', icon: Upload },
        { id: 'photogallery', label: 'Photo Gallery', icon: Image },
        // Reporting
        { id: 'divider-reporting', label: 'Reporting', isDivider: true },
        { id: 'incidents', label: 'Incident Reports', icon: AlertTriangle },
        { id: 'customerforms', label: 'Customer Forms', icon: FileText },
      ]
    },
    {
      id: 'workers',
      label: 'Workers',
      icon: Briefcase,
      tabs: [
        // Hiring & Onboarding
        { id: 'divider-hiring', label: 'Hiring & Onboarding', isDivider: true },
        { id: 'careers', label: 'Careers', icon: Briefcase },
        { id: 'applications', label: 'Applications', icon: UserPlus, badge: applications.filter(a => a.status === 'pending').length },
        { id: 'onboarding', label: 'Onboarding', icon: FileCheck, badge: onboardingTracker?.in_progress || 0 },
        { id: 'idcards', label: 'ID Cards', icon: IdCard },
        { id: 'certifications', label: 'Certifications', icon: Award },
        // Active Workforce
        { id: 'divider-workforce', label: 'Active Workforce', isDivider: true },
        { id: 'workers', label: 'Worker List', icon: Users },
        { id: 'jobapprovals', label: 'Job Approvals', icon: CheckCircle, badge: pendingJobApprovals.length },
        { id: 'declinedjobs', label: 'Declined Jobs', icon: UserX },
        { id: 'callouts', label: 'Call Outs', icon: PhoneOff },
        // Performance & Development
        { id: 'divider-performance', label: 'Performance', isDivider: true },
        { id: 'education', label: 'Training', icon: GraduationCap },
        { id: 'evaluations', label: 'Evaluations', icon: FileWarning },
        // Compensation
        { id: 'divider-compensation', label: 'Compensation', isDivider: true },
        { id: 'timerecords', label: 'Time Records', icon: ClipboardCheck, badge: pendingTimeRecords.length },
        { id: 'payroll', label: 'Payroll', icon: DollarSign },
      ]
    },
    {
      id: 'finance',
      label: 'Finance',
      icon: DollarSign,
      tabs: [
        { id: 'funds', label: 'Funds', icon: DollarSign },
        { id: 'payments', label: 'Payments', icon: CreditCard },
        { id: 'receipts', label: 'Receipts', icon: Receipt },
        { id: 'tips', label: 'Tips', icon: Heart },
      ]
    },
    {
      id: 'services',
      label: 'Services & Products',
      icon: Package,
      tabs: [
        { id: 'addons', label: 'Add-Ons', icon: Package },
        { id: 'coupons', label: 'Coupons', icon: Tag },
        { id: 'courier', label: 'Courier', icon: Truck },
        { id: 'rides', label: 'Rides & Transport', icon: Car },
        { id: 'driver-payouts', label: 'Driver Payouts', icon: DollarSign },
        { id: 'packages', label: 'Packages', icon: Package },
        { id: 'services', label: 'Services', icon: Briefcase },
      ]
    },
    {
      id: 'forms',
      label: 'Forms & Documents',
      icon: FileText,
      tabs: [
        { id: 'completedforms', label: 'Completed Forms', icon: ClipboardList },
        { id: 'serviceforms', label: 'Form Submissions', icon: FileText },
        { id: 'formtemplates', label: 'Form Templates', icon: Settings },
        { id: 'policies', label: 'Policies', icon: ScrollText },
      ]
    },
    {
      id: 'communications',
      label: 'Communications',
      icon: Mail,
      tabs: [
        { id: 'commcenter', label: 'Communication Center', icon: Inbox },
        { id: 'failedemails', label: 'Failed Emails', icon: MailX },
        { id: 'reminders', label: 'Reminders', icon: Bell },
        { id: 'email', label: 'Send Email', icon: Mail },
        { id: 'smslogs', label: 'SMS Logs', icon: SmsIcon },
      ]
    },
    {
      id: 'system',
      label: 'System',
      icon: Settings,
      tabs: [
        { id: 'pricing', label: 'Pricing Settings', icon: DollarSign },
        { id: 'emailsettings', label: 'Email Settings', icon: Mail },
        { id: 'emailtemplates', label: 'Email Templates', icon: FileText },
        { id: 'autoarchive', label: 'Auto-Archive', icon: Clock },
        { id: 'archive', label: 'Archive', icon: Archive, badge: archiveSummary.total },
        { id: 'activitylogs', label: 'Activity Logs', icon: Activity },
        { id: 'testcenter', label: 'System Tests', icon: Shield },
        { id: 'auditlogs', label: 'Audit Logs', icon: FileText },
        { id: 'notes', label: 'Notes', icon: MessageSquare },
        { id: 'gallery', label: 'Photo Gallery', icon: Camera },
      ]
    },
  ];

  // Flat tabs array for mobile view (exclude dividers)
  const tabs = tabCategories.flatMap(cat => cat.tabs.filter(tab => !tab.isDivider));

  // pendingApplications for use elsewhere
  const pendingApplications = applications.filter(a => a.status === 'pending');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse-soft text-[var(--primary)]">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--background)]">
      {/* Sidebar */}
      <aside className="hidden lg:fixed lg:flex lg:flex-col lg:w-64 lg:h-screen bg-[var(--background-paper)] border-r border-[var(--border-primary)]">
        <div className="p-6 flex-shrink-0">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#F4C2C2] rounded-xl flex items-center justify-center">
              <span className="text-black font-bold text-lg">H</span>
            </div>
            <span className="text-xl font-bold text-[var(--text-primary)] font-['Cormorant_Garamond']">NC Help Hub</span>
          </Link>
        </div>
        
        <nav className="flex-1 px-4 overflow-y-auto pb-4">
          {tabCategories.map(category => {
            const isCollapsed = collapsedCategories[category.id];
            const categoryBadge = category.tabs.filter(tab => !tab.isDivider).reduce((sum, tab) => sum + (tab.badge || 0), 0);
            const hasActiveTab = category.tabs.filter(tab => !tab.isDivider).some(tab => tab.id === activeTab);
            
            return (
              <div key={category.id} className="mb-2">
                {/* Category Header */}
                <button
                  onClick={() => toggleCategory(category.id)}
                  className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-xs font-semibold uppercase tracking-wider transition-all ${
                    hasActiveTab 
                      ? 'bg-[var(--primary)]/10 text-[var(--primary)]' 
                      : 'text-[var(--text-muted)] hover:bg-[var(--background-subtle)]'
                  }`}
                >
                  <span className="flex items-center gap-2">
                    <category.icon className="w-4 h-4" />
                    {category.label}
                    {categoryBadge > 0 && (
                      <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-[var(--primary)] text-white">
                        {categoryBadge}
                      </span>
                    )}
                  </span>
                  <ChevronDown className={`w-4 h-4 transition-transform ${isCollapsed ? '-rotate-90' : ''}`} />
                </button>
                
                {/* Category Tabs */}
                {!isCollapsed && (
                  <div className="mt-1 ml-2 border-l-2 border-gray-100 pl-2">
                    {category.tabs.map(tab => (
                      tab.isDivider ? (
                        // Section Divider
                        <div key={tab.id} className="px-3 py-1.5 mt-2 first:mt-0">
                          <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
                            {tab.label}
                          </span>
                        </div>
                      ) : (
                        // Regular Tab
                        <button
                          key={tab.id}
                          onClick={() => setActiveTab(tab.id)}
                          className={`w-full flex items-center justify-between px-3 py-2 rounded-lg mb-1 transition-all text-sm ${
                            activeTab === tab.id 
                              ? 'bg-[var(--primary)] text-white' 
                              : 'text-[var(--text-secondary)] hover:bg-[var(--accent)]'
                          }`}
                          data-testid={`nav-${tab.id}`}
                        >
                          <span className="flex items-center gap-2">
                            <tab.icon className="w-4 h-4" />
                            {tab.label}
                          </span>
                          {tab.badge > 0 && (
                            <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded-full ${
                              activeTab === tab.id ? 'bg-[var(--background-paper)] text-[var(--primary)]' : 'bg-[var(--primary)] text-white'
                            }`}>
                              {tab.badge}
                            </span>
                          )}
                        </button>
                      )
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        <div className="p-4 border-t border-[var(--border-primary)] flex-shrink-0 bg-[var(--background-paper)]">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-[var(--accent)] rounded-full flex items-center justify-center">
                <Users className="w-5 h-5 text-[var(--primary)]" />
              </div>
              <div>
                <p className="font-semibold text-sm">{user?.full_name}</p>
                <p className="text-xs text-[var(--text-muted)]">Owner</p>
              </div>
            </div>
            <NotificationBell />
          </div>
          
          {/* Sound & Browser Notifications Toggle */}
          <div className="mb-3 p-2 bg-[var(--background-subtle)] rounded-lg">
            <button
              onClick={() => setShowNotificationPrefs(true)}
              className="w-full flex items-center justify-between text-sm hover:bg-[var(--background-paper)] p-1 rounded transition-colors"
            >
              <span className="flex items-center gap-2">
                <Volume2 className="w-4 h-4" />
                Notification Settings
              </span>
              <span className={`text-xs px-2 py-0.5 rounded ${notificationsEnabled() ? 'bg-green-500/20 text-green-400' : 'bg-amber-500/20 text-amber-400'}`}>
                {notificationsEnabled() ? 'ON' : 'OFF'}
              </span>
            </button>
          </div>
          
          {/* Switch Dashboard View Dropdown */}
          <div className="mb-3">
            <label className="block text-xs text-[var(--text-muted)] mb-1">Switch Dashboard View</label>
            <select
              onChange={(e) => {
                const value = e.target.value;
                if (value === 'worker') {
                  window.location.href = '/worker-preview';
                } else if (value === 'driver') {
                  window.location.href = '/driver-preview';
                } else if (value === 'customer') {
                  window.location.href = '/customer-preview';
                }
                e.target.value = '';
              }}
              className="w-full p-2 rounded-lg border border-[var(--border-primary)] bg-[var(--background-subtle)] text-[var(--text-primary)] text-sm"
              defaultValue=""
              data-testid="role-switch-dropdown"
            >
              <option value="" disabled>Select view...</option>
              <option value="worker">👷 Worker View</option>
              <option value="driver">🚗 Driver View</option>
              <option value="customer">👤 Customer View</option>
            </select>
          </div>
          
          <Button 
            variant="outline" 
            onClick={handleLogout} 
            className="w-full border-[var(--error)]/30 text-[var(--error)] hover:bg-[var(--error)]/10 hover:text-red-700"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="lg:ml-64">
        {/* Mobile Header */}
        <header className="lg:hidden nav-glass sticky top-0 z-40 px-4 py-3">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-[#D4AF37] to-[#F4C2C2] rounded-lg flex items-center justify-center">
                <span className="text-black font-bold text-sm">H</span>
              </div>
              <span className="text-lg font-bold text-[var(--text-primary)] font-['Cormorant_Garamond']">NC Help Hub</span>
            </Link>
            <div className="flex items-center gap-2">
              {/* Mobile Switch View Dropdown */}
              <select
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === 'worker') {
                    window.location.href = '/worker-preview';
                  } else if (value === 'driver') {
                    window.location.href = '/driver-preview';
                  } else if (value === 'customer') {
                    window.location.href = '/customer-preview';
                  }
                  e.target.value = '';
                }}
                className="p-2 rounded-lg border border-[var(--border-primary)] bg-[var(--background-subtle)] text-[var(--text-primary)] text-xs"
                defaultValue=""
                data-testid="mobile-role-switch"
              >
                <option value="" disabled>Switch View</option>
                <option value="worker">👷 Worker</option>
                <option value="driver">🚗 Driver</option>
                <option value="customer">👤 Customer</option>
              </select>
              <Button variant="ghost" onClick={handleLogout} size="sm">
                <LogOut className="w-5 h-5" />
              </Button>
            </div>
          </div>
          
          {/* Mobile Tabs - Hidden on mobile since BottomNavBar handles navigation */}
          <div className="hidden md:flex gap-2 mt-3 overflow-x-auto pb-2 -mx-4 px-4 scrollbar-hide">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                  activeTab === tab.id 
                    ? 'bg-[var(--primary)] text-white' 
                    : 'bg-[var(--background-subtle)] text-[var(--text-secondary)] hover:bg-[var(--background-subtle)]'
                }`}
                data-testid={`mobile-tab-${tab.id}`}
              >
                {tab.icon && <tab.icon className="w-4 h-4" />}
                {tab.label}
                {tab.badge > 0 && (
                  <span className="px-1.5 py-0.5 text-xs bg-red-500 text-white rounded-full">{tab.badge}</span>
                )}
              </button>
            ))}
          </div>
        </header>

        <div className="p-6 lg:p-8">
          {/* Job Board Tab - for mobile bottom nav */}
          {activeTab === 'jobboard' && (
            <JobBoardTab
              jobBoard={jobBoard}
              jobBoardFilter={jobBoardFilter}
              setJobBoardFilter={setJobBoardFilter}
              showWorkerPreview={showWorkerPreview}
              setShowWorkerPreview={setShowWorkerPreview}
              allWorkersHours={allWorkersHours}
              workers={workers}
              noteCounts={noteCounts}
              setNotesModal={setNotesModal}
              handlePostAllJobs={handlePostAllJobs}
              handlePostJob={handlePostJob}
              handleApproveJob={handleApproveJob}
              handleDenyJob={handleDenyJob}
              handleManualAssign={handleManualAssign}
              handleViewWorkerProfile={handleViewWorkerProfile}
              setEditingJob={setEditingJob}
              setShowJobEditModal={setShowJobEditModal}
              handleDeleteJob={handleDeleteJob}
              fetchAllData={fetchAllData}
              currentUser={user}
            />
          )}

          {/* Job Approvals Tab */}
          {activeTab === 'jobapprovals' && (
            <JobBoardTab
              jobBoard={jobBoard}
              jobBoardFilter={jobBoardFilter}
              setJobBoardFilter={setJobBoardFilter}
              showWorkerPreview={showWorkerPreview}
              setShowWorkerPreview={setShowWorkerPreview}
              allWorkersHours={allWorkersHours}
              workers={workers}
              noteCounts={noteCounts}
              setNotesModal={setNotesModal}
              handlePostAllJobs={handlePostAllJobs}
              handlePostJob={handlePostJob}
              handleApproveJob={handleApproveJob}
              handleDenyJob={handleDenyJob}
              handleManualAssign={handleManualAssign}
              handleViewWorkerProfile={handleViewWorkerProfile}
              setEditingJob={setEditingJob}
              setShowJobEditModal={setShowJobEditModal}
              handleDeleteJob={handleDeleteJob}
              fetchAllData={fetchAllData}
              currentUser={user}
            />
          )}

          {/* Declined Jobs Tab */}
          {activeTab === 'declinedjobs' && (
            <DeclinedJobsTab />
          )}

          {/* Customer Files Tab */}
          {activeTab === 'customerfiles' && (
            <CustomerFilesTab />
          )}

          {/* Customers Tab (Mobile) - Shows customer list */}
          {activeTab === 'customers' && (
            <CustomerFilesTab />
          )}

          {/* Onboarding Tab */}
          {activeTab === 'onboarding' && (
            <OnboardingTab
              onboardingTracker={onboardingTracker}
              fetchOnboardingTracker={fetchOnboardingTracker}
              setSelectedOnboardingWorker={setSelectedOnboardingWorker}
              setShowOnboardingModal={setShowOnboardingModal}
            />
          )}

          {/* Overview Tab */}
          {activeTab === 'overview' && (
            <div className="space-y-6">
              {/* Today's Schedule - Quick View */}
              <TodaySchedule onViewAll={() => setActiveTab('schedule')} />
              
              {/* Full Overview */}
              <OverviewTab
                analytics={analytics}
                bookings={bookings}
                workers={workers}
                pendingApplications={pendingApplications}
                setActiveTab={setActiveTab}
                handleApproveApplication={handleApproveApplication}
                handleRejectApplication={handleRejectApplication}
              />
            </div>
          )}

          {/* More Menu Tab - Mobile Full Page View */}
          {activeTab === 'more' && (
            <OwnerMoreMenu 
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              onLogout={handleLogout}
            />
          )}

          {/* ===== SERVICE-SPECIFIC BOOKING TABS ===== */}

          {/* Errands Bookings Tab */}
          {activeTab === 'errands-bookings' && (
            <div className="space-y-4" data-testid="errands-bookings-tab">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-pink-500/10 flex items-center justify-center">
                    <ShoppingCart className="w-5 h-5 text-pink-500" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold">Errands & Tasks</h2>
                    <p className="text-sm text-[var(--text-muted)]">
                      {bookings.filter(b => b.service_type === 'errands' || b.service_name?.toLowerCase().includes('errand')).length} total bookings
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Filtered Errands Bookings */}
              <div className="space-y-3">
                {bookings
                  .filter(b => b.service_type === 'errands' || b.service_name?.toLowerCase().includes('errand'))
                  .slice(0, 20)
                  .map(booking => (
                    <div 
                      key={booking.id} 
                      className="card p-4 cursor-pointer hover:shadow-md transition-shadow"
                      onClick={() => handleViewBookingDetails(booking.id)}
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-semibold">{booking.service_name || 'Errands & Tasks'}</p>
                          <p className="text-sm text-[var(--text-muted)]">
                            {booking.customer_name || booking.guest_name || 'Guest'} • {new Date(booking.scheduled_date).toLocaleDateString()}
                          </p>
                        </div>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          booking.status === 'completed' ? 'bg-green-100 text-green-700' :
                          booking.status === 'in_progress' ? 'bg-blue-100 text-blue-700' :
                          booking.status === 'confirmed' ? 'bg-purple-100 text-purple-700' :
                          'bg-amber-100 text-amber-700'
                        }`}>
                          {booking.status?.replace('_', ' ') || 'pending'}
                        </span>
                      </div>
                    </div>
                  ))}
                {bookings.filter(b => b.service_type === 'errands' || b.service_name?.toLowerCase().includes('errand')).length === 0 && (
                  <div className="text-center py-12 text-[var(--text-muted)]">
                    <ShoppingCart className="w-12 h-12 mx-auto mb-3 opacity-50" />
                    <p>No errands bookings yet</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Laundry Bookings Tab */}
          {activeTab === 'laundry-bookings' && (
            <div className="space-y-4" data-testid="laundry-bookings-tab">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-pink-300/20 flex items-center justify-center">
                    <Shirt className="w-5 h-5 text-pink-400" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold">Laundry Bookings</h2>
                    <p className="text-sm text-[var(--text-muted)]">
                      {bookings.filter(b => b.service_type === 'laundry' || b.service_name?.toLowerCase().includes('laundry')).length} total bookings
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Filtered Laundry Bookings */}
              <div className="space-y-3">
                {bookings
                  .filter(b => b.service_type === 'laundry' || b.service_name?.toLowerCase().includes('laundry'))
                  .slice(0, 20)
                  .map(booking => (
                    <div 
                      key={booking.id} 
                      className="card p-4 cursor-pointer hover:shadow-md transition-shadow"
                      onClick={() => handleViewBookingDetails(booking.id)}
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-semibold">{booking.service_name || 'Laundry Service'}</p>
                          <p className="text-sm text-[var(--text-muted)]">
                            {booking.customer_name || booking.guest_name || 'Guest'} • {new Date(booking.scheduled_date).toLocaleDateString()}
                          </p>
                        </div>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          booking.status === 'completed' ? 'bg-green-100 text-green-700' :
                          booking.status === 'in_progress' ? 'bg-blue-100 text-blue-700' :
                          booking.status === 'confirmed' ? 'bg-purple-100 text-purple-700' :
                          'bg-amber-100 text-amber-700'
                        }`}>
                          {booking.status?.replace('_', ' ') || 'pending'}
                        </span>
                      </div>
                    </div>
                  ))}
                {bookings.filter(b => b.service_type === 'laundry' || b.service_name?.toLowerCase().includes('laundry')).length === 0 && (
                  <div className="text-center py-12 text-[var(--text-muted)]">
                    <Shirt className="w-12 h-12 mx-auto mb-3 opacity-50" />
                    <p>No laundry bookings yet</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* My Profile Tab */}
          {activeTab === 'myprofile' && (
            <OwnerProfileTab user={user} />
          )}

          {/* Reports Tab */}
          {activeTab === 'reports' && (
            <ReportsTab />
          )}

          {/* Visitor Analytics Tab */}
          {activeTab === 'visitor-analytics' && (
            <VisitorAnalyticsTab />
          )}

          {/* ===== MY WORK TABS ===== */}
          
          {/* Quick Book Service Tab - Dynamic Service Types */}
          {activeTab === 'quickbook' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold">Book a Service</h2>
                <Link to="/book-ride" className="btn-primary flex items-center gap-2" data-testid="book-ride-link">
                  <Car className="w-4 h-4" />
                  Book a Ride
                </Link>
              </div>
              
              {/* Service Type Categories */}
              {(() => {
                // Group active services by type (exclude rides - handled by Book a Ride button)
                const activeServices = services.filter(s => s.is_active !== false && s.service_type !== 'rides');
                const serviceTypes = [...new Set(activeServices.map(s => s.service_type))].filter(Boolean);
                
                const typeInfo = {
                  rides: { name: 'Rides', icon: Car, color: '#8B5CF6', description: 'Personal transportation' },
                  courier: { name: 'Courier', icon: Truck, color: '#3B82F6', description: 'Package pickup and delivery' },
                  laundry: { name: 'Laundry', icon: Shirt, color: '#F4C2C2', description: 'Wash, dry, fold with delivery' },
                  errands: { name: 'Errands & Tasks', icon: ShoppingCart, color: '#EC4899', description: 'Grocery, prescriptions & more' }
                };
                
                return (
                  <div className="space-y-8">
                    {/* Summary Cards */}
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                      {serviceTypes.map(type => {
                        const info = typeInfo[type] || { name: type, icon: Briefcase, color: '#6B7280' };
                        const Icon = info.icon;
                        const count = activeServices.filter(s => s.service_type === type).length;
                        return (
                          <div key={type} className="card p-4 text-center" style={{ borderLeftColor: info.color, borderLeftWidth: '4px' }}>
                            <Icon className="w-6 h-6 mx-auto mb-2" style={{ color: info.color }} />
                            <p className="font-semibold text-sm">{info.name}</p>
                            <p className="text-xs text-[var(--text-muted)]">{count} services</p>
                          </div>
                        );
                      })}
                    </div>
                    
                    {/* Service Categories */}
                    {serviceTypes.map(type => {
                      const info = typeInfo[type] || { name: type, icon: Briefcase, color: '#6B7280', description: 'Services' };
                      const Icon = info.icon;
                      const typeServices = activeServices.filter(s => s.service_type === type);
                      
                      return (
                        <div key={type} className="card p-6" data-testid={`service-category-${type}`}>
                          <div className="flex items-center gap-3 mb-4">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${info.color}20` }}>
                              <Icon className="w-5 h-5" style={{ color: info.color }} />
                            </div>
                            <div>
                              <h3 className="font-bold text-lg">{info.name}</h3>
                              <p className="text-xs text-[var(--text-muted)]">{info.description}</p>
                            </div>
                          </div>
                          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
                            {typeServices.map(service => (
                              <Link
                                key={service.id}
                                to={`/customer/book/${service.id}`}
                                className="p-3 rounded-lg border border-[var(--border-primary)] hover:border-[var(--primary)] hover:bg-[var(--primary)]/5 transition-all group"
                                data-testid={`book-service-${service.id}`}
                              >
                                <h4 className="font-medium text-sm group-hover:text-[var(--primary)]">{service.name}</h4>
                                <p className="text-xs text-[var(--text-muted)] line-clamp-2 mt-1">{service.description}</p>
                                <p className="text-sm font-semibold mt-2" style={{ color: info.color }}>
                                  ${service.hourly_rate || service.base_rate || 25}/hr
                                </p>
                              </Link>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                    
                    {serviceTypes.length === 0 && (
                      <div className="card p-8 text-center">
                        <Briefcase className="w-12 h-12 mx-auto text-[var(--text-muted)] mb-4" />
                        <h3 className="text-lg font-semibold mb-2">No Active Services</h3>
                        <p className="text-[var(--text-muted)]">
                          Add services from the Services tab to enable bookings.
                        </p>
                      </div>
                    )}
                  </div>
                );
              })()}
              
              <div className="p-4 bg-[var(--accent)] rounded-xl">
                <p className="text-sm text-[var(--text-muted)]">
                  <strong>Tip:</strong> You can also create manual bookings from the Bookings tab with full control over pricing and assignment.
                </p>
              </div>
            </div>
          )}

          {/* Pick Up Jobs Tab */}
          {activeTab === 'pickupjobs' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold">Pick Up Jobs</h2>
                  <p className="text-[var(--text-muted)]">Quickly claim available jobs for yourself</p>
                </div>
              </div>
              <PickUpJobsTab />
            </div>
          )}

          {/* My Assigned Jobs Tab */}
          {activeTab === 'myjobs' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold">My Assigned Jobs</h2>
                <Button onClick={fetchOwnerAssignedJobs} variant="outline" size="sm">
                  <RefreshCw className="w-4 h-4 mr-2" /> Refresh
                </Button>
              </div>
              
              {ownerAssignedJobs.length === 0 ? (
                <div className="card p-8 text-center">
                  <Briefcase className="w-12 h-12 mx-auto text-[var(--text-muted)] mb-4" />
                  <h3 className="text-lg font-semibold mb-2">No Jobs Assigned</h3>
                  <p className="text-[var(--text-muted)]">
                    You don&apos;t have any jobs assigned to you. Assign yourself to bookings from the Bookings tab.
                  </p>
                </div>
              ) : (
                <div className="grid gap-4">
                  {ownerAssignedJobs.map(job => {
                    // Determine service type and color
                    const serviceType = job.service_type || 'other';
                    const serviceColors = {
                      rides: 'bg-purple-100 text-purple-700',
                      errands: 'bg-orange-100 text-orange-700',
                      laundry: 'bg-cyan-100 text-cyan-700',
                      courier: 'bg-green-100 text-green-700',
                      other: 'bg-gray-100 text-gray-700'
                    };
                    const serviceIcons = {
                      rides: '🚗',
                      errands: '📋',
                      laundry: '🧺',
                      courier: '📦',
                      other: '📌'
                    };
                    
                    return (
                      <div key={job.id} className="card p-6 hover:shadow-lg transition-shadow">
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-2">
                              <span className={`px-2 py-1 rounded-full text-xs font-medium ${serviceColors[serviceType] || serviceColors.other}`}>
                                {serviceIcons[serviceType] || serviceIcons.other} {serviceType.toUpperCase()}
                              </span>
                              <h3 className="font-bold text-lg">{job.service_name}</h3>
                            </div>
                            <p className="text-[var(--text-muted)]">
                              {job.scheduled_date} at {job.scheduled_time}
                            </p>
                            <p className="text-sm mt-1">{job.address}, {job.city}</p>
                            <p className="text-sm text-[var(--text-muted)]">
                              Customer: {job.customer_name || job.client_name || 'N/A'}
                            </p>
                            {job.customer_phone && (
                              <p className="text-sm text-[var(--text-muted)]">
                                📞 {job.customer_phone}
                              </p>
                            )}
                            {job.payment_method === 'cash' && (
                              <span className={`inline-flex items-center gap-1 mt-2 px-2 py-1 rounded-full text-xs font-medium ${
                                job.payment_status === 'cash_received' 
                                  ? 'bg-[var(--success)]/10 text-[var(--success)]'
                                  : 'bg-amber-100 text-amber-800'
                              }`}>
                                <DollarSign className="w-3 h-3" />
                                {job.payment_status === 'cash_received' ? 'Cash Received' : 'Cash Pending'}
                              </span>
                            )}
                          </div>
                          <div className="flex flex-col gap-2 items-end">
                            <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                              job.status === 'in_progress' ? 'bg-blue-100 text-blue-800' :
                              job.status === 'confirmed' ? 'bg-[var(--success)]/10 text-[var(--success)]' :
                              job.status === 'completed' ? 'bg-green-100 text-green-800' :
                              'bg-amber-100 text-amber-800'
                            }`}>
                              {job.status.replace('_', ' ').toUpperCase()}
                            </span>
                            <span className="text-lg font-bold text-[var(--primary)]">
                              ${job.total_amount?.toFixed(2) || job.total_price?.toFixed(2) || '0.00'}
                            </span>
                          </div>
                        </div>
                        
                        {/* Action Buttons */}
                        <div className="mt-4 pt-4 border-t border-[var(--border-primary)] flex flex-wrap gap-2">
                          {job.status === 'confirmed' && (
                            <Button 
                              size="sm" 
                              className="bg-blue-600 hover:bg-blue-700"
                              onClick={() => {
                                setOwnerWorkflowJob(job);
                                setShowOwnerWorkflowModal(true);
                              }}
                            >
                              <Clock className="w-4 h-4 mr-1" /> Start Job
                            </Button>
                          )}
                          {job.status === 'in_progress' && (
                            <>
                              <Button 
                                size="sm" 
                                className="bg-green-600 hover:bg-green-700"
                                onClick={() => {
                                  setOwnerWorkflowJob(job);
                                  setShowOwnerWorkflowModal(true);
                                }}
                              >
                                <CheckCircle className="w-4 h-4 mr-1" /> Continue / Complete
                              </Button>
                              {serviceType === 'rides' && (
                                <Button 
                                  size="sm" 
                                  variant="outline"
                                  onClick={() => {
                                    setActiveTab('rides');
                                  }}
                                >
                                  <MapPin className="w-4 h-4 mr-1" /> Track Ride
                                </Button>
                              )}
                            </>
                          )}
                          <Button 
                            size="sm" 
                            variant="outline"
                            onClick={() => handleViewBookingDetails(job.id)}
                          >
                            <Eye className="w-4 h-4 mr-1" /> View Details
                          </Button>
                          {job.customer_phone && (
                            <Button 
                              size="sm" 
                              variant="outline"
                              onClick={() => window.open(`tel:${job.customer_phone}`)}
                            >
                              <Phone className="w-4 h-4 mr-1" /> Call
                            </Button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* Clock In/Out Tab */}
          {activeTab === 'clockinout' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold">Clock In/Out</h2>
                {currentLocation ? (
                  <span className="flex items-center gap-2 text-sm text-[var(--success)]">
                    <Wifi className="w-4 h-4" /> Location Ready
                  </span>
                ) : (
                  <span className="flex items-center gap-2 text-sm text-[var(--error)]">
                    <WifiOff className="w-4 h-4" /> Location Required
                  </span>
                )}
              </div>

              {/* Current Clock Status */}
              {ownerClockStatus?.isClockedIn && (
                <div className="card p-6 border-l-4 border-blue-500">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <Clock className="w-6 h-6 text-blue-600 animate-pulse" />
                    </div>
                    <div>
                      <p className="font-bold text-lg">Currently Clocked In</p>
                      <p className="text-[var(--text-muted)]">{ownerClockStatus.booking?.service_name}</p>
                    </div>
                  </div>
                  <Button 
                    onClick={() => handleOwnerClockOut(ownerClockStatus.booking.id)}
                    disabled={clockingIn}
                    className="bg-[var(--error)] hover:bg-[var(--error)]/90 text-white"
                  >
                    {clockingIn ? 'Processing...' : 'Clock Out'}
                  </Button>
                </div>
              )}

              {/* Jobs Available for Clock In */}
              <div>
                <h3 className="font-semibold mb-4">Jobs Ready to Start</h3>
                {ownerAssignedJobs.filter(j => j.status === 'confirmed' && (j.payment_method !== 'cash' || j.payment_status === 'cash_received')).length === 0 ? (
                  <div className="card p-6 text-center text-[var(--text-muted)]">
                    <Clock className="w-10 h-10 mx-auto mb-3 opacity-50" />
                    <p>No jobs ready to clock in. Jobs must be confirmed and cash payments verified first.</p>
                  </div>
                ) : (
                  <div className="grid gap-4">
                    {ownerAssignedJobs.filter(j => j.status === 'confirmed' && (j.payment_method !== 'cash' || j.payment_status === 'cash_received')).map(job => (
                      <div key={job.id} className="card p-4 flex items-center justify-between">
                        <div>
                          <h4 className="font-semibold">{job.service_name}</h4>
                          <p className="text-sm text-[var(--text-muted)]">
                            {job.scheduled_date} at {job.scheduled_time}
                          </p>
                          <p className="text-sm">{job.address}</p>
                        </div>
                        <Button
                          onClick={() => handleOwnerClockIn(job.id)}
                          disabled={clockingIn || !currentLocation || ownerClockStatus?.isClockedIn}
                          className="bg-[var(--success)] hover:bg-[var(--success)]/90 text-white"
                        >
                          <PlayCircle className="w-4 h-4 mr-2" />
                          Clock In
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Cash Verification Tab */}
          {activeTab === 'cashverify' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold">Verify Cash Payments</h2>
                <Button onClick={fetchOwnerAssignedJobs} variant="outline" size="sm">
                  <RefreshCw className="w-4 h-4 mr-2" /> Refresh
                </Button>
              </div>

              {ownerCashPendingJobs.length === 0 ? (
                <div className="card p-8 text-center">
                  <DollarSign className="w-12 h-12 mx-auto text-[var(--text-muted)] mb-4" />
                  <h3 className="text-lg font-semibold mb-2">No Pending Cash Payments</h3>
                  <p className="text-[var(--text-muted)]">
                    All cash payments for your assigned jobs have been verified.
                  </p>
                </div>
              ) : (
                <div className="grid gap-4">
                  {ownerCashPendingJobs.map(job => (
                    <div key={job.id} className="card p-6 border-l-4 border-amber-500">
                      <div className="flex items-start justify-between">
                        <div>
                          <h3 className="font-bold text-lg">{job.service_name}</h3>
                          <p className="text-[var(--text-muted)]">
                            {job.scheduled_date} at {job.scheduled_time}
                          </p>
                          <p className="text-sm">{job.address}, {job.city}</p>
                          <p className="text-sm text-[var(--text-muted)]">
                            Customer: {job.customer_name || job.client_name || job.guest_name || 'N/A'}
                          </p>
                        </div>
                        <div className="text-right">
                          <p className="text-2xl font-bold text-[var(--primary)]">
                            ${job.total_amount?.toFixed(2) || job.total_price?.toFixed(2)}
                          </p>
                          <span className="inline-flex items-center gap-1 px-2 py-1 bg-amber-100 text-amber-800 rounded-full text-xs font-medium">
                            <DollarSign className="w-3 h-3" /> CASH PENDING
                          </span>
                        </div>
                      </div>
                      <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                        <p className="text-sm text-amber-800">
                          <strong>Important:</strong> Collect <strong>${job.total_amount?.toFixed(2) || job.total_price?.toFixed(2)}</strong> in cash BEFORE starting work.
                        </p>
                      </div>
                      <div className="flex gap-3 mt-4">
                        <Button
                          onClick={() => {
                            setCashVerifyBooking(job);
                            setShowCashVerifyModal(true);
                          }}
                          className="bg-amber-500 hover:bg-amber-600 text-white"
                        >
                          <DollarSign className="w-4 h-4 mr-2" /> Verify Cash Payment
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Cash Verification Modal */}
          {showCashVerifyModal && cashVerifyBooking && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="bg-[var(--background-paper)] rounded-2xl shadow-2xl w-full max-w-lg p-6"
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
                    <DollarSign className="w-6 h-6 text-amber-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">Verify Cash Payment</h3>
                    <p className="text-sm text-[var(--text-muted)]">Confirm payment before starting service</p>
                  </div>
                </div>

                <div className="bg-[var(--accent)] rounded-xl p-4 mb-6">
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium">{cashVerifyBooking.service_name}</span>
                    <span className="text-2xl font-bold text-[var(--primary)]">
                      ${cashVerifyBooking.total_amount?.toFixed(2) || cashVerifyBooking.total_price?.toFixed(2)}
                    </span>
                  </div>
                  <p className="text-sm text-[var(--text-muted)]">
                    {cashVerifyBooking.customer_name || cashVerifyBooking.client_name || cashVerifyBooking.guest_name}
                  </p>
                </div>

                <div className="mb-6">
                  <Label>Notes (Optional)</Label>
                  <Input
                    value={cashVerifyNotes}
                    onChange={(e) => setCashVerifyNotes(e.target.value)}
                    placeholder="Add any notes about the payment..."
                    className="input-styled mt-1"
                  />
                </div>

                <div className="flex gap-3">
                  <Button 
                    variant="outline" 
                    onClick={() => {
                      setShowCashVerifyModal(false);
                      setCashVerifyBooking(null);
                      setCashVerifyNotes('');
                    }}
                    className="flex-1"
                    disabled={processingCashVerify}
                  >
                    Cancel
                  </Button>
                  <Button 
                    onClick={() => handleOwnerCashVerify(false)}
                    disabled={processingCashVerify}
                    className="flex-1 bg-[var(--error)] hover:bg-[var(--error)]/90 text-white"
                  >
                    <X className="w-4 h-4 mr-2" />
                    Not Received
                  </Button>
                  <Button 
                    onClick={() => handleOwnerCashVerify(true)}
                    disabled={processingCashVerify}
                    className="flex-1 bg-[var(--success)] hover:bg-[var(--success)]/90 text-white"
                  >
                    <Check className="w-4 h-4 mr-2" />
                    Cash Received
                  </Button>
                </div>
              </motion.div>
            </div>
          )}

          {/* ===== END MY WORK TABS ===== */}

          {/* Education/Training Tab */}
          {activeTab === 'education' && (
            <EducationTab
              trainingStats={trainingStats}
              trainingCourses={trainingCourses}
              trainingProgress={trainingProgress}
              selectedCourseFilter={selectedCourseFilter}
              setSelectedCourseFilter={setSelectedCourseFilter}
              setEditingCourse={setEditingCourse}
              setCourseForm={setCourseForm}
              setShowCourseModal={setShowCourseModal}
              setSelectedCourse={setSelectedCourse}
              setShowCourseDetailModal={setShowCourseDetailModal}
              openEditCourseModal={openEditCourseModal}
              handleDeleteCourse={handleDeleteCourse}
            />
          )}

          {/* Certifications Tab */}
          {activeTab === 'certifications' && (
            <CertificationCoursesTab workers={workers} />
          )}

          {/* Careers Tab */}
          {activeTab === 'careers' && <CareersTab />}

          {/* Policies Tab */}
          {activeTab === 'policies' && <PoliciesTab />}

          {/* Evaluations Tab */}
          {activeTab === 'evaluations' && <EvaluationsTab />}

          {/* Call Outs Tab */}
          {activeTab === 'callouts' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h1 className="text-2xl lg:text-3xl font-bold font-['Cormorant_Garamond']">Call Outs Management</h1>
                  <p className="text-[var(--text-muted)] mt-1">Review and manage worker call out requests</p>
                </div>
              </div>
              <CallOutsManagementTab />
            </motion.div>
          )}

          {/* Customer Reviews Tab */}
          {activeTab === 'reviews' && <CustomerReviewsTab />}

          {/* Customer Feedback Tab */}
          {activeTab === 'feedback' && (
            <FeedbackTab
              reviewStats={reviewStats}
              feedbackLoading={feedbackLoading}
              pendingReviews={pendingReviews}
              approvedReviews={approvedReviews}
              handleApproveReview={handleApproveReview}
              handleRejectReview={handleRejectReview}
              handleToggleReviewFeatured={handleToggleReviewFeatured}
              handleDeleteReview={handleDeleteReview}
              fetchAllData={fetchAllData}
            />
          )}

          {/* Uploads Tab */}
          {activeTab === 'uploads' && <UploadsTab />}

          {/* Photo Gallery Tab */}
          {activeTab === 'photogallery' && <PhotoGalleryTab />}

          {/* Messages Tab */}
          {activeTab === 'messages' && <MessagesTab />}

          {/* Support Center Tab */}
          {activeTab === 'support' && (
            <SupportCenterTab 
              onStartChat={(contact) => {
                setActiveTab('messages');
                toast.info(`Opening chat with ${contact.user_name || contact.full_name}`);
              }}
              onStartCall={async (contact, callType = 'video') => {
                try {
                  const response = await api.post('/calls/initiate', {
                    recipient_id: contact.user_id || contact.id,
                    call_type: callType
                  });
                  setActiveCall({
                    callId: response.data.call_id,
                    callType: callType,
                    direction: 'outgoing',
                    otherParty: {
                      id: contact.user_id || contact.id,
                      name: contact.user_name || contact.full_name,
                      role: contact.user_role || contact.role
                    }
                  });
                  setShowCallModal(true);
                } catch (error) {
                  toast.error(error.response?.data?.detail || 'Failed to start call');
                }
              }}
            />
          )}

          {/* Applications Tab */}
          {activeTab === 'applications' && <ApplicationsTab />}

          {/* Send Email Tab */}
          {activeTab === 'email' && (
            <EmailTab
              emailRecipientType={emailRecipientType}
              setEmailRecipientType={setEmailRecipientType}
              emailSubject={emailSubject}
              setEmailSubject={setEmailSubject}
              emailMessage={emailMessage}
              setEmailMessage={setEmailMessage}
              emailRecipients={emailRecipients}
              setEmailRecipients={setEmailRecipients}
              selectedEmails={selectedEmails}
              setSelectedEmails={setSelectedEmails}
              sendingEmail={sendingEmail}
              setSendingEmail={setSendingEmail}
              emailLogs={emailLogs}
              setEmailLogs={setEmailLogs}
              bulkSelectMode={bulkSelectMode}
              setBulkSelectMode={setBulkSelectMode}
              selectedEmailIds={selectedEmailIds}
              setSelectedEmailIds={setSelectedEmailIds}
              handleBulkDeleteEmails={handleBulkDeleteEmails}
            />
          )}

          {/* Failed Emails Tab */}
          {activeTab === 'failedemails' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="flex items-center justify-between mb-8">
                <h1 className="text-2xl lg:text-3xl font-bold font-['Cormorant_Garamond']">Failed Emails</h1>
              </div>
              <FailedEmailsTab />
            </motion.div>
          )}

          {/* Communication Center Tab */}
          {activeTab === 'commcenter' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <CommunicationCenterTab />
            </motion.div>
          )}

          {/* SMS Logs Tab */}
          {activeTab === 'smslogs' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h1 className="text-2xl lg:text-3xl font-bold font-['Cormorant_Garamond']">SMS Logs</h1>
                  <p className="text-[var(--text-muted)] mt-1">Monitor SMS notifications and test Twilio integration</p>
                </div>
              </div>
              <SMSLogsTab />
            </motion.div>
          )}

          {/* Disputes Tab */}
          {activeTab === 'disputes' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <DisputesTab />
            </motion.div>
          )}

          {/* Incidents Tab */}
          {activeTab === 'incidents' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <IncidentsTab />
            </motion.div>
          )}

          {/* Customer Forms Tab */}
          {activeTab === 'customerforms' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <CustomerPoliciesSection />
            </motion.div>
          )}

          {/* Audit Logs Tab */}
          {activeTab === 'auditlogs' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <AuditLogsTab />
            </motion.div>
          )}

          {/* Activity Logs Tab */}
          {activeTab === 'activitylogs' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <ActivityLogsTab />
            </motion.div>
          )}

          {/* System Test Center Tab */}
          {activeTab === 'testcenter' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <SystemTestCenter />
            </motion.div>
          )}

          {/* Custom Requests Tab */}
          {activeTab === 'customrequests' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <CustomRequestsTab />
            </motion.div>
          )}

          {/* Contact Submissions Tab */}
          {activeTab === 'contactsubmissions' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="space-y-6">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                  <h2 className="text-xl font-bold text-[var(--text-primary)]">Contact Submissions</h2>
                  <div className="flex items-center gap-3">
                    <Select value={contactStatusFilter} onValueChange={setContactStatusFilter}>
                      <SelectTrigger className="w-[150px] bg-[var(--background-paper)] border-[var(--border-primary)]">
                        <SelectValue placeholder="Filter by status" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="all">All Status</SelectItem>
                        <SelectItem value="new">New</SelectItem>
                        <SelectItem value="in_progress">In Progress</SelectItem>
                        <SelectItem value="responded">Responded</SelectItem>
                        <SelectItem value="closed">Closed</SelectItem>
                      </SelectContent>
                    </Select>
                    <Button 
                      variant="outline" 
                      size="sm" 
                      onClick={fetchContactSubmissions}
                      className="border-[var(--primary)] text-[var(--primary)]"
                    >
                      <RefreshCw className="w-4 h-4 mr-2" />
                      Refresh
                    </Button>
                  </div>
                </div>

                {contactSubmissionsLoading ? (
                  <div className="flex items-center justify-center py-12">
                    <RefreshCw className="w-6 h-6 animate-spin text-[var(--primary)]" />
                  </div>
                ) : contactSubmissions.length === 0 ? (
                  <div className="bg-[var(--background-paper)] rounded-xl border border-[var(--border-primary)] p-12 text-center">
                    <Inbox className="w-12 h-12 mx-auto mb-4 text-[var(--text-muted)]" />
                    <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">No Contact Submissions</h3>
                    <p className="text-[var(--text-muted)]">When customers submit the contact form, they will appear here.</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {contactSubmissions.map((submission) => (
                      <div 
                        key={submission.id} 
                        className="bg-[var(--background-paper)] rounded-xl border border-[var(--border-primary)] p-5 hover:border-[var(--primary)]/50 transition-colors cursor-pointer"
                        onClick={() => { setSelectedSubmission(submission); setShowSubmissionModal(true); }}
                      >
                        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-3 mb-2">
                              <h3 className="font-semibold text-[var(--text-primary)] truncate">{submission.name}</h3>
                              <span className={`px-2 py-0.5 text-xs font-medium rounded-full border ${getContactStatusColor(submission.status)}`}>
                                {submission.status?.replace('_', ' ').toUpperCase()}
                              </span>
                            </div>
                            <p className="text-sm text-[var(--primary)] font-medium mb-1">{submission.subject}</p>
                            <p className="text-sm text-[var(--text-muted)] line-clamp-2">{submission.message}</p>
                            <div className="flex flex-wrap items-center gap-4 mt-3 text-xs text-[var(--text-muted)]">
                              <span className="flex items-center gap-1">
                                <Mail className="w-3 h-3" />
                                {submission.email}
                              </span>
                              {submission.phone && (
                                <span className="flex items-center gap-1">
                                  <SmsIcon className="w-3 h-3" />
                                  {submission.phone}
                                </span>
                              )}
                              <span className="flex items-center gap-1">
                                <Clock className="w-3 h-3" />
                                {new Date(submission.created_at).toLocaleDateString()}
                              </span>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <Button
                              size="sm"
                              variant="outline"
                              className="border-[var(--primary)] text-[var(--primary)]"
                              onClick={(e) => { e.stopPropagation(); window.location.href = `mailto:${submission.email}?subject=Re: ${submission.subject}`; }}
                            >
                              <Mail className="w-4 h-4 mr-1" />
                              Reply
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Submission Detail Modal */}
                {showSubmissionModal && selectedSubmission && (
                  <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={() => setShowSubmissionModal(false)}>
                    <div className="bg-[var(--background-paper)] rounded-2xl border border-[var(--border-primary)] max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                      <div className="p-6 border-b border-[var(--border-primary)]">
                        <div className="flex items-center justify-between">
                          <h2 className="text-xl font-bold text-[var(--text-primary)]">Contact Submission</h2>
                          <button onClick={() => setShowSubmissionModal(false)} className="p-2 hover:bg-[var(--background-subtle)] rounded-lg">
                            <X className="w-5 h-5 text-[var(--text-muted)]" />
                          </button>
                        </div>
                        <p className="text-sm text-[var(--text-muted)] mt-1">Reference: {selectedSubmission.reference_id}</p>
                      </div>
                      <div className="p-6 space-y-6">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <Label className="text-[var(--text-muted)] text-xs">Name</Label>
                            <p className="text-[var(--text-primary)] font-medium">{selectedSubmission.name}</p>
                          </div>
                          <div>
                            <Label className="text-[var(--text-muted)] text-xs">Email</Label>
                            <p className="text-[var(--primary)]">{selectedSubmission.email}</p>
                          </div>
                          <div>
                            <Label className="text-[var(--text-muted)] text-xs">Phone</Label>
                            <p className="text-[var(--text-primary)]">{selectedSubmission.phone || 'Not provided'}</p>
                          </div>
                          <div>
                            <Label className="text-[var(--text-muted)] text-xs">Preferred Contact</Label>
                            <p className="text-[var(--text-primary)] capitalize">{selectedSubmission.preferred_contact}</p>
                          </div>
                        </div>
                        
                        <div>
                          <Label className="text-[var(--text-muted)] text-xs">Subject</Label>
                          <p className="text-[var(--text-primary)] font-semibold text-lg">{selectedSubmission.subject}</p>
                        </div>
                        
                        <div>
                          <Label className="text-[var(--text-muted)] text-xs">Message</Label>
                          <div className="bg-[var(--background-subtle)] rounded-lg p-4 mt-1">
                            <p className="text-[var(--text-primary)] whitespace-pre-wrap">{selectedSubmission.message}</p>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-4 text-sm text-[var(--text-muted)]">
                          <span>Submitted: {new Date(selectedSubmission.created_at).toLocaleString()}</span>
                          {selectedSubmission.responded_at && (
                            <span>Responded: {new Date(selectedSubmission.responded_at).toLocaleString()}</span>
                          )}
                        </div>
                        
                        <div>
                          <Label className="text-[var(--text-muted)] text-xs mb-2 block">Update Status</Label>
                          <div className="flex flex-wrap gap-2">
                            {['new', 'in_progress', 'responded', 'closed'].map((status) => (
                              <Button
                                key={status}
                                size="sm"
                                variant={selectedSubmission.status === status ? 'default' : 'outline'}
                                className={selectedSubmission.status === status ? 'bg-[var(--primary)] text-black' : 'border-[var(--border-primary)]'}
                                onClick={() => handleUpdateSubmissionStatus(selectedSubmission.id, status)}
                              >
                                {status.replace('_', ' ').toUpperCase()}
                              </Button>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="p-6 border-t border-[var(--border-primary)] flex justify-end gap-3">
                        <Button variant="outline" onClick={() => setShowSubmissionModal(false)}>
                          Close
                        </Button>
                        <Button 
                          className="bg-[var(--primary)] text-black hover:bg-[var(--primary)]/90"
                          onClick={() => window.location.href = `mailto:${selectedSubmission.email}?subject=Re: ${selectedSubmission.subject}`}
                        >
                          <Mail className="w-4 h-4 mr-2" />
                          Reply via Email
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          )}

          {/* Receipts Tab */}
          {activeTab === 'receipts' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <ReceiptsTab />
            </motion.div>
          )}

          {/* Tips Tab */}
          {activeTab === 'tips' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <TipsTab />
            </motion.div>
          )}

          {/* Courier Tab */}
          {activeTab === 'courier' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <CourierTab />
            </motion.div>
          )}

          {/* Rides & Transportation Tab */}
          {activeTab === 'rides' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <RidesTab />
            </motion.div>
          )}

          {/* Driver Payouts Tab */}
          {activeTab === 'driver-payouts' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} data-testid="driver-payouts-tab">
              <DriverPayoutsTab />
            </motion.div>
          )}

          {/* Service Forms Tab */}
          {activeTab === 'serviceforms' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <ServiceFormsTab />
            </motion.div>
          )}

          {/* Form Templates Tab */}
          {activeTab === 'formtemplates' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <FormTemplatesTab />
            </motion.div>
          )}

          {/* ID Cards Tab */}
          {activeTab === 'idcards' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <IDCardsTab />
            </motion.div>
          )}

          {/* Add-Ons Tab */}
          {activeTab === 'addons' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <AddOnsTab />
            </motion.div>
          )}

          {/* Packages Tab */}
          {activeTab === 'packages' && (
            <PackagesTab />
          )}

          {/* Workers Tab */}
          {activeTab === 'workers' && (
            <WorkersTab
              workers={workers}
              bulkSelectMode={bulkSelectMode}
              setBulkSelectMode={setBulkSelectMode}
              selectedWorkerIds={selectedWorkerIds}
              setSelectedWorkerIds={setSelectedWorkerIds}
              setShowAddWorkerModal={setShowAddWorkerModal}
              handleBulkDeleteWorkers={handleBulkDeleteWorkers}
              handleOpenWorkerSchedule={handleOpenWorkerSchedule}
              handleEditWorker={handleEditWorker}
              handleSendOffer={handleSendOffer}
              handleViewWorkerFile={handleViewWorkerFile}
              handleDeleteWorker={handleDeleteWorker}
              noteCounts={noteCounts}
              setNotesModal={setNotesModal}
              refreshWorkers={fetchAllData}
            />
          )}

          {/* Master Schedule Tab */}
          {activeTab === 'schedule' && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} data-testid="master-schedule-tab-wrapper">
              <MasterScheduleTab />
            </motion.div>
          )}

          {/* Phone Booking Tab */}
          {activeTab === 'phone' && (
            <PhoneBookingTab
              workers={workers}
              onBookingCreated={(booking) => {
                toast.success(`Phone booking ${booking.reference_number} created!`);
                fetchAllData();
              }}
            />
          )}

          {/* Bookings Tab */}
          {activeTab === 'bookings' && (
            <BookingsTab
              bookings={bookings}
              bookingStatusTab={bookingStatusTab}
              setBookingStatusTab={setBookingStatusTab}
              bulkSelectMode={bulkSelectMode}
              setBulkSelectMode={setBulkSelectMode}
              selectedBookingIds={selectedBookingIds}
              setSelectedBookingIds={setSelectedBookingIds}
              setShowCreateBookingModal={setShowCreateBookingModal}
              setSelectedBooking={setSelectedBooking}
              setShowAssignModal={setShowAssignModal}
              handleBookingAction={handleBookingAction}
              handleOpenReschedule={handleOpenReschedule}
              handleViewBookingDetails={handleViewBookingDetails}
              noteCounts={noteCounts}
              setNotesModal={setNotesModal}
              fetchAllData={fetchAllData}
              handleAssignToOwner={handleAssignToOwner}
              handleBatchAssignToOwner={handleBatchAssignToOwner}
              setShowCreateRideModal={setShowCreateRideModal}
            />
          )}

          {/* Notes Summary Tab */}
          {activeTab === 'notes' && (
            <NotesSummaryTab
              onViewEntity={(entityType, entityId) => {
                if (entityType === 'booking') {
                  const booking = bookings.find(b => b.id === entityId);
                  if (booking) {
                    handleViewBookingDetails(entityId);
                  }
                }
                // Can expand to handle worker, job, application views
              }}
            />
          )}

          {/* Services Tab */}
          {activeTab === 'services' && (
            <ServicesTab
              services={services}
              servicesSelectMode={servicesSelectMode}
              setServicesSelectMode={setServicesSelectMode}
              selectedServices={selectedServices}
              setSelectedServices={setSelectedServices}
              setShowServiceModal={setShowServiceModal}
              handleEditService={handleEditService}
              handleDeleteService={handleDeleteService}
              fetchAllData={fetchAllData}
            />
          )}

          {/* Coupons Tab */}
          {activeTab === 'coupons' && (
            <CouponsTab
              coupons={coupons}
              couponsLoading={couponsLoading}
              setEditingCoupon={setEditingCoupon}
              setCouponForm={setCouponForm}
              setShowCouponModal={setShowCouponModal}
              openEditCouponModal={openEditCouponModal}
              handleDeleteCoupon={handleDeleteCoupon}
            />
          )}

          {/* Photo Gallery Tab */}
          {activeTab === 'gallery' && (
            <GalleryTab
              galleryLoading={galleryLoading}
              pendingPhotos={pendingPhotos}
              approvedPhotos={approvedPhotos}
              handleApprovePhoto={handleApprovePhoto}
              handleRejectPhoto={handleRejectPhoto}
              handleToggleFeatured={handleToggleFeatured}
              fetchGalleryPhotos={fetchGalleryPhotos}
            />
          )}

          {/* Time Records Tab */}
          {activeTab === 'timerecords' && (
            <TimeRecordsTab
              pendingTimeRecords={pendingTimeRecords}
              setShowManualTimeModal={setShowManualTimeModal}
              handleApproveTimeRecord={handleApproveTimeRecord}
              handleRejectTimeRecord={handleRejectTimeRecord}
              formatDateTime={formatDateTime}
            />
          )}

          {/* Payments Tab */}
          {activeTab === 'payments' && (
            <PaymentsTab
              paymentsData={paymentsData}
              paymentsLoading={paymentsLoading}
              paymentsFilter={paymentsFilter}
              setPaymentsFilter={setPaymentsFilter}
              handleDownloadInvoice={handleDownloadInvoice}
              handleDownloadReceipt={handleDownloadReceipt}
              handleDeletePayment={handleDeletePayment}
              handleUpdatePayment={handleUpdatePayment}
              noteCounts={noteCounts}
              setNotesModal={setNotesModal}
            />
          )}

          {/* Funds Tab */}
          {activeTab === 'funds' && (
            <FundsTab
              funds={funds}
              fundsWorkers={fundsWorkers}
              expenseCategories={expenseCategories}
              transferData={transferData}
              setTransferData={setTransferData}
              setShowTransferModal={setShowTransferModal}
              fetchFundsData={fetchFundsData}
            />
          )}

          {/* Payroll Tab */}
          {activeTab === 'payroll' && <PayrollTab />}

          {/* Reminders Tab */}
          {activeTab === 'reminders' && <ReminderSettingsTab />}

          {/* Email Settings Tab */}
          {activeTab === 'emailsettings' && <EmailSettingsTab />}

          {/* Pricing Settings Tab */}
          {activeTab === 'pricing' && <PricingSettingsTab />}

          {/* Customer Leads CRM Tab */}
          {activeTab === 'leads' && <LeadsCRMTab />}

          {/* Email Templates Tab */}
          {activeTab === 'emailtemplates' && <EmailTemplatesTab />}

          {/* Auto-Archive Settings Tab */}
          {activeTab === 'autoarchive' && <AutoArchiveSettingsTab />}

          {/* Archive Tab */}
          {activeTab === 'archive' && (
            <ArchiveTab
              archiveSummary={archiveSummary}
              archiveTab={archiveTab}
              setArchiveTab={setArchiveTab}
              archiveLoading={archiveLoading}
              fetchArchiveData={fetchArchiveData}
              fetchAllData={fetchAllData}
              completedJobs={completedJobs}
              deletedWorkers={deletedWorkers}
              deletedJobs={deletedJobs}
              cancelledBookings={cancelledBookings}
              deletedTransactions={deletedTransactions}
              deletedApplications={deletedApplications}
              archivedConversations={archivedConversations}
              archivedPaystubs={archivedPaystubs}
              archivedEmails={archivedEmails}
              deletedServices={deletedServices}
              deletedPolicies={deletedPolicies}
              deletedCoupons={deletedCoupons}
              archivedReceipts={archivedReceipts}
              archivedTips={archivedTips}
              archivedCourierJobs={archivedCourierJobs}
              archivedIDCards={archivedIDCards}
              onRestoreReceipt={handleRestoreReceipt}
              onRestoreTip={handleRestoreTip}
              onRestoreCourierJob={handleRestoreCourierJob}
              onRestoreIDCard={handleRestoreIDCard}
              onPermanentDeleteIDCard={handlePermanentDeleteIDCard}
            />
          )}

          {/* Completed Forms Tab */}
          {activeTab === 'completedforms' && (
            <CompletedFormsTab />
          )}
        </div>
      </main>

      {/* Transfer/Expense Modal */}
      {showTransferModal && (
        <div className="modal-overlay" onClick={() => setShowTransferModal(false)}>
          <div className="modal-content max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-6">Record Expense</h2>
            <div className="space-y-4">
              <div>
                <Label>Category</Label>
                <Select value={transferData.category} onValueChange={(v) => setTransferData({ ...transferData, category: v })}>
                  <SelectTrigger className="input-styled mt-1">
                    <SelectValue placeholder="Select category" />
                  </SelectTrigger>
                  <SelectContent>
                    {expenseCategories.map(cat => (
                      <SelectItem key={cat.id} value={cat.id}>{cat.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Amount ($)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={transferData.amount}
                  onChange={(e) => setTransferData({ ...transferData, amount: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="0.00"
                />
              </div>
              <div>
                <Label>Description</Label>
                <Input
                  value={transferData.description}
                  onChange={(e) => setTransferData({ ...transferData, description: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="e.g., Monthly rent payment"
                />
              </div>
              <div>
                <Label>Recipient (optional)</Label>
                <Input
                  value={transferData.recipient}
                  onChange={(e) => setTransferData({ ...transferData, recipient: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="e.g., Landlord, Supply Company"
                />
              </div>
              <div className="flex gap-3 mt-6">
                <Button type="button" onClick={() => setShowTransferModal(false)} className="btn-secondary flex-1">
                  Cancel
                </Button>
                <Button onClick={handleCreateExpense} className="btn-primary flex-1">
                  Record Expense
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Manual Time Entry Modal */}
      {showManualTimeModal && (
        <div className="modal-overlay" onClick={() => setShowManualTimeModal(false)}>
          <div className="modal-content max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-6">Manual Time Entry</h2>
            <div className="space-y-4">
              <div>
                <Label>Worker</Label>
                <Select value={manualTimeEntry.worker_id} onValueChange={(v) => setManualTimeEntry({ ...manualTimeEntry, worker_id: v })}>
                  <SelectTrigger className="input-styled mt-1" data-testid="time-entry-worker-select">
                    <SelectValue placeholder="Select worker" />
                  </SelectTrigger>
                  <SelectContent>
                    {workers.map(w => (
                      <SelectItem key={w.id} value={w.id}>{w.full_name}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Booking</Label>
                <Select value={manualTimeEntry.booking_id} onValueChange={(v) => setManualTimeEntry({ ...manualTimeEntry, booking_id: v })}>
                  <SelectTrigger className="input-styled mt-1">
                    <SelectValue placeholder="Select booking" />
                  </SelectTrigger>
                  <SelectContent>
                    {bookings.filter(b => b.status !== 'cancelled').map(b => (
                      <SelectItem key={b.id} value={b.id}>
                        {b.service_name} - {b.scheduled_date} ({b.customer_name || 'Customer'})
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Date</Label>
                <Input
                  type="date"
                  value={manualTimeEntry.date}
                  onChange={(e) => setManualTimeEntry({ ...manualTimeEntry, date: e.target.value })}
                  className="input-styled mt-1"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Clock In</Label>
                  <Input
                    type="time"
                    value={manualTimeEntry.clock_in_time}
                    onChange={(e) => setManualTimeEntry({ ...manualTimeEntry, clock_in_time: e.target.value })}
                    className="input-styled mt-1"
                  />
                </div>
                <div>
                  <Label>Clock Out</Label>
                  <Input
                    type="time"
                    value={manualTimeEntry.clock_out_time}
                    onChange={(e) => setManualTimeEntry({ ...manualTimeEntry, clock_out_time: e.target.value })}
                    className="input-styled mt-1"
                  />
                </div>
              </div>
              <div>
                <Label>Notes</Label>
                <Textarea
                  value={manualTimeEntry.notes}
                  onChange={(e) => setManualTimeEntry({ ...manualTimeEntry, notes: e.target.value })}
                  className="input-styled mt-1"
                  rows={2}
                  placeholder="Reason for manual entry..."
                />
              </div>
              <div className="flex gap-3 mt-6">
                <Button type="button" onClick={() => setShowManualTimeModal(false)} className="btn-secondary flex-1">
                  Cancel
                </Button>
                <Button onClick={handleCreateManualTimeEntry} className="btn-primary flex-1">
                  Create Entry
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Rejection Modal */}
      {showRejectModal && (
        <div className="modal-overlay" onClick={() => setShowRejectModal(false)}>
          <div className="modal-content max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-2">Reject Application</h2>
            <p className="text-sm text-[var(--text-muted)] mb-6">
              The applicant will receive an email with the rejection reason.
            </p>
            <div className="space-y-4">
              <div>
                <Label>Rejection Reason <span className="text-[var(--error)]">*</span></Label>
                <Select value={rejectionReason} onValueChange={setRejectionReason}>
                  <SelectTrigger className="input-styled mt-1" data-testid="rejection-reason-select">
                    <SelectValue placeholder="Select reason for rejection" />
                  </SelectTrigger>
                  <SelectContent>
                    {rejectionReasons.map(reason => (
                      <SelectItem key={reason.id} value={reason.id}>{reason.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="p-4 bg-[var(--warning)]/10 border border-[var(--warning)]/30 rounded-xl">
                <div className="flex items-start gap-2">
                  <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                  <div className="text-sm">
                    <p className="font-medium text-amber-800">This action cannot be undone</p>
                    <p className="text-amber-600">The applicant will be notified via email about this decision.</p>
                  </div>
                </div>
              </div>
              <div className="flex gap-3 mt-6">
                <Button type="button" onClick={() => setShowRejectModal(false)} className="btn-secondary flex-1">
                  Cancel
                </Button>
                <Button 
                  onClick={confirmRejectApplication} 
                  className="bg-red-500 hover:bg-red-600 text-white flex-1"
                  disabled={!rejectionReason}
                  data-testid="confirm-reject-btn"
                >
                  Reject Application
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Service Modal */}
      {showServiceModal && (
        <div className="modal-overlay" onClick={() => setShowServiceModal(false)}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-6">Add New Service</h2>
            <form onSubmit={handleCreateService} className="space-y-4">
              <div>
                <Label>Service Name</Label>
                <Input
                  value={newService.name}
                  onChange={(e) => setNewService({ ...newService, name: e.target.value })}
                  className="input-styled mt-1"
                  required
                  data-testid="service-name-input"
                />
              </div>
              <div>
                <Label>Description</Label>
                <Textarea
                  value={newService.description}
                  onChange={(e) => setNewService({ ...newService, description: e.target.value })}
                  className="input-styled mt-1"
                  rows={3}
                  required
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Service Type</Label>
                  <Select 
                    value={newService.service_type} 
                    onValueChange={(value) => setNewService({ ...newService, service_type: value })}
                  >
                    <SelectTrigger className="input-styled mt-1">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="rides">Rides</SelectItem>
                      <SelectItem value="courier">Courier</SelectItem>
                      <SelectItem value="laundry">Laundry</SelectItem>
                      <SelectItem value="errands">Errands & Tasks</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Package Type</Label>
                  <Select 
                    value={newService.package_type} 
                    onValueChange={(value) => setNewService({ ...newService, package_type: value })}
                  >
                    <SelectTrigger className="input-styled mt-1">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="hourly">Hourly</SelectItem>
                      <SelectItem value="recurring">Recurring</SelectItem>
                      <SelectItem value="package">Package (Fixed)</SelectItem>
                      <SelectItem value="add_on">Add-On Service</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Hourly Rate ($)</Label>
                  <Input
                    type="number"
                    min="1"
                    value={newService.hourly_rate}
                    onChange={(e) => setNewService({ ...newService, hourly_rate: Number(e.target.value) })}
                    className="input-styled mt-1"
                    required
                  />
                </div>
                <div>
                  <Label>Duration (hours)</Label>
                  <Input
                    type="number"
                    min="1"
                    value={newService.duration_hours}
                    onChange={(e) => setNewService({ ...newService, duration_hours: Number(e.target.value) })}
                    className="input-styled mt-1"
                    required
                  />
                </div>
              </div>
              <div>
                <Label>Recurring Discount (%)</Label>
                <Input
                  type="number"
                  min="0"
                  max="50"
                  value={newService.recurring_discount}
                  onChange={(e) => setNewService({ ...newService, recurring_discount: Number(e.target.value) })}
                  className="input-styled mt-1"
                />
              </div>
              <div className="flex gap-4 mt-6">
                <Button type="button" onClick={() => setShowServiceModal(false)} className="btn-secondary flex-1">
                  Cancel
                </Button>
                <Button type="submit" className="btn-primary flex-1" data-testid="save-service-btn">
                  Create Service
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Service Modal */}
      {showEditServiceModal && editingService && (
        <div className="modal-overlay" onClick={() => { setShowEditServiceModal(false); setEditingService(null); }}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
              <Edit className="w-6 h-6 text-[#D4AF37]" />
              Edit Service
            </h2>
            <form onSubmit={handleUpdateService} className="space-y-4">
              <div>
                <Label>Service Name</Label>
                <Input
                  value={editingService.name}
                  onChange={(e) => setEditingService({ ...editingService, name: e.target.value })}
                  className="input-styled mt-1"
                  required
                  data-testid="edit-service-name-input"
                />
              </div>
              <div>
                <Label>Description</Label>
                <Textarea
                  value={editingService.description}
                  onChange={(e) => setEditingService({ ...editingService, description: e.target.value })}
                  className="input-styled mt-1"
                  rows={3}
                  required
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Service Type</Label>
                  <Select 
                    value={editingService.service_type} 
                    onValueChange={(value) => setEditingService({ ...editingService, service_type: value })}
                  >
                    <SelectTrigger className="input-styled mt-1">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="rides">Rides</SelectItem>
                      <SelectItem value="courier">Courier</SelectItem>
                      <SelectItem value="laundry">Laundry</SelectItem>
                      <SelectItem value="errands">Errands & Tasks</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Package Type</Label>
                  <Select 
                    value={editingService.package_type} 
                    onValueChange={(value) => setEditingService({ ...editingService, package_type: value })}
                  >
                    <SelectTrigger className="input-styled mt-1">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="hourly">Hourly</SelectItem>
                      <SelectItem value="recurring">Recurring</SelectItem>
                      <SelectItem value="package">Package (Fixed)</SelectItem>
                      <SelectItem value="add_on">Add-On Service</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Hourly Rate ($)</Label>
                  <Input
                    type="number"
                    min="1"
                    step="0.01"
                    value={editingService.hourly_rate}
                    onChange={(e) => setEditingService({ ...editingService, hourly_rate: Number(e.target.value) })}
                    className="input-styled mt-1"
                    required
                  />
                </div>
                <div>
                  <Label>Duration (hours)</Label>
                  <Input
                    type="number"
                    min="0.25"
                    step="0.25"
                    value={editingService.duration_hours}
                    onChange={(e) => setEditingService({ ...editingService, duration_hours: Number(e.target.value) })}
                    className="input-styled mt-1"
                    required
                  />
                </div>
              </div>
              <div>
                <Label>Recurring Discount (%)</Label>
                <Input
                  type="number"
                  min="0"
                  max="50"
                  value={editingService.recurring_discount}
                  onChange={(e) => setEditingService({ ...editingService, recurring_discount: Number(e.target.value) })}
                  className="input-styled mt-1"
                />
              </div>
              <div className="flex gap-4 mt-6">
                <Button type="button" onClick={() => { setShowEditServiceModal(false); setEditingService(null); }} className="btn-secondary flex-1">
                  Cancel
                </Button>
                <Button type="submit" className="btn-primary flex-1" data-testid="update-service-btn" disabled={updatingService}>
                  {updatingService ? 'Updating...' : 'Update Service'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Coupon Modal */}
      {showCouponModal && (
        <div className="modal-overlay" onClick={() => { setShowCouponModal(false); setEditingCoupon(null); }}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
              <Tag className="w-6 h-6 text-[#F4C2C2]" />
              {editingCoupon ? 'Edit Coupon' : 'Create New Coupon'}
            </h2>
            <form onSubmit={(e) => { e.preventDefault(); editingCoupon ? handleUpdateCoupon() : handleCreateCoupon(); }} className="space-y-4">
              <div>
                <Label>Coupon Code *</Label>
                <Input
                  value={couponForm.code}
                  onChange={(e) => setCouponForm({ ...couponForm, code: e.target.value.toUpperCase() })}
                  className="input-styled mt-1 uppercase font-mono"
                  placeholder="e.g., WELCOME20, SUMMER2026"
                  required
                  data-testid="coupon-code-input"
                />
                <p className="text-xs text-[var(--text-muted)] mt-1">Code will be automatically converted to uppercase</p>
              </div>

              <div>
                <Label>Description *</Label>
                <Input
                  value={couponForm.description}
                  onChange={(e) => setCouponForm({ ...couponForm, description: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="e.g., Summer special - 20% off your first ride"
                  required
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Discount Type</Label>
                  <Select 
                    value={couponForm.discount_type} 
                    onValueChange={(value) => setCouponForm({ ...couponForm, discount_type: value })}
                  >
                    <SelectTrigger className="input-styled mt-1">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="percentage">Percentage (%)</SelectItem>
                      <SelectItem value="fixed">Fixed Amount ($)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Discount Value *</Label>
                  <div className="relative mt-1">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-muted)]">
                      {couponForm.discount_type === 'percentage' ? '%' : '$'}
                    </span>
                    <Input
                      type="number"
                      min="1"
                      max={couponForm.discount_type === 'percentage' ? 100 : 1000}
                      value={couponForm.discount_value}
                      onChange={(e) => setCouponForm({ ...couponForm, discount_value: Number(e.target.value) })}
                      className="input-styled pl-8"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Min. Order Amount ($)</Label>
                  <Input
                    type="number"
                    min="0"
                    value={couponForm.min_order_amount}
                    onChange={(e) => setCouponForm({ ...couponForm, min_order_amount: Number(e.target.value) })}
                    className="input-styled mt-1"
                  />
                </div>
                <div>
                  <Label>Max Uses (total)</Label>
                  <Input
                    type="number"
                    min="1"
                    value={couponForm.max_uses || ''}
                    onChange={(e) => setCouponForm({ ...couponForm, max_uses: e.target.value ? Number(e.target.value) : null })}
                    className="input-styled mt-1"
                    placeholder="Unlimited"
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Max Uses Per Customer</Label>
                  <Input
                    type="number"
                    min="1"
                    value={couponForm.max_uses_per_customer}
                    onChange={(e) => setCouponForm({ ...couponForm, max_uses_per_customer: Number(e.target.value) })}
                    className="input-styled mt-1"
                  />
                </div>
                <div className="flex items-end">
                  <label className="flex items-center gap-2 cursor-pointer p-3 bg-[var(--background-subtle)] rounded-lg w-full">
                    <Checkbox
                      checked={couponForm.is_active}
                      onCheckedChange={(checked) => setCouponForm({ ...couponForm, is_active: checked })}
                    />
                    <span className="text-sm font-medium">Active</span>
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Valid From</Label>
                  <Input
                    type="date"
                    value={couponForm.valid_from}
                    onChange={(e) => setCouponForm({ ...couponForm, valid_from: e.target.value })}
                    className="input-styled mt-1"
                  />
                </div>
                <div>
                  <Label>Valid Until</Label>
                  <Input
                    type="date"
                    value={couponForm.valid_until}
                    onChange={(e) => setCouponForm({ ...couponForm, valid_until: e.target.value })}
                    className="input-styled mt-1"
                  />
                </div>
              </div>

              <div className="flex gap-4 mt-6">
                <Button 
                  type="button" 
                  onClick={() => { setShowCouponModal(false); setEditingCoupon(null); }} 
                  className="btn-secondary flex-1"
                >
                  Cancel
                </Button>
                <Button 
                  type="submit" 
                  className="btn-primary flex-1" 
                  data-testid="save-coupon-btn"
                >
                  {editingCoupon ? 'Update Coupon' : 'Create Coupon'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Course Modal */}
      {showCourseModal && (
        <div className="modal-overlay" onClick={() => { setShowCourseModal(false); setEditingCourse(null); }}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
              <GraduationCap className="w-6 h-6 text-[var(--primary)]" />
              {editingCourse ? 'Edit Training Course' : 'Add Training Video'}
            </h2>
            <form onSubmit={(e) => { e.preventDefault(); editingCourse ? handleUpdateCourse() : handleCreateCourse(); }} className="space-y-4">
              <div>
                <Label>Title *</Label>
                <Input
                  value={courseForm.title}
                  onChange={(e) => setCourseForm({ ...courseForm, title: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="e.g., Introduction to Service Standards"
                  required
                />
              </div>

              <div>
                <Label>Description</Label>
                <Textarea
                  value={courseForm.description}
                  onChange={(e) => setCourseForm({ ...courseForm, description: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="Brief description of what workers will learn"
                  rows={3}
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Category *</Label>
                  <Select 
                    value={courseForm.category} 
                    onValueChange={(value) => setCourseForm({ ...courseForm, category: value })}
                  >
                    <SelectTrigger className="input-styled mt-1">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="rules">Company Rules</SelectItem>
                      <SelectItem value="rides">Rides</SelectItem>
                      <SelectItem value="courier">Courier</SelectItem>
                      <SelectItem value="laundry">Laundry</SelectItem>
                      <SelectItem value="errands">Errands</SelectItem>
                      <SelectItem value="safety">Safety</SelectItem>
                      <SelectItem value="customer_service">Customer Service</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Duration (minutes) *</Label>
                  <Input
                    type="number"
                    min="1"
                    value={courseForm.duration_minutes}
                    onChange={(e) => setCourseForm({ ...courseForm, duration_minutes: Number(e.target.value) })}
                    className="input-styled mt-1"
                    required
                  />
                </div>
              </div>

              <div>
                <Label>Video URL *</Label>
                <Input
                  value={courseForm.video_url}
                  onChange={(e) => setCourseForm({ ...courseForm, video_url: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="YouTube, Vimeo, or direct video link"
                  required
                />
                <p className="text-xs text-[var(--text-muted)] mt-1">
                  Supports YouTube, Vimeo, and direct video URLs
                </p>
              </div>

              <div>
                <Label>Thumbnail URL (optional)</Label>
                <Input
                  value={courseForm.thumbnail_url}
                  onChange={(e) => setCourseForm({ ...courseForm, thumbnail_url: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="Image URL for video thumbnail"
                />
              </div>

              <div className="flex gap-4">
                <label className="flex items-center gap-2 cursor-pointer p-3 bg-[var(--background-subtle)] rounded-lg flex-1">
                  <Checkbox
                    checked={courseForm.is_required}
                    onCheckedChange={(checked) => setCourseForm({ ...courseForm, is_required: checked })}
                  />
                  <span className="text-sm font-medium">Required for all workers</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer p-3 bg-[var(--background-subtle)] rounded-lg flex-1">
                  <Checkbox
                    checked={courseForm.is_active}
                    onCheckedChange={(checked) => setCourseForm({ ...courseForm, is_active: checked })}
                  />
                  <span className="text-sm font-medium">Active</span>
                </label>
              </div>

              <div className="flex gap-4 mt-6">
                <Button 
                  type="button" 
                  onClick={() => { setShowCourseModal(false); setEditingCourse(null); }} 
                  className="btn-secondary flex-1"
                >
                  Cancel
                </Button>
                <Button type="submit" className="btn-primary flex-1">
                  {editingCourse ? 'Update Course' : 'Create Course'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Assign Course Modal */}
      {showAssignCourseModal && assigningCourse && (
        <div className="modal-overlay" onClick={() => { setShowAssignCourseModal(false); setAssigningCourse(null); }}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-4">Assign Training Course</h2>
            <p className="text-[var(--text-secondary)] mb-6">
              Assign <strong>{assigningCourse.title}</strong> to workers
            </p>
            
            <Button 
              onClick={handleAssignCourseToAll}
              className="w-full btn-primary mb-4"
            >
              <Users className="w-4 h-4 mr-2" />
              Assign to All Workers
            </Button>
            
            <div className="relative mb-4">
              <div className="absolute inset-0 flex items-center">
                <span className="w-full border-t" />
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-[var(--background-paper)] px-2 text-[var(--text-muted)]">Or select individual workers</span>
              </div>
            </div>
            
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {workers.map(worker => {
                const alreadyAssigned = trainingProgress.some(
                  p => p.worker_id === worker.id && p.course_id === assigningCourse.id
                );
                return (
                  <button
                    key={worker.id}
                    onClick={() => !alreadyAssigned && handleAssignCourseToWorker(worker.id)}
                    disabled={alreadyAssigned}
                    className={`w-full text-left p-3 rounded-lg border transition-all ${
                      alreadyAssigned 
                        ? 'bg-[var(--background-subtle)] text-gray-400 cursor-not-allowed' 
                        : 'hover:bg-[var(--accent)] hover:border-[var(--primary)]'
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-medium">{worker.full_name}</p>
                        <p className="text-xs text-[var(--text-muted)]">
                          {worker.service_types?.map(t => t.toUpperCase()).join(', ')}
                        </p>
                      </div>
                      {alreadyAssigned && (
                        <span className="badge-success text-xs">Already Assigned</span>
                      )}
                    </div>
                  </button>
                );
              })}
            </div>
            
            <Button 
              type="button" 
              onClick={() => { setShowAssignCourseModal(false); setAssigningCourse(null); }} 
              className="btn-secondary w-full mt-4"
            >
              Close
            </Button>
          </div>
        </div>
      )}

      {/* Assign Worker Modal */}
      {showAssignModal && selectedBooking && (
        <div className="modal-overlay" onClick={() => setShowAssignModal(false)}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-4">Assign Worker</h2>
            <p className="text-[var(--text-secondary)] mb-6">
              Select a worker for: <strong>{selectedBooking.service_name}</strong> on {selectedBooking.scheduled_date}
            </p>
            
            {workers.length === 0 ? (
              <p className="text-[var(--text-muted)]">No available workers. Approve applications to add workers.</p>
            ) : (
              <div className="space-y-3 max-h-80 overflow-y-auto">
                {workers.map(worker => (
                  <button
                    key={worker.id}
                    onClick={() => handleAssignWorker(worker.id)}
                    className="w-full text-left p-4 bg-[var(--background-subtle)] rounded-xl hover:bg-[var(--accent)] transition-all"
                    data-testid={`assign-worker-${worker.id}`}
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-semibold">{worker.full_name}</p>
                        <p className="text-sm text-[var(--text-muted)]">
                          {worker.service_types.map(t => t.toUpperCase()).join(', ')} • ${worker.hourly_rate}/hr
                        </p>
                      </div>
                      <span className="text-[var(--warning)]">{worker.rating} ★</span>
                    </div>
                  </button>
                ))}
              </div>
            )}
            
            <Button 
              onClick={() => setShowAssignModal(false)} 
              className="btn-secondary w-full mt-6"
            >
              Cancel
            </Button>
          </div>
        </div>
      )}

      {/* Edit Worker Modal */}
      {showWorkerModal && selectedWorker && (
        <div className="modal-overlay" onClick={() => setShowWorkerModal(false)}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-2">Edit Worker</h2>
            <p className="text-[var(--text-secondary)] mb-6">{selectedWorker.full_name}</p>
            
            <form onSubmit={handleUpdateWorker} className="space-y-4">
              <div>
                <Label>Email (Read-only)</Label>
                <Input
                  value={selectedWorker.email}
                  disabled
                  className="input-styled mt-1 bg-[var(--background-subtle)]"
                />
              </div>
              
              <div>
                <Label>Phone Number</Label>
                <Input
                  value={workerEditData.phone}
                  onChange={(e) => setWorkerEditData({ ...workerEditData, phone: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="(555) 123-4567"
                  data-testid="edit-worker-phone"
                />
              </div>
              
              <div>
                <Label>Address</Label>
                <Input
                  value={workerEditData.address}
                  onChange={(e) => setWorkerEditData({ ...workerEditData, address: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="123 Main St, City, State"
                  data-testid="edit-worker-address"
                />
              </div>
              
              <div className="p-4 bg-[var(--accent)] rounded-xl">
                <Label className="text-lg font-semibold flex items-center gap-2">
                  <DollarSign className="w-5 h-5 text-[var(--primary)]" />
                  Pay Rate ($/hour)
                </Label>
                <p className="text-sm text-[var(--text-muted)] mb-3">Set the hourly pay rate for this worker</p>
                <Input
                  type="number"
                  min="10"
                  max="100"
                  step="0.50"
                  value={workerEditData.hourly_rate}
                  onChange={(e) => setWorkerEditData({ ...workerEditData, hourly_rate: parseFloat(e.target.value) })}
                  className="input-styled bg-[var(--background-paper)] text-2xl font-bold text-center"
                  data-testid="edit-worker-rate"
                />
                <div className="flex justify-between mt-3 text-sm text-[var(--text-muted)]">
                  <span>Min: $10/hr</span>
                  <span>Max: $100/hr</span>
                </div>
                
                {/* Offer Letter Notice */}
                {selectedWorker && (!selectedWorker.hourly_rate || selectedWorker.hourly_rate !== workerEditData.hourly_rate) && workerEditData.hourly_rate > 0 && (
                  <div className="mt-3 p-3 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg">
                    <p className="text-sm text-blue-800 flex items-start gap-2">
                      <FileText className="w-4 h-4 flex-shrink-0 mt-0.5" />
                      <span>
                        {selectedWorker.hourly_rate 
                          ? 'Changing the pay rate will send a new offer letter requiring the worker\'s signature.'
                          : 'Setting the pay rate will send an offer letter to the worker. They must sign it to enable login.'}
                      </span>
                    </p>
                  </div>
                )}
              </div>

              <div>
                <Label>Status</Label>
                <Select 
                  value={workerEditData.is_active ? 'active' : 'inactive'} 
                  onValueChange={(value) => setWorkerEditData({ ...workerEditData, is_active: value === 'active' })}
                >
                  <SelectTrigger className="input-styled mt-1" data-testid="edit-worker-status">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="active">Active - Can receive assignments</SelectItem>
                    <SelectItem value="inactive">Inactive - Paused from assignments</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="bg-[var(--background-subtle)] rounded-xl p-4 text-sm">
                <h4 className="font-semibold mb-2">Worker Stats</h4>
                <div className="grid grid-cols-2 gap-2 text-[var(--text-muted)]">
                  <span>Rating:</span>
                  <span className="text-[var(--warning)] font-semibold">{selectedWorker.rating} ★</span>
                  <span>Jobs Completed:</span>
                  <span className="font-semibold">{selectedWorker.total_jobs}</span>
                  <span>Service Types:</span>
                  <span className="font-semibold">{selectedWorker.service_types?.map(t => t.toUpperCase()).join(', ')}</span>
                </div>
              </div>

              <div className="flex gap-4 mt-6">
                <Button type="button" onClick={() => setShowWorkerModal(false)} className="btn-secondary flex-1">
                  Cancel
                </Button>
                <Button type="submit" className="btn-primary flex-1" data-testid="save-worker-btn">
                  Save Changes
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}


      {/* Add Worker Modal - Use New Component */}
      {showAddWorkerModal && (
        <AddWorkerModal
          onClose={() => setShowAddWorkerModal(false)}
          onSuccess={() => {
            setShowAddWorkerModal(false);
            fetchAllData();
          }}
        />
      )}

      {/* Create Booking Modal */}
      {showCreateBookingModal && (
        <CreateBookingModal
          onClose={() => setShowCreateBookingModal(false)}
          onSuccess={() => {
            setShowCreateBookingModal(false);
            fetchAllData();
            playSuccess();
          }}
        />
      )}

      {/* Create Ride Modal */}
      {showCreateRideModal && (
        <div className="modal-overlay" onClick={() => setShowCreateRideModal(false)}>
          <div className="modal-content max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
              <Car className="w-6 h-6 text-blue-500" />
              Create New Ride
            </h2>
            
            <form onSubmit={async (e) => {
              e.preventDefault();
              try {
                await api.post('/rides/manual', newRide);
                toast.success('Ride created successfully!');
                playSuccess();
                setShowCreateRideModal(false);
                setNewRide({
                  customer_name: '', customer_email: '', customer_phone: '',
                  pickup_address: '', pickup_city: '', pickup_state: 'NC', pickup_zip: '',
                  dropoff_address: '', dropoff_city: '', dropoff_state: 'NC', dropoff_zip: '',
                  scheduled_date: '', scheduled_time: '', notes: '', ride_type: 'standard', passengers: 1
                });
                fetchAllData();
              } catch (err) {
                toast.error(err.response?.data?.detail || 'Failed to create ride');
              }
            }} className="space-y-4">
              {/* Customer Info */}
              <div className="bg-[var(--background-subtle)] p-4 rounded-xl">
                <h3 className="font-semibold mb-3 flex items-center gap-2">
                  <User className="w-4 h-4" /> Customer Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <Label>Name *</Label>
                    <Input
                      value={newRide.customer_name}
                      onChange={(e) => setNewRide({ ...newRide, customer_name: e.target.value })}
                      placeholder="Full name"
                      required
                    />
                  </div>
                  <div>
                    <Label>Email</Label>
                    <Input
                      type="email"
                      value={newRide.customer_email}
                      onChange={(e) => setNewRide({ ...newRide, customer_email: e.target.value })}
                      placeholder="email@example.com"
                    />
                  </div>
                  <div>
                    <Label>Phone *</Label>
                    <Input
                      value={newRide.customer_phone}
                      onChange={(e) => setNewRide({ ...newRide, customer_phone: e.target.value })}
                      placeholder="(919) 555-0000"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Pickup Location */}
              <div className="bg-green-500/10 p-4 rounded-xl border border-green-500/30">
                <h3 className="font-semibold mb-3 flex items-center gap-2 text-green-600">
                  <MapPin className="w-4 h-4" /> Pickup Location
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2">
                    <Label>Address *</Label>
                    <Input
                      value={newRide.pickup_address}
                      onChange={(e) => setNewRide({ ...newRide, pickup_address: e.target.value })}
                      placeholder="123 Main St"
                      required
                    />
                  </div>
                  <div>
                    <Label>City *</Label>
                    <Input
                      value={newRide.pickup_city}
                      onChange={(e) => setNewRide({ ...newRide, pickup_city: e.target.value })}
                      placeholder="Greenville"
                      required
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <Label>State</Label>
                      <Input value={newRide.pickup_state} onChange={(e) => setNewRide({ ...newRide, pickup_state: e.target.value })} />
                    </div>
                    <div>
                      <Label>ZIP *</Label>
                      <Input
                        value={newRide.pickup_zip}
                        onChange={(e) => setNewRide({ ...newRide, pickup_zip: e.target.value })}
                        placeholder="27858"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Dropoff Location */}
              <div className="bg-red-500/10 p-4 rounded-xl border border-red-500/30">
                <h3 className="font-semibold mb-3 flex items-center gap-2 text-red-600">
                  <MapPin className="w-4 h-4" /> Dropoff Location
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2">
                    <Label>Address *</Label>
                    <Input
                      value={newRide.dropoff_address}
                      onChange={(e) => setNewRide({ ...newRide, dropoff_address: e.target.value })}
                      placeholder="456 Oak Ave"
                      required
                    />
                  </div>
                  <div>
                    <Label>City *</Label>
                    <Input
                      value={newRide.dropoff_city}
                      onChange={(e) => setNewRide({ ...newRide, dropoff_city: e.target.value })}
                      placeholder="Raleigh"
                      required
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <Label>State</Label>
                      <Input value={newRide.dropoff_state} onChange={(e) => setNewRide({ ...newRide, dropoff_state: e.target.value })} />
                    </div>
                    <div>
                      <Label>ZIP *</Label>
                      <Input
                        value={newRide.dropoff_zip}
                        onChange={(e) => setNewRide({ ...newRide, dropoff_zip: e.target.value })}
                        placeholder="27601"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Schedule & Details */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <Label>Date *</Label>
                  <Input
                    type="date"
                    value={newRide.scheduled_date}
                    onChange={(e) => setNewRide({ ...newRide, scheduled_date: e.target.value })}
                    required
                  />
                </div>
                <div>
                  <Label>Time *</Label>
                  <Input
                    type="time"
                    value={newRide.scheduled_time}
                    onChange={(e) => setNewRide({ ...newRide, scheduled_time: e.target.value })}
                    required
                  />
                </div>
                <div>
                  <Label>Passengers</Label>
                  <Input
                    type="number"
                    min="1"
                    max="8"
                    value={newRide.passengers}
                    onChange={(e) => setNewRide({ ...newRide, passengers: parseInt(e.target.value) || 1 })}
                  />
                </div>
              </div>

              <div>
                <Label>Notes</Label>
                <Textarea
                  value={newRide.notes}
                  onChange={(e) => setNewRide({ ...newRide, notes: e.target.value })}
                  placeholder="Special instructions, accessibility needs, etc."
                  rows={2}
                />
              </div>

              <div className="flex gap-3 pt-4">
                <Button type="button" variant="outline" onClick={() => setShowCreateRideModal(false)} className="flex-1">
                  Cancel
                </Button>
                <Button type="submit" className="flex-1 bg-blue-600 hover:bg-blue-700 text-white">
                  <Car className="w-4 h-4 mr-2" />
                  Create Ride
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Reschedule Modal */}
      {showRescheduleModal && selectedBooking && (
        <div className="modal-overlay" onClick={() => setShowRescheduleModal(false)}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
              <RefreshCw className="w-6 h-6 text-[var(--primary)]" />
              Reschedule Booking
            </h2>

            <div className="bg-[var(--background-subtle)] p-4 rounded-xl mb-6">
              <p className="font-semibold">{selectedBooking.service_name}</p>
              <p className="text-sm text-[var(--text-muted)]">
                Current: {selectedBooking.scheduled_date} at {selectedBooking.scheduled_time}
              </p>
              {selectedBooking.worker_name && (
                <p className="text-sm text-[var(--secondary)]">Assigned to: {selectedBooking.worker_name}</p>
              )}
            </div>

            <div className="space-y-4 mb-6">
              <div>
                <Label>New Date *</Label>
                <Input
                  type="date"
                  value={rescheduleData.new_date}
                  onChange={(e) => setRescheduleData({ ...rescheduleData, new_date: e.target.value })}
                  className="input-styled mt-1"
                  data-testid="reschedule-date"
                />
              </div>
              <div>
                <Label>New Time *</Label>
                <Input
                  type="time"
                  value={rescheduleData.new_time}
                  onChange={(e) => setRescheduleData({ ...rescheduleData, new_time: e.target.value })}
                  className="input-styled mt-1"
                  data-testid="reschedule-time"
                />
              </div>
              <div>
                <Label>Reason for Reschedule *</Label>
                <Textarea
                  value={rescheduleData.reason}
                  onChange={(e) => setRescheduleData({ ...rescheduleData, reason: e.target.value })}
                  className="input-styled mt-1"
                  placeholder="Please provide a reason for rescheduling..."
                  rows={2}
                  required
                />
              </div>
              <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg p-3 text-sm text-[#D4AF37] flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>An email notification will be sent to the customer{selectedBooking.worker_id ? ' and assigned worker' : ''} with the new schedule.</span>
              </div>
            </div>

            {/* Check Conflicts Button */}
            {selectedBooking.worker_id && (
              <Button 
                variant="outline" 
                className="w-full mb-4"
                onClick={handleCheckConflicts}
                data-testid="check-conflicts-btn"
              >
                <AlertTriangle className="w-4 h-4 mr-2" />
                Check for Conflicts
              </Button>
            )}

            {/* Conflicts Display */}
            {rescheduleConflicts.length > 0 && (
              <div className="bg-[var(--error)]/10 border border-[var(--error)]/30 rounded-xl p-4 mb-4">
                <p className="font-semibold text-[var(--error)] mb-2 flex items-center gap-2">
                  <AlertTriangle className="w-4 h-4" />
                  Conflicts Detected
                </p>
                <ul className="text-sm text-red-700 space-y-1">
                  {rescheduleConflicts.map((conflict, idx) => (
                    <li key={`conflict-${conflict.type}-${conflict.time || idx}`}>
                      {conflict.type === 'availability' 
                        ? conflict.message 
                        : `${conflict.time} - ${conflict.service_name} (${conflict.customer_name})`
                      }
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="flex gap-3">
              <Button 
                variant="outline" 
                onClick={() => setShowRescheduleModal(false)}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button 
                onClick={handleReschedule}
                className="btn-primary flex-1"
                disabled={!rescheduleData.new_date || !rescheduleData.new_time || !rescheduleData.reason}
                data-testid="confirm-reschedule-btn"
              >
                Reschedule & Notify
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* New Message Modal */}
      {showNewMessageModal && (
        <div className="modal-overlay" onClick={() => setShowNewMessageModal(false)}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <Send className="w-6 h-6 text-[#D4AF37]" />
                New Message
              </h2>
              <button 
                onClick={() => setShowNewMessageModal(false)}
                className="p-2 hover:bg-[var(--accent)] rounded-full"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Recipient Selection */}
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">Select Recipient</label>
              
              {/* Customers */}
              <div className="mb-4">
                <p className="text-xs text-[var(--text-muted)] mb-2 uppercase tracking-wide">Customers ({allUsers.customers?.length || 0})</p>
                <div className="max-h-40 overflow-y-auto border border-[var(--border-primary)] rounded-lg">
                  {allUsers.customers?.length === 0 ? (
                    <p className="p-3 text-sm text-[var(--text-muted)]">No customers found</p>
                  ) : (
                    allUsers.customers?.map(user => (
                      <button
                        key={user.id}
                        onClick={() => setSelectedRecipient({ ...user, type: 'customer' })}
                        className={`w-full p-3 text-left hover:bg-[var(--accent)] transition-colors flex items-center gap-3 border-b border-[var(--border-primary)] last:border-b-0 ${
                          selectedRecipient?.id === user.id ? 'bg-[#D4AF37]/10 border-l-4 border-l-blue-500' : ''
                        }`}
                      >
                        <div className="w-8 h-8 bg-[#D4AF37]/10 rounded-full flex items-center justify-center">
                          <Users className="w-4 h-4 text-[#D4AF37]" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-medium truncate">{user.full_name || user.email}</p>
                          <p className="text-xs text-[var(--text-muted)]">{user.email}</p>
                        </div>
                      </button>
                    ))
                  )}
                </div>
              </div>
              
              {/* Workers */}
              <div>
                <p className="text-xs text-[var(--text-muted)] mb-2 uppercase tracking-wide">Workers ({allUsers.workers?.length || 0})</p>
                <div className="max-h-40 overflow-y-auto border border-[var(--border-primary)] rounded-lg">
                  {allUsers.workers?.length === 0 ? (
                    <p className="p-3 text-sm text-[var(--text-muted)]">No workers found</p>
                  ) : (
                    allUsers.workers?.map(user => (
                      <button
                        key={user.id}
                        onClick={() => setSelectedRecipient({ ...user, type: 'worker' })}
                        className={`w-full p-3 text-left hover:bg-[var(--accent)] transition-colors flex items-center gap-3 border-b border-[var(--border-primary)] last:border-b-0 ${
                          selectedRecipient?.id === user.id ? 'bg-[var(--success)]/10 border-l-4 border-l-[var(--success)]' : ''
                        }`}
                      >
                        <div className="w-8 h-8 bg-[var(--success)]/15 rounded-full flex items-center justify-center">
                          <Briefcase className="w-4 h-4 text-[var(--success)]" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-medium truncate">{user.full_name || user.email}</p>
                          <p className="text-xs text-[var(--text-muted)]">{user.email}</p>
                        </div>
                      </button>
                    ))
                  )}
                </div>
              </div>
            </div>

            {/* Selected Recipient Display */}
            {selectedRecipient && (
              <div className={`p-3 rounded-lg mb-4 ${
                selectedRecipient.type === 'customer' ? 'bg-[#D4AF37]/10 border border-[#D4AF37]/30' : 'bg-[var(--success)]/10 border border-[var(--success)]/30'
              }`}>
                <p className="text-sm font-medium">
                  Sending to: <span className="font-bold">{selectedRecipient.full_name || selectedRecipient.email}</span>
                  <span className="text-xs ml-2 opacity-70 capitalize">({selectedRecipient.type})</span>
                </p>
              </div>
            )}

            {/* Message Input */}
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">Message</label>
              <textarea
                value={newConversationMessage}
                onChange={(e) => setNewConversationMessage(e.target.value)}
                placeholder="Type your message..."
                className="input-styled w-full h-32 resize-none"
                data-testid="new-message-input"
              />
            </div>

            {/* Actions */}
            <div className="flex gap-3">
              <Button 
                variant="outline" 
                onClick={() => { setShowNewMessageModal(false); setSelectedRecipient(null); setNewConversationMessage(''); }}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button 
                onClick={handleStartNewConversation}
                className="btn-primary flex-1"
                disabled={!selectedRecipient || !newConversationMessage.trim()}
                data-testid="send-new-message-btn"
              >
                <Send className="w-4 h-4 mr-2" />
                Send Message
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Group Chat Modal */}
      {showGroupChatModal && (
        <div className="modal-overlay" onClick={() => setShowGroupChatModal(false)}>
          <div className="modal-content max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <Users className="w-6 h-6 text-[#F4C2C2]" />
                Create Group Chat
              </h2>
              <button 
                onClick={() => setShowGroupChatModal(false)}
                className="p-2 hover:bg-[var(--accent)] rounded-full"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Group Name */}
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">Group Name</label>
              <Input
                value={groupChatName}
                onChange={(e) => setGroupChatName(e.target.value)}
                placeholder="Enter group name..."
                data-testid="group-chat-name"
              />
            </div>

            {/* Participant Selection */}
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">
                Select Participants ({groupChatParticipants.length} selected)
              </label>
              
              {/* All Users List */}
              <div className="max-h-60 overflow-y-auto border border-[var(--border-primary)] rounded-lg">
                {[...(allUsers.workers || []), ...(allUsers.customers || [])].length === 0 ? (
                  <p className="p-3 text-sm text-[var(--text-muted)]">No users found</p>
                ) : (
                  [...(allUsers.workers || []), ...(allUsers.customers || [])].map(u => (
                    <button
                      key={u.id}
                      type="button"
                      onClick={() => {
                        if (groupChatParticipants.includes(u.id)) {
                          setGroupChatParticipants(groupChatParticipants.filter(p => p !== u.id));
                        } else {
                          setGroupChatParticipants([...groupChatParticipants, u.id]);
                        }
                      }}
                      className={`w-full p-3 text-left hover:bg-[var(--accent)] transition-colors flex items-center gap-3 border-b border-[var(--border-primary)] last:border-b-0 ${
                        groupChatParticipants.includes(u.id) ? 'bg-[#F4C2C2]/10 border-l-4 border-l-purple-500' : ''
                      }`}
                    >
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                        u.role === 'worker' ? 'bg-[var(--success)]/15' : 'bg-[#D4AF37]/10'
                      }`}>
                        {u.role === 'worker' ? (
                          <Briefcase className="w-4 h-4 text-[var(--success)]" />
                        ) : (
                          <User className="w-4 h-4 text-[#D4AF37]" />
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-medium truncate">{u.full_name || u.email}</p>
                        <p className="text-xs text-[var(--text-muted)]">{u.email} • {u.role}</p>
                      </div>
                      {groupChatParticipants.includes(u.id) && (
                        <CheckCircle className="w-5 h-5 text-[#F4C2C2]" />
                      )}
                    </button>
                  ))
                )}
              </div>
            </div>

            {/* Selected Participants Display */}
            {groupChatParticipants.length > 0 && (
              <div className="p-3 rounded-lg mb-4 bg-[#F4C2C2]/10 border border-[#F4C2C2]/30">
                <p className="text-sm font-medium">
                  {groupChatParticipants.length} participant{groupChatParticipants.length !== 1 ? 's' : ''} selected
                </p>
              </div>
            )}

            {/* Actions */}
            <div className="flex gap-3">
              <Button 
                variant="outline" 
                onClick={() => { setShowGroupChatModal(false); setGroupChatName(''); setGroupChatParticipants([]); }}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button 
                onClick={handleCreateGroupChat}
                className="flex-1 bg-[#F4C2C2]/100 hover:bg-purple-600 text-white"
                disabled={!groupChatName.trim() || groupChatParticipants.length === 0}
                data-testid="create-group-submit"
              >
                <Users className="w-4 h-4 mr-2" />
                Create Group
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Pay Worker Modal */}
      {payWorkerModal.open && payWorkerModal.stub && (
        <div className="modal-overlay" onClick={() => setPayWorkerModal({ open: false, stub: null })}>
          <div className="modal-content max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <Banknote className="w-6 h-6 text-[var(--success)]" />
                Pay Worker
              </h2>
              <button 
                onClick={() => setPayWorkerModal({ open: false, stub: null })}
                className="p-2 hover:bg-[var(--accent)] rounded-full"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Pay Stub Summary */}
            <div className="bg-[var(--success)]/10 border border-[var(--success)]/30 rounded-lg p-4 mb-6">
              <p className="font-bold text-lg">{payWorkerModal.stub.worker_name}</p>
              <p className="text-sm text-[var(--text-muted)]">
                {payWorkerModal.stub.pay_period_start} to {payWorkerModal.stub.pay_period_end}
              </p>
              <div className="mt-3 flex justify-between items-center">
                <span className="text-[var(--text-muted)]">Hours: {payWorkerModal.stub.total_hours}h</span>
                <span className="text-2xl font-bold text-[var(--success)]">${payWorkerModal.stub.net_pay?.toFixed(2)}</span>
              </div>
            </div>

            {/* Payment Method Selection */}
            <div className="mb-4">
              <Label className="mb-2 block">Payment Method</Label>
              <Select value={paymentMethod} onValueChange={setPaymentMethod}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select payment method" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="direct_deposit">
                    <div className="flex items-center gap-2">
                      <CreditCard className="w-4 h-4" />
                      Direct Deposit
                    </div>
                  </SelectItem>
                  <SelectItem value="check">
                    <div className="flex items-center gap-2">
                      <FileText className="w-4 h-4" />
                      Check
                    </div>
                  </SelectItem>
                  <SelectItem value="cash">
                    <div className="flex items-center gap-2">
                      <DollarSign className="w-4 h-4" />
                      Cash
                    </div>
                  </SelectItem>
                </SelectContent>
              </Select>
            </div>

            {/* Payment Notes */}
            <div className="mb-6">
              <Label className="mb-2 block">Notes (Optional)</Label>
              <Input
                value={paymentNotes}
                onChange={(e) => setPaymentNotes(e.target.value)}
                placeholder="Check #, confirmation, etc."
                data-testid="payment-notes"
              />
            </div>

            {/* Actions */}
            <div className="flex gap-3">
              <Button 
                variant="outline" 
                onClick={() => setPayWorkerModal({ open: false, stub: null })}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button 
                onClick={handlePayWorkerWithMethod}
                className="flex-1 bg-[var(--success)] hover:bg-[var(--success)]/80 text-white"
                data-testid="confirm-payment-btn"
              >
                <Check className="w-4 h-4 mr-2" />
                Mark as Paid
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Booking Details Modal */}
      {showBookingDetailsModal && (
        <div className="modal-overlay" onClick={() => setShowBookingDetailsModal(false)}>
          <div className="modal-content max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            {loadingBookingDetails ? (
              <div className="p-12 text-center">
                <div className="animate-spin w-12 h-12 border-4 border-[var(--primary)] border-t-transparent rounded-full mx-auto mb-4"></div>
                <p className="text-[var(--text-muted)]">Loading booking details...</p>
              </div>
            ) : bookingDetails ? (
              <>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-bold flex items-center gap-2">
                    <FileText className="w-6 h-6 text-[var(--primary)]" />
                    Booking Details
                  </h2>
                  <button 
                    onClick={() => setShowBookingDetailsModal(false)}
                    className="p-2 hover:bg-[var(--accent)] rounded-full"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>

                {/* Booking Overview */}
                <div className="bg-gradient-to-r from-[var(--primary)]/10 to-[var(--secondary)]/10 p-6 rounded-xl mb-6">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div>
                      <h3 className="text-lg font-bold">{bookingDetails.booking?.service_name}</h3>
                      <p className="text-[var(--text-muted)]">
                        {bookingDetails.booking?.scheduled_date} at {bookingDetails.booking?.scheduled_time} • {bookingDetails.booking?.duration_hours}h
                      </p>
                      <span className={`inline-block mt-2 badge-${
                        bookingDetails.booking?.status === 'completed' ? 'success' : 
                        bookingDetails.booking?.status === 'confirmed' ? 'primary' :
                        bookingDetails.booking?.status === 'cancelled' ? 'error' :
                        'warning'
                      }`}>
                        {bookingDetails.booking?.status?.replace('_', ' ')}
                      </span>
                    </div>
                    <div className="text-right">
                      <p className="text-2xl font-bold text-[var(--primary)]">${Number(bookingDetails.booking?.total_amount || 0).toFixed(2)}</p>
                      <span className={`badge-${bookingDetails.booking?.payment_status === 'paid' ? 'success' : 'warning'}`}>
                        {bookingDetails.booking?.payment_status}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  {/* Customer Info */}
                  <div className="card p-4">
                    <h4 className="font-bold flex items-center gap-2 mb-3 text-[var(--primary)]">
                      <Users className="w-5 h-5" />
                      Customer Information
                    </h4>
                    <div className="space-y-2 text-sm">
                      <p><span className="text-[var(--text-muted)]">Name:</span> {bookingDetails.customer?.full_name || 'N/A'}</p>
                      <p><span className="text-[var(--text-muted)]">Email:</span> {bookingDetails.customer?.email}</p>
                      <p><span className="text-[var(--text-muted)]">Phone:</span> {bookingDetails.customer?.phone || 'N/A'}</p>
                    </div>
                  </div>

                  {/* Worker Info */}
                  <div className="card p-4">
                    <h4 className="font-bold flex items-center gap-2 mb-3 text-[var(--secondary)]">
                      <Briefcase className="w-5 h-5" />
                      Assigned Worker
                    </h4>
                    {bookingDetails.worker ? (
                      <div className="space-y-2 text-sm">
                        <p><span className="text-[var(--text-muted)]">Name:</span> {bookingDetails.worker?.full_name}</p>
                        <p><span className="text-[var(--text-muted)]">Email:</span> {bookingDetails.worker?.email}</p>
                        <p><span className="text-[var(--text-muted)]">Phone:</span> {bookingDetails.worker?.phone || 'N/A'}</p>
                        {bookingDetails.worker?.rating && (
                          <p><span className="text-[var(--text-muted)]">Rating:</span> {bookingDetails.worker?.rating.toFixed(1)} / 5</p>
                        )}
                      </div>
                    ) : (
                      <p className="text-amber-600 text-sm">No worker assigned yet</p>
                    )}
                  </div>
                </div>

                {/* Service Location */}
                <div className="card p-4 mb-6">
                  <h4 className="font-bold flex items-center gap-2 mb-3">
                    <MapPin className="w-5 h-5 text-[var(--primary)]" />
                    Service Location
                  </h4>
                  <div className="text-sm">
                    <p>{bookingDetails.booking?.address}</p>
                    <p>{bookingDetails.booking?.city}, {bookingDetails.booking?.state} {bookingDetails.booking?.zip_code}</p>
                  </div>
                </div>

                {/* Time Estimate & Override Control */}
                <div className="mb-6">
                  <TimeOverrideControl 
                    booking={bookingDetails.booking}
                    onUpdate={() => handleViewBookingDetails(bookingDetails.booking?.id)}
                  />
                </div>

                {/* Special Instructions */}
                {bookingDetails.special_instructions && (
                  <div className="card p-4 mb-6 bg-[var(--warning)]/10 border border-[var(--warning)]/30">
                    <h4 className="font-bold flex items-center gap-2 mb-2">
                      <AlertTriangle className="w-5 h-5 text-amber-600" />
                      Special Instructions
                    </h4>
                    <p className="text-sm">{bookingDetails.special_instructions}</p>
                  </div>
                )}

                {/* Agreements & Waivers */}
                <div className="card p-4 mb-6">
                  <h4 className="font-bold flex items-center gap-2 mb-3">
                    <FileCheck className="w-5 h-5 text-[var(--primary)]" />
                    Agreements
                  </h4>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <div className="flex items-center gap-2">
                      {bookingDetails.waiver_signed ? (
                        <CheckCircle className="w-4 h-4 text-[var(--success)]" />
                      ) : (
                        <X className="w-4 h-4 text-[var(--error)]" />
                      )}
                      <span>Waiver {bookingDetails.waiver_signed ? 'Signed' : 'Not Signed'}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      {bookingDetails.non_solicitation_agreed ? (
                        <CheckCircle className="w-4 h-4 text-[var(--success)]" />
                      ) : (
                        <X className="w-4 h-4 text-[var(--error)]" />
                      )}
                      <span>Non-Solicitation {bookingDetails.non_solicitation_agreed ? 'Agreed' : 'Not Agreed'}</span>
                    </div>
                  </div>
                </div>

                {/* Payment Breakdown */}
                <div className="card p-4 mb-6 border-l-4 border-[var(--success)]">
                  <h4 className="font-bold flex items-center gap-2 mb-3">
                    <DollarSign className="w-5 h-5 text-[var(--success)]" />
                    Payment Details
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-[var(--text-muted)]">Total Amount:</span>
                      <span className="font-bold">${bookingDetails.booking?.total_amount?.toFixed(2) || '0.00'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[var(--text-muted)]">Deposit (20%):</span>
                      <span className={bookingDetails.booking?.deposit_paid ? 'text-[var(--success)]' : 'text-[var(--error)]'}>
                        ${(bookingDetails.booking?.deposit_amount || bookingDetails.booking?.total_amount * 0.2)?.toFixed(2) || '0.00'}
                        {bookingDetails.booking?.deposit_paid ? ' (Paid)' : ' (Not Paid)'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[var(--text-muted)]">Remaining Balance:</span>
                      <span className={bookingDetails.booking?.payment_status === 'paid' ? 'text-[var(--success)]' : 'text-orange-500'}>
                        ${(bookingDetails.booking?.remaining_balance || (bookingDetails.booking?.total_amount - (bookingDetails.booking?.deposit_amount || 0)))?.toFixed(2) || '0.00'}
                        {bookingDetails.booking?.payment_status === 'paid' ? ' (Paid)' : ' (Due)'}
                      </span>
                    </div>
                    <div className="flex justify-between pt-2 border-t">
                      <span className="font-medium">Payment Status:</span>
                      <span className={`px-2 py-1 rounded text-xs font-medium ${
                        bookingDetails.booking?.payment_status === 'paid' ? 'bg-[var(--success)]/15 text-green-700' :
                        bookingDetails.booking?.payment_status === 'deposit_paid' ? 'bg-[#D4AF37]/10 text-[#D4AF37]' :
                        bookingDetails.booking?.payment_status === 'partial' ? 'bg-[var(--warning)]/15 text-yellow-700' :
                        'bg-[var(--error)]/15 text-red-700'
                      }`}>
                        {bookingDetails.booking?.payment_status === 'deposit_paid' ? 'Deposit Paid' :
                         bookingDetails.booking?.payment_status?.replace('_', ' ').toUpperCase() || 'PENDING'}
                      </span>
                    </div>
                    {bookingDetails.booking?.payment_method && (
                      <div className="flex justify-between text-xs text-[var(--text-muted)]">
                        <span>Payment Method:</span>
                        <span>{bookingDetails.booking?.payment_method}</span>
                      </div>
                    )}
                    {bookingDetails.booking?.stripe_payment_id && (
                      <div className="flex justify-between text-xs text-[var(--text-muted)]">
                        <span>Transaction ID:</span>
                        <span className="font-mono">{bookingDetails.booking?.stripe_payment_id?.slice(0, 20)}...</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Photos & Videos - from booking media */}
                {(() => {
                  const bookingPhotos = bookingDetails.booking?.photos || [];
                  const bookingVideos = bookingDetails.booking?.videos || [];
                  const allPhotos = bookingPhotos;
                  const allVideos = bookingVideos;
                  const hasMedia = allPhotos.length > 0 || allVideos.length > 0;
                  
                  if (!hasMedia) return null;
                  
                  return (
                    <div className="card p-4 mb-6">
                      <h4 className="font-bold flex items-center gap-2 mb-3">
                        <Camera className="w-5 h-5 text-[var(--primary)]" />
                        Photos & Videos ({allPhotos.length + allVideos.length})
                      </h4>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                        {allPhotos.map((photo, idx) => {
                          const photoUrl = typeof photo === 'string' 
                            ? (photo.startsWith('http') ? photo : `${process.env.REACT_APP_BACKEND_URL}/api/files/${photo}`)
                            : (photo.url || photo.path);
                          return (
                            <div key={`photo-${idx}`} className="relative group">
                              <img 
                                src={photoUrl}
                                alt={`Booking photo ${idx + 1}`}
                                className="w-full h-32 object-cover rounded-lg cursor-pointer hover:opacity-90 border border-[var(--border-primary)]"
                                onClick={() => window.open(photoUrl, '_blank')}
                                onError={(e) => { e.target.style.display = 'none'; }}
                              />
                              <div className="absolute bottom-1 left-1 bg-black/60 text-white text-xs px-2 py-0.5 rounded">
                                Photo {idx + 1}
                              </div>
                            </div>
                          );
                        })}
                        {allVideos.map((video, idx) => {
                          const videoUrl = typeof video === 'string' 
                            ? (video.startsWith('http') ? video : `${process.env.REACT_APP_BACKEND_URL}/api/files/${video}`)
                            : (video.url || video.path);
                          return (
                            <div key={`video-${idx}`} className="relative">
                              <video 
                                src={videoUrl}
                                className="w-full h-32 object-cover rounded-lg border border-[var(--border-primary)]"
                                controls
                              />
                              <div className="absolute bottom-1 left-1 bg-[#E6C965]/80 text-white text-xs px-2 py-0.5 rounded">
                                Video {idx + 1}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}

                {/* Comments & Notes */}
                {(bookingDetails.booking?.comments || bookingDetails.booking?.notes || 
                  bookingDetails.booking?.customer_notes || bookingDetails.booking?.worker_notes) && (
                  <div className="card p-4 mb-6">
                    <h4 className="font-bold flex items-center gap-2 mb-3">
                      <MessageSquare className="w-5 h-5 text-[var(--primary)]" />
                      Comments & Notes
                    </h4>
                    <div className="space-y-3">
                      {bookingDetails.booking?.customer_notes && (
                        <div className="bg-[#D4AF37]/10 p-3 rounded-lg">
                          <p className="text-xs text-[#D4AF37] font-medium mb-1">Customer Notes:</p>
                          <p className="text-sm">{bookingDetails.booking.customer_notes}</p>
                        </div>
                      )}
                      {bookingDetails.booking?.worker_notes && (
                        <div className="bg-[var(--success)]/10 p-3 rounded-lg">
                          <p className="text-xs text-[var(--success)] font-medium mb-1">Worker Notes:</p>
                          <p className="text-sm">{bookingDetails.booking.worker_notes}</p>
                        </div>
                      )}
                      {(bookingDetails.booking?.comments || bookingDetails.booking?.notes) && (
                        <div className="bg-[var(--background-subtle)] p-3 rounded-lg">
                          <p className="text-xs text-[var(--text-secondary)] font-medium mb-1">Additional Notes:</p>
                          <p className="text-sm">{bookingDetails.booking.comments || bookingDetails.booking.notes}</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Time Records */}
                {bookingDetails.time_records && bookingDetails.time_records.length > 0 && (
                  <div className="card p-4 mb-6">
                    <h4 className="font-bold flex items-center gap-2 mb-3">
                      <Clock className="w-5 h-5 text-[var(--primary)]" />
                      Time Records
                    </h4>
                    <div className="space-y-2">
                      {bookingDetails.time_records.map((record, idx) => (
                        <div key={record._id || record.id || `time-record-${idx}`} className="flex items-center justify-between p-3 bg-[var(--background-subtle)] rounded-lg text-sm">
                          <div>
                            <p className="font-medium">Clock In: {record.clock_in_time ? new Date(record.clock_in_time).toLocaleString() : 'N/A'}</p>
                            <p>Clock Out: {record.clock_out_time ? new Date(record.clock_out_time).toLocaleString() : 'Not yet'}</p>
                          </div>
                          <span className={`badge-${record.approval_status === 'approved' ? 'success' : 'warning'}`}>
                            {record.approval_status || 'pending'}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Review */}
                {bookingDetails.review && (
                  <div className="card p-4 mb-6 bg-[var(--accent)]">
                    <h4 className="font-bold flex items-center gap-2 mb-3">
                      <TrendingUp className="w-5 h-5 text-[var(--primary)]" />
                      Customer Review
                    </h4>
                    <div className="flex items-center gap-2 mb-2">
                      {[...Array(5)].map((_, i) => (
                        <span key={`star-${i}`} className={i < bookingDetails.review.rating ? 'text-yellow-400' : 'text-gray-300'}>★</span>
                      ))}
                      <span className="font-bold ml-2">{bookingDetails.review.rating}/5</span>
                    </div>
                    {bookingDetails.review.comment && (
                      <p className="text-sm italic">&quot;{bookingDetails.review.comment}&quot;</p>
                    )}
                  </div>
                )}

                {/* Status History */}
                {bookingDetails.status_history && bookingDetails.status_history.length > 0 && (
                  <div className="card p-4">
                    <h4 className="font-bold flex items-center gap-2 mb-3">
                      <Clock className="w-5 h-5 text-[var(--text-muted)]" />
                      Status History
                    </h4>
                    <div className="space-y-2">
                      {bookingDetails.status_history.map((entry, idx) => (
                        <div key={entry._id || entry.id || `status-${entry.status}-${idx}`} className="flex items-center gap-3 text-sm">
                          <div className="w-2 h-2 rounded-full bg-[var(--primary)]"></div>
                          <span className="font-medium">{entry.status?.replace('_', ' ')}</span>
                          <span className="text-[var(--text-muted)]">{entry.timestamp ? new Date(entry.timestamp).toLocaleString() : ''}</span>
                          {entry.reason && <span className="text-[var(--text-secondary)]">- {entry.reason}</span>}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Quick Status Actions - One-Click Advancement */}
                {bookingDetails.booking?.status !== 'completed' && bookingDetails.booking?.status !== 'cancelled' && (
                  <div className="card p-4 mt-6 bg-gradient-to-r from-[var(--primary)]/5 to-[var(--secondary)]/5 border-2 border-[var(--primary)]/20">
                    <h4 className="font-bold flex items-center gap-2 mb-4">
                      <Zap className="w-5 h-5 text-[var(--primary)]" />
                      Quick Actions - Advance Booking
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {/* Pending -> Confirmed */}
                      {bookingDetails.booking?.status === 'pending' && (
                        <>
                          <Button 
                            className="bg-[var(--success)] hover:bg-[var(--success)]/80 text-white"
                            onClick={async () => {
                              await handleBookingAction(bookingDetails.booking.id, 'confirmed');
                              setShowBookingDetailsModal(false);
                            }}
                            data-testid="quick-confirm-btn"
                          >
                            <Check className="w-4 h-4 mr-2" />
                            Confirm Booking
                          </Button>
                          <Button 
                            variant="destructive"
                            onClick={async () => {
                              if (window.confirm('Cancel this booking?')) {
                                await handleBookingAction(bookingDetails.booking.id, 'cancelled', true);
                                setShowBookingDetailsModal(false);
                              }
                            }}
                            data-testid="quick-cancel-btn"
                          >
                            <X className="w-4 h-4 mr-2" />
                            Cancel
                          </Button>
                        </>
                      )}

                      {/* Confirmed -> In Progress (if worker assigned) */}
                      {bookingDetails.booking?.status === 'confirmed' && bookingDetails.worker && (
                        <Button 
                          className="bg-[#D4AF37] hover:bg-[#E6C965] text-black"
                          onClick={async () => {
                            await handleBookingAction(bookingDetails.booking.id, 'in_progress');
                            setShowBookingDetailsModal(false);
                          }}
                          data-testid="quick-start-btn"
                        >
                          <Play className="w-4 h-4 mr-2" />
                          Mark as Started
                        </Button>
                      )}

                      {/* In Progress -> Completed */}
                      {bookingDetails.booking?.status === 'in_progress' && (
                        <Button 
                          className="bg-[var(--success)] hover:bg-[var(--success)]/80 text-white"
                          onClick={async () => {
                            await handleBookingAction(bookingDetails.booking.id, 'completed');
                            setShowBookingDetailsModal(false);
                          }}
                          data-testid="quick-complete-btn"
                        >
                          <CheckCircle className="w-4 h-4 mr-2" />
                          Mark as Completed
                        </Button>
                      )}

                      {/* Mark Payment as Paid */}
                      {bookingDetails.booking?.payment_status !== 'paid' && (
                        <Button 
                          variant="outline"
                          className="border-[var(--success)] text-[var(--success)] hover:bg-[var(--success)]/10"
                          onClick={async () => {
                            try {
                              await api.post(`/bookings/${bookingDetails.booking.id}/mark-paid`);
                              toast.success('Payment marked as paid');
                              setShowBookingDetailsModal(false);
                              fetchAllData();
                            } catch (e) {
                              toast.error(e.response?.data?.detail || 'Failed to mark as paid');
                            }
                          }}
                          data-testid="quick-paid-btn"
                        >
                          <DollarSign className="w-4 h-4 mr-2" />
                          Mark as Paid
                        </Button>
                      )}

                      {/* Assign Worker (if not assigned) */}
                      {!bookingDetails.worker && bookingDetails.booking?.status !== 'cancelled' && (
                        <Select onValueChange={async (workerId) => {
                          try {
                            await bookingsAPI.assign(bookingDetails.booking.id, workerId);
                            toast.success('Worker assigned!');
                            setShowBookingDetailsModal(false);
                            fetchAllData();
                          } catch (e) {
                            toast.error(e.response?.data?.detail || 'Failed to assign worker');
                          }
                        }}>
                          <SelectTrigger className="w-[200px] border-[var(--primary)]">
                            <SelectValue placeholder="Assign Worker..." />
                          </SelectTrigger>
                          <SelectContent>
                            {workers.filter(w => w.is_verified).map(worker => (
                              <SelectItem key={worker.id} value={worker.id}>
                                {worker.full_name}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      )}
                      
                      {/* Delete Button for cancelled/completed bookings */}
                      {['cancelled', 'completed'].includes(bookingDetails.booking?.status) && (
                        <Button 
                          variant="outline"
                          className="border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
                          onClick={() => {
                            handleDeleteBooking(bookingDetails.booking);
                            setShowBookingDetailsModal(false);
                          }}
                          data-testid="delete-booking-btn"
                        >
                          <Trash2 className="w-4 h-4 mr-2" />
                          Delete Booking
                        </Button>
                      )}
                    </div>
                    
                    <p className="text-xs text-[var(--text-muted)] mt-3">
                      Current: <span className="font-semibold">{bookingDetails.booking?.status?.replace('_', ' ')}</span>
                      {bookingDetails.booking?.payment_status && (
                        <> • Payment: <span className="font-semibold">{bookingDetails.booking?.payment_status}</span></>
                      )}
                    </p>
                  </div>
                )}

                <div className="mt-6">
                  <Button 
                    onClick={() => setShowBookingDetailsModal(false)}
                    className="btn-primary w-full"
                  >
                    Close
                  </Button>
                </div>
              </>
            ) : (
              <div className="p-12 text-center">
                <AlertCircle className="w-12 h-12 text-[var(--error)] mx-auto mb-4" />
                <p className="text-[var(--text-muted)]">Failed to load booking details</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Worker Schedule Modal */}
      {showWorkerScheduleModal && selectedWorker && (
        <div className="modal-overlay" onClick={() => setShowWorkerScheduleModal(false)}>
          <div className="modal-content max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <CalendarDays className="w-6 h-6 text-[var(--primary)]" />
                {selectedWorker.full_name}&apos;s Schedule
              </h2>
              <Button variant="ghost" size="sm" onClick={() => setShowWorkerScheduleModal(false)}>
                <X className="w-5 h-5" />
              </Button>
            </div>

            {workerSchedule ? (
              <>
                {/* Availability Section */}
                <div className="bg-[var(--background-subtle)] p-4 rounded-xl mb-6">
                  <h3 className="font-semibold mb-2">Weekly Availability</h3>
                  <div className="flex flex-wrap gap-2">
                    {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => (
                      <span 
                        key={day}
                        className={`px-3 py-1 rounded-full text-sm ${
                          workerSchedule.availability && workerSchedule.availability[day] 
                            ? 'bg-[var(--success)]/15 text-green-700' 
                            : 'bg-[var(--background-subtle)] text-gray-400'
                        }`}
                      >
                        {day.charAt(0).toUpperCase() + day.slice(1, 3)}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="card p-4 text-center">
                    <p className="text-2xl font-bold text-[var(--primary)]">{workerSchedule.total_bookings}</p>
                    <p className="text-sm text-[var(--text-muted)]">Bookings This Week</p>
                  </div>
                  <div className="card p-4 text-center">
                    <p className="text-2xl font-bold text-[var(--secondary)]">{workerSchedule.total_hours}h</p>
                    <p className="text-sm text-[var(--text-muted)]">Total Hours</p>
                  </div>
                </div>

                {/* Weekly Schedule */}
                <div className="space-y-3">
                  {workerSchedule.schedule_by_day && Object.entries(workerSchedule.schedule_by_day).map(([date, day]) => (
                    <div 
                      key={date} 
                      className={`card p-4 ${!day.is_available ? 'opacity-50' : ''}`}
                      data-testid={`worker-day-${date}`}
                    >
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-3">
                          <span className="font-bold">{day.day_name}</span>
                          <span className="text-sm text-[var(--text-muted)]">
                            {new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          {!day.is_available && (
                            <span className="badge-error text-xs">Unavailable</span>
                          )}
                          {day.bookings.length > 0 && (
                            <span className="badge-primary text-xs">{day.total_hours}h</span>
                          )}
                        </div>
                      </div>
                      
                      {day.bookings.length === 0 ? (
                        <p className="text-sm text-[var(--text-muted)]">No bookings</p>
                      ) : (
                        <div className="space-y-2">
                          {day.bookings.map(booking => (
                            <div 
                              key={booking.id}
                              className="flex items-center justify-between p-3 bg-[var(--background-subtle)] rounded-lg"
                            >
                              <div>
                                <div className="flex items-center gap-2">
                                  <span className="font-medium">{booking.scheduled_time}</span>
                                  <span className="text-sm">({booking.duration_hours}h)</span>
                                </div>
                                <p className="text-sm text-[var(--text-secondary)]">{booking.service_name}</p>
                                <p className="text-xs text-[var(--text-muted)]">{booking.address}</p>
                              </div>
                              <span className={`badge-${
                                booking.status === 'completed' ? 'success' :
                                booking.status === 'confirmed' ? 'primary' :
                                'warning'
                              }`}>
                                {booking.status}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {workerSchedule.message && (
                  <div className="bg-[var(--warning)]/10 border border-[var(--warning)]/30 p-4 rounded-xl mt-4 text-center">
                    <p className="text-amber-700">{workerSchedule.message}</p>
                  </div>
                )}
              </>
            ) : (
              <div className="p-12 text-center">
                <div className="animate-pulse-soft text-[var(--primary)]">Loading schedule...</div>
              </div>
            )}

            <div className="flex gap-3 mt-6">
              <Button 
                variant="outline" 
                onClick={() => setShowWorkerScheduleModal(false)}
                className="flex-1"
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Onboarding Details Modal */}
      {showOnboardingModal && selectedOnboardingWorker && (
        <div className="modal-overlay" onClick={() => setShowOnboardingModal(false)}>
          <div className="modal-content max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <FileCheck className="w-6 h-6 text-[var(--primary)]" />
                {selectedOnboardingWorker.worker_name} - Onboarding Details
              </h2>
              <Button variant="ghost" size="sm" onClick={() => setShowOnboardingModal(false)}>
                <X className="w-5 h-5" />
              </Button>
            </div>

            {/* Status and Progress */}
            <div className={`p-4 rounded-xl mb-6 ${
              selectedOnboardingWorker.onboarding_status === 'blocked' ? 'bg-[var(--error)]/10 border border-[var(--error)]/30' :
              selectedOnboardingWorker.onboarding_status === 'approved' ? 'bg-[var(--success)]/10 border border-[var(--success)]/30' :
              'bg-[var(--background-subtle)]'
            }`}>
              <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                <span className={`font-semibold ${
                  selectedOnboardingWorker.onboarding_status === 'blocked' ? 'text-[var(--error)]' :
                  selectedOnboardingWorker.onboarding_status === 'approved' ? 'text-[var(--success)]' :
                  'text-[var(--primary)]'
                }`}>
                  Status: {selectedOnboardingWorker.onboarding_status?.toUpperCase()}
                </span>
                <div className="flex items-center gap-3">
                  <span className={`font-medium ${
                    selectedOnboardingWorker.days_remaining <= 0 ? 'text-[var(--error)]' :
                    selectedOnboardingWorker.days_remaining <= 3 ? 'text-amber-600' :
                    'text-[var(--success)]'
                  }`}>
                    {selectedOnboardingWorker.days_remaining <= 0 ? 'OVERDUE' : `${selectedOnboardingWorker.days_remaining} days remaining`}
                  </span>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={async () => {
                      const days = window.prompt('Extend deadline by how many days? (1-30)', '7');
                      if (!days) return;
                      const daysNum = parseInt(days);
                      if (isNaN(daysNum) || daysNum < 1 || daysNum > 30) {
                        toast.error('Please enter a number between 1 and 30');
                        return;
                      }
                      const reason = window.prompt('Reason for extension (optional):');
                      try {
                        const response = await onboardingAPI.extendDeadline(selectedOnboardingWorker.worker_id, daysNum, reason);
                        toast.success(`Deadline extended! Now ${response.data.days_remaining} days remaining`);
                        setSelectedOnboardingWorker({
                          ...selectedOnboardingWorker,
                          days_remaining: response.data.days_remaining,
                          onboarding_status: response.data.new_status
                        });
                        fetchOnboardingTracker();
                      } catch (e) {
                        toast.error(e.response?.data?.detail || 'Failed to extend deadline');
                      }
                    }}
                    className="text-[#D4AF37] border-blue-300 hover:bg-[#D4AF37]/10"
                    data-testid="extend-deadline-btn"
                  >
                    <Calendar className="w-4 h-4 mr-1" />
                    Extend Deadline
                  </Button>
                </div>
              </div>
              <div className="h-3 bg-[var(--background-subtle)] rounded-full overflow-hidden">
                <div 
                  className="h-full bg-[var(--primary)] rounded-full"
                  style={{ width: `${selectedOnboardingWorker.progress_percent}%` }}
                />
              </div>
              <div className="text-sm text-center mt-2">{selectedOnboardingWorker.progress_percent}% Complete</div>
            </div>

            {/* Documents Checklist */}
            <div className="mb-6">
              <h3 className="font-semibold mb-3 flex items-center gap-2">
                <FileText className="w-5 h-5" />
                Documents ({selectedOnboardingWorker.documents_completed}/{selectedOnboardingWorker.documents_total})
              </h3>
              <div className="space-y-2">
                {selectedOnboardingWorker.documents?.map((doc) => (
                  <div 
                    key={doc.type}
                    className={`p-3 rounded-lg ${
                      doc.status === 'uploaded' || doc.status === 'approved' ? 'bg-[var(--success)]/10 border border-[var(--success)]/30' : 
                      doc.status === 'rejected' ? 'bg-[var(--error)]/10 border border-[var(--error)]/30' :
                      'bg-[var(--background-subtle)] border border-[var(--border-primary)]'
                    }`}
                  >
                    <div className="flex items-center justify-between flex-wrap gap-2">
                      <div className="flex items-center gap-3">
                        {doc.status === 'uploaded' || doc.status === 'approved' ? (
                          <CheckCircle className="w-5 h-5 text-[var(--success)]" />
                        ) : doc.status === 'rejected' ? (
                          <X className="w-5 h-5 text-[var(--error)]" />
                        ) : (
                          <Clock className="w-5 h-5 text-gray-400" />
                        )}
                        <div>
                          <span className="font-medium">{doc.name}</span>
                          {doc.uploaded_at && (
                            <p className="text-xs text-[var(--success)]">
                              {doc.uploaded_by === 'owner' ? 'Uploaded by Owner' : 'Uploaded'} {new Date(doc.uploaded_at).toLocaleDateString()}
                            </p>
                          )}
                          {doc.expiration_date && (
                            <p className="text-xs text-[var(--text-muted)]">Expires: {new Date(doc.expiration_date).toLocaleDateString()}</p>
                          )}
                          {doc.notes && <p className="text-xs text-[var(--text-muted)]">{doc.notes}</p>}
                        </div>
                      </div>
                      
                      <div className="flex gap-2">
                        {/* View Button - if file exists */}
                        {doc.file_url && (
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => {
                              // If file_url is a relative path, prepend the backend URL
                              let url = doc.file_url;
                              if (url.startsWith('/api/')) {
                                url = process.env.REACT_APP_BACKEND_URL + url;
                              } else if (!url.startsWith('http')) {
                                // Legacy local paths - try via the API endpoint
                                onboardingAPI.getDocument(selectedOnboardingWorker.worker_id, doc.type)
                                  .then(res => window.open(process.env.REACT_APP_BACKEND_URL + res.data.file_url, '_blank'))
                                  .catch(() => toast.error('Failed to open document'));
                                return;
                              }
                              window.open(url, '_blank');
                            }}
                          >
                            <Eye className="w-4 h-4 mr-1" />
                            View
                          </Button>
                        )}
                        
                        {/* Upload Button - for owner to upload on behalf of worker */}
                        <Button
                          size="sm"
                          variant={doc.status === 'uploaded' ? 'outline' : 'default'}
                          className={doc.status !== 'uploaded' && doc.status !== 'approved' ? 'bg-[var(--primary)] text-white' : ''}
                          onClick={() => {
                            setUploadingDocType(doc);
                            setShowDocUploadModal(true);
                          }}
                        >
                          <Upload className="w-4 h-4 mr-1" />
                          {doc.status === 'uploaded' || doc.status === 'approved' ? 'Replace' : 'Upload'}
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Waivers Checklist */}
            <div className="mb-6">
              <h3 className="font-semibold mb-3 flex items-center gap-2">
                <FileCheck className="w-5 h-5" />
                Waivers & Agreements ({selectedOnboardingWorker.waivers_completed}/{selectedOnboardingWorker.waivers_total})
              </h3>
              <div className="space-y-2">
                {selectedOnboardingWorker.waivers?.map((waiver) => (
                  <div 
                    key={waiver.type}
                    className={`p-3 rounded-lg flex items-center justify-between ${
                      waiver.status === 'signed' ? 'bg-[var(--success)]/10 border border-[var(--success)]/30' : 'bg-[var(--background-subtle)] border border-[var(--border-primary)]'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {waiver.status === 'signed' ? (
                        <CheckCircle className="w-5 h-5 text-[var(--success)]" />
                      ) : (
                        <Clock className="w-5 h-5 text-gray-400" />
                      )}
                      <div>
                        <span className="font-medium">{waiver.name}</span>
                        {waiver.signed_at && (
                          <p className="text-xs text-[var(--success)]">Signed {new Date(waiver.signed_at).toLocaleDateString()}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex gap-3 flex-wrap">
              <Button 
                variant="outline"
                onClick={async () => {
                  try {
                    await onboardingAPI.sendReminder(selectedOnboardingWorker.worker_id);
                    toast.success('Reminder sent');
                  } catch (e) {
                    toast.error('Failed to send reminder');
                  }
                }}
              >
                <Mail className="w-4 h-4 mr-2" />
                Send Reminder
              </Button>
              
              {selectedOnboardingWorker.progress_percent === 100 && selectedOnboardingWorker.onboarding_status !== 'approved' && (
                <Button 
                  className="bg-green-500 hover:bg-[var(--success)] text-white"
                  onClick={async () => {
                    try {
                      await onboardingAPI.approveWorker(selectedOnboardingWorker.worker_id, { can_work: true });
                      toast.success('Worker approved to work!');
                      setShowOnboardingModal(false);
                      fetchOnboardingTracker();
                    } catch (e) {
                      toast.error('Failed to approve');
                    }
                  }}
                >
                  <Check className="w-4 h-4 mr-2" />
                  Approve to Work
                </Button>
              )}
              
              {selectedOnboardingWorker.can_work ? (
                <Button 
                  variant="destructive"
                  onClick={async () => {
                    const notes = prompt('Reason for blocking (optional):');
                    try {
                      await onboardingAPI.approveWorker(selectedOnboardingWorker.worker_id, { can_work: false, notes });
                      toast.success('Worker blocked');
                      setShowOnboardingModal(false);
                      fetchOnboardingTracker();
                    } catch (e) {
                      toast.error('Failed to block');
                    }
                  }}
                >
                  <X className="w-4 h-4 mr-2" />
                  Block Worker
                </Button>
              ) : selectedOnboardingWorker.onboarding_status === 'blocked' && (
                <Button 
                  className="bg-green-500 hover:bg-[var(--success)] text-white"
                  onClick={async () => {
                    try {
                      await onboardingAPI.approveWorker(selectedOnboardingWorker.worker_id, { can_work: true });
                      toast.success('Worker unblocked');
                      setShowOnboardingModal(false);
                      fetchOnboardingTracker();
                    } catch (e) {
                      toast.error('Failed to unblock');
                    }
                  }}
                >
                  <Check className="w-4 h-4 mr-2" />
                  Unblock Worker
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Document Upload Modal */}
      {showDocUploadModal && uploadingDocType && selectedOnboardingWorker && (
        <div className="modal-overlay" onClick={() => setShowDocUploadModal(false)}>
          <div className="modal-content max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-bold">Upload {uploadingDocType.name}</h2>
              <Button variant="ghost" size="sm" onClick={() => setShowDocUploadModal(false)}>
                <X className="w-5 h-5" />
              </Button>
            </div>
            
            <p className="text-sm text-[var(--text-muted)] mb-4">
              Upload document on behalf of {selectedOnboardingWorker.worker_name}
            </p>
            
            <form onSubmit={async (e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              formData.append('document_type', uploadingDocType.type);
              
              try {
                await onboardingAPI.ownerUploadDocument(selectedOnboardingWorker.worker_id, formData);
                toast.success('Document uploaded successfully');
                setShowDocUploadModal(false);
                // Refresh onboarding data
                const response = await onboardingAPI.getWorkerDetails(selectedOnboardingWorker.worker_id);
                setSelectedOnboardingWorker(response.data);
                fetchOnboardingTracker();
              } catch (error) {
                toast.error(error.response?.data?.detail || 'Failed to upload document');
              }
            }}>
              <div className="space-y-4">
                <div>
                  <Label>Document File *</Label>
                  <Input type="file" name="file" required accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" className="mt-1" />
                </div>
                
                <div>
                  <Label>Expiration Date (if applicable)</Label>
                  <Input type="date" name="expiration_date" className="mt-1" />
                </div>
                
                <div>
                  <Label>Notes</Label>
                  <Input type="text" name="notes" placeholder="Optional notes..." className="mt-1" />
                </div>
                
                <div className="flex gap-3 mt-6">
                  <Button type="button" variant="outline" onClick={() => setShowDocUploadModal(false)} className="flex-1">
                    Cancel
                  </Button>
                  <Button type="submit" className="flex-1 bg-[var(--primary)] text-white">
                    <Upload className="w-4 h-4 mr-2" />
                    Upload
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Worker Profile Summary Modal */}
      {showWorkerProfileModal && selectedWorkerProfile && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-[var(--background-paper)] rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-xl font-bold">{selectedWorkerProfile.profile.full_name}</h2>
                  <p className="text-sm text-[var(--text-muted)]">{selectedWorkerProfile.profile.email}</p>
                </div>
                <Button variant="ghost" size="sm" onClick={() => setShowWorkerProfileModal(false)}>
                  <X className="w-5 h-5" />
                </Button>
              </div>
            </div>
            
            <div className="p-6 space-y-6">
              {/* Contact Info */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-[var(--text-muted)]">Phone</p>
                  <p className="font-semibold">{selectedWorkerProfile.profile.phone || 'N/A'}</p>
                </div>
                <div>
                  <p className="text-sm text-[var(--text-muted)]">Hourly Rate</p>
                  <p className="font-semibold">${selectedWorkerProfile.profile.hourly_rate || 'Not set'}/hr</p>
                </div>
                <div>
                  <p className="text-sm text-[var(--text-muted)]">Service Types</p>
                  <p className="font-semibold">{selectedWorkerProfile.profile.service_types?.join(', ') || 'N/A'}</p>
                </div>
                <div>
                  <p className="text-sm text-[var(--text-muted)]">Location</p>
                  <p className="font-semibold">{selectedWorkerProfile.profile.city}, {selectedWorkerProfile.profile.state}</p>
                </div>
              </div>

              {/* Weekly Hours */}
              <div className="card p-4 bg-[var(--background-subtle)]">
                <h3 className="font-semibold mb-3">This Week&apos;s Hours</h3>
                <div className="grid grid-cols-4 gap-2 text-center">
                  <div>
                    <p className="text-2xl font-bold text-[var(--primary)]">{selectedWorkerProfile.weekly_hours.confirmed_hours.toFixed(1)}</p>
                    <p className="text-xs text-[var(--text-muted)]">Confirmed</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-yellow-500">{selectedWorkerProfile.weekly_hours.pending_hours.toFixed(1)}</p>
                    <p className="text-xs text-[var(--text-muted)]">Pending</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-[var(--success)]">{selectedWorkerProfile.weekly_hours.remaining_hours.toFixed(1)}</p>
                    <p className="text-xs text-[var(--text-muted)]">Remaining</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold">{selectedWorkerProfile.weekly_hours.weekly_cap}</p>
                    <p className="text-xs text-[var(--text-muted)]">Cap</p>
                  </div>
                </div>
              </div>

              {/* Onboarding Status */}
              <div>
                <h3 className="font-semibold mb-3">Onboarding Status</h3>
                <div className="flex items-center gap-4">
                  <span className={`badge-${selectedWorkerProfile.onboarding.status === 'approved' ? 'success' : 
                    selectedWorkerProfile.onboarding.status === 'blocked' ? 'danger' : 'warning'}`}>
                    {selectedWorkerProfile.onboarding.status}
                  </span>
                  <span className="text-sm">
                    Docs: {selectedWorkerProfile.onboarding.documents_completed}/{selectedWorkerProfile.onboarding.documents_total}
                  </span>
                  <span className="text-sm">
                    Waivers: {selectedWorkerProfile.onboarding.waivers_completed}/{selectedWorkerProfile.onboarding.waivers_total}
                  </span>
                  {selectedWorkerProfile.onboarding.can_work ? (
                    <span className="badge-success">Can Work</span>
                  ) : (
                    <span className="badge-danger">Cannot Work Yet</span>
                  )}
                </div>
              </div>

              {/* Stats */}
              <div>
                <h3 className="font-semibold mb-3">Performance</h3>
                <p className="text-sm">Total Jobs Completed: <strong>{selectedWorkerProfile.stats.total_jobs_completed}</strong></p>
              </div>

              {/* Recent Jobs */}
              {selectedWorkerProfile.stats.recent_jobs?.length > 0 && (
                <div>
                  <h3 className="font-semibold mb-3">Recent Jobs</h3>
                  <div className="space-y-2">
                    {selectedWorkerProfile.stats.recent_jobs.slice(0, 5).map(job => (
                      <div key={job.id} className="flex justify-between items-center p-2 bg-[var(--background-subtle)] rounded">
                        <span className="text-sm">{job.service_name || job.service_type}</span>
                        <span className="text-sm text-[var(--text-muted)]">{job.scheduled_date}</span>
                        <span className={`badge-${job.status === 'completed' ? 'success' : 'primary'} text-xs`}>
                          {job.status}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Job Edit Modal */}
      {showJobEditModal && editingJob && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-[var(--background-paper)] rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-xl font-bold">Edit Job</h2>
                  <p className="text-sm text-[var(--text-muted)]">ID: {editingJob.id?.slice(0, 8)}...</p>
                </div>
                <Button variant="ghost" size="sm" onClick={() => setShowJobEditModal(false)}>
                  <X className="w-5 h-5" />
                </Button>
              </div>
            </div>
            
            <div className="p-6 space-y-4">
              {/* Job Details */}
              <div className="bg-[var(--background-subtle)] p-4 rounded-lg space-y-2">
                <p><strong>Service:</strong> {editingJob.service_name || editingJob.service_type}</p>
                <p><strong>Date:</strong> {editingJob.scheduled_date} @ {editingJob.scheduled_time}</p>
                <p><strong>Duration:</strong> {editingJob.duration_hours} hours</p>
                <p><strong>Location:</strong> {editingJob.address}, {editingJob.city}</p>
                <p><strong>Customer:</strong> {editingJob.customer_name || 'N/A'}</p>
              </div>

              {/* Worker Pay - Editable */}
              <div>
                <Label>Worker Pay (visible to workers)</Label>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-lg">$</span>
                  <Input
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="Leave empty to hide price"
                    value={editingJob.worker_pay || ''}
                    onChange={(e) => setEditingJob({
                      ...editingJob,
                      worker_pay: e.target.value ? parseFloat(e.target.value) : null
                    })}
                    className="w-32"
                  />
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={async () => {
                      try {
                        await jobsAPI.updateJob(editingJob.id, { worker_pay: editingJob.worker_pay });
                        toast.success('Worker pay updated');
                        fetchAllData();
                      } catch (e) {
                        toast.error(e.response?.data?.detail || 'Failed to update');
                      }
                    }}
                  >
                    Save Pay
                  </Button>
                </div>
                <p className="text-xs text-[var(--text-muted)] mt-1">
                  {editingJob.worker_pay ? `Workers will see $${editingJob.worker_pay.toFixed(2)}` : 'Price will be hidden from workers'}
                </p>
              </div>

              {/* Current Status */}
              <div>
                <Label>Current Status</Label>
                <div className="flex items-center gap-2 mt-1">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                    editingJob.status === 'pending' ? 'bg-[var(--background-subtle)] text-[var(--text-primary)]' :
                    editingJob.status === 'available' ? 'bg-[#D4AF37]/10 text-[#D4AF37]' :
                    editingJob.status === 'claimed' ? 'bg-[var(--warning)]/15 text-yellow-700' :
                    editingJob.status === 'confirmed' ? 'bg-[var(--success)]/15 text-green-700' :
                    'bg-[var(--background-subtle)] text-[var(--text-primary)]'
                  }`}>
                    {editingJob.status?.replace('_', ' ')}
                  </span>
                  {editingJob.worker_details && (
                    <span className="text-sm">→ {editingJob.worker_details.full_name}</span>
                  )}
                </div>
              </div>

              {/* Claims */}
              {editingJob.claims?.length > 0 && (
                <div>
                  <Label>Worker Claims ({editingJob.claims.length})</Label>
                  <div className="mt-2 space-y-2">
                    {editingJob.claims.map(claim => (
                      <div key={claim.id} className="flex justify-between items-center p-3 bg-[var(--warning)]/10 rounded-lg">
                        <div>
                          <p className="font-medium">{claim.worker_name}</p>
                          <p className="text-xs text-[var(--text-muted)]">{claim.worker_email}</p>
                        </div>
                        <div className="flex gap-2">
                          <Button 
                            size="sm" 
                            className="bg-[var(--success)] hover:bg-[var(--success)]/80 text-white"
                            onClick={() => {
                              handleApproveJob(editingJob.id, claim.worker_id, claim.worker_name);
                              setShowJobEditModal(false);
                            }}
                          >
                            Approve
                          </Button>
                          <Button 
                            size="sm" 
                            variant="destructive"
                            onClick={() => {
                              handleDenyJob(editingJob.id, claim.worker_id);
                              setShowJobEditModal(false);
                            }}
                          >
                            Deny
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Quick Actions */}
              <div>
                <Label>Quick Actions</Label>
                <div className="mt-2 grid grid-cols-2 gap-2">
                  {editingJob.status === 'pending' && (
                    <Button 
                      variant="outline" 
                      className="w-full"
                      onClick={() => {
                        handlePostJob(editingJob.id);
                        setShowJobEditModal(false);
                      }}
                    >
                      Post to Board
                    </Button>
                  )}
                  {editingJob.status === 'confirmed' && editingJob.worker_id && (
                    <Button 
                      variant="outline" 
                      className="w-full text-[var(--error)]"
                      onClick={() => {
                        jobsAPI.unassignJob(editingJob.id, 'Manual unassignment')
                          .then(() => { toast.success('Worker unassigned'); fetchAllData(); setShowJobEditModal(false); })
                          .catch(e => toast.error(e.response?.data?.detail || 'Failed'));
                      }}
                    >
                      Unassign Worker
                    </Button>
                  )}
                </div>
              </div>

              {/* Manual Assignment */}
              {!editingJob.worker_id && (
                <div>
                  <Label>Manually Assign Worker</Label>
                  <Select onValueChange={(workerId) => {
                    handleManualAssign(editingJob.id, workerId);
                    setShowJobEditModal(false);
                  }}>
                    <SelectTrigger className="w-full mt-1">
                      <SelectValue placeholder="Select a worker..." />
                    </SelectTrigger>
                    <SelectContent>
                      {workers.filter(w => w.is_verified).map(worker => (
                        <SelectItem key={worker.id} value={worker.id}>
                          {worker.full_name} ({worker.service_types?.join(', ')})
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}
            </div>

            <div className="p-6 border-t flex gap-3">
              {/* Delete button - only show if job is not in progress or completed */}
              {editingJob && !['in_progress', 'completed'].includes(editingJob.status) && (
                <Button 
                  variant="destructive" 
                  className="flex-1"
                  onClick={() => handleDeleteJob(editingJob.id, `${editingJob.service_name || editingJob.service_type} on ${editingJob.scheduled_date}`)}
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Delete Job
                </Button>
              )}
              <Button variant="outline" className="flex-1" onClick={() => setShowJobEditModal(false)}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Worker File Modal */}
      {showWorkerFileModal && workerFile && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-[var(--background-paper)] rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
            <div className="p-6 border-b bg-gradient-to-r from-purple-50 to-pink-50 flex items-center justify-between">
              <div className="flex items-center gap-4">
                {workerFile.worker.profile_picture ? (
                  <img 
                    src={filesAPI.getUrl(workerFile.worker.profile_picture)} 
                    alt={workerFile.worker.full_name}
                    className="w-16 h-16 rounded-full object-cover border-2 border-white shadow"
                  />
                ) : (
                  <div className="w-16 h-16 rounded-full bg-[#F4C2C2]/15 flex items-center justify-center">
                    <Users className="w-8 h-8 text-[#F4C2C2]" />
                  </div>
                )}
                <div>
                  <div className="flex items-center gap-2">
                    <h2 className="text-xl font-bold text-[var(--text-primary)]">{workerFile.worker.full_name}</h2>
                    {workerFile.worker.employee_id && (
                      <span className="px-2 py-1 bg-[var(--primary)] text-white text-xs font-mono rounded-md">
                        {workerFile.worker.employee_id}
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-[var(--text-muted)]">{workerFile.worker.email}</p>
                  <p className="text-sm text-[var(--text-muted)]">{workerFile.worker.phone}</p>
                </div>
              </div>
              <Button variant="ghost" size="icon" onClick={() => setShowWorkerFileModal(false)}>
                <X className="w-5 h-5" />
              </Button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-6">
              {/* Stats Summary */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-[var(--success)]/10 rounded-xl p-4 text-center">
                  <p className="text-2xl font-bold text-[var(--success)]">{workerFile.stats.total_jobs_completed}</p>
                  <p className="text-sm text-green-700">Jobs Completed</p>
                </div>
                <div className="bg-[#D4AF37]/10 rounded-xl p-4 text-center">
                  <p className="text-2xl font-bold text-[#D4AF37]">${workerFile.stats.total_earnings.toFixed(2)}</p>
                  <p className="text-sm text-[#D4AF37]">Total Earnings</p>
                </div>
                <div className="bg-[#F4C2C2]/10 rounded-xl p-4 text-center">
                  <p className="text-2xl font-bold text-[#F4C2C2]">{workerFile.stats.total_hours_worked.toFixed(1)}h</p>
                  <p className="text-sm text-purple-700">Hours Worked</p>
                </div>
                <div className="bg-[var(--warning)]/10 rounded-xl p-4 text-center">
                  <p className="text-2xl font-bold text-amber-600">{workerFile.stats.average_rating}★</p>
                  <p className="text-sm text-amber-700">Rating</p>
                </div>
              </div>

              {/* Offer Letter */}
              <div className="card p-4">
                <h3 className="font-semibold text-[var(--text-primary)] flex items-center gap-2 mb-3">
                  <FileText className="w-5 h-5 text-[#F4C2C2]" />
                  Offer Letter
                </h3>
                {workerFile.offer_letter ? (
                  <div className="bg-[var(--background-subtle)] rounded-lg p-4 space-y-2">
                    <div className="flex justify-between">
                      <span className="text-[var(--text-secondary)]">Status:</span>
                      <span className={`font-medium ${workerFile.offer_letter.status === 'accepted' ? 'text-[var(--success)]' : 'text-amber-600'}`}>
                        {workerFile.offer_letter.status?.toUpperCase()}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-[var(--text-secondary)]">Hourly Rate:</span>
                      <span className="font-medium">${workerFile.offer_letter.hourly_rate}/hr</span>
                    </div>
                    {workerFile.offer_letter.signed_at && (
                      <div className="flex justify-between">
                        <span className="text-[var(--text-secondary)]">Signed:</span>
                        <span className="font-medium">{new Date(workerFile.offer_letter.signed_at).toLocaleDateString()}</span>
                      </div>
                    )}
                    {workerFile.offer_letter.signature_url && (
                      <div className="mt-3 pt-3 border-t">
                        <p className="text-sm text-[var(--text-muted)] mb-2">Signature:</p>
                        <img src={workerFile.offer_letter.signature_url} alt="Signature" className="max-h-16 border rounded" />
                      </div>
                    )}
                  </div>
                ) : (
                  <p className="text-[var(--text-muted)] italic">No offer letter on file</p>
                )}
              </div>

              {/* Payment Details - NEW SECTION */}
              <div className="card p-4 border-2 border-emerald-200 bg-emerald-50/30">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-semibold text-[var(--text-primary)] flex items-center gap-2">
                    <Banknote className="w-5 h-5 text-emerald-600" />
                    Payment Details
                  </h3>
                  <Button 
                    variant="ghost" 
                    size="sm"
                    onClick={() => setEditingPaymentDetails(!editingPaymentDetails)}
                    className="text-emerald-600 hover:text-emerald-700"
                    data-testid="edit-payment-details-btn"
                  >
                    <Edit className="w-4 h-4 mr-1" />
                    {editingPaymentDetails ? 'Cancel' : 'Edit'}
                  </Button>
                </div>

                {editingPaymentDetails ? (
                  <div className="space-y-4">
                    {/* Payment Method Selection */}
                    <div>
                      <Label className="text-sm font-medium">Preferred Payment Method</Label>
                      <div className="flex gap-2 mt-2">
                        {['direct_deposit', 'check', 'cash'].map((method) => (
                          <button
                            key={method}
                            onClick={() => setPaymentDetailsForm(prev => ({ ...prev, preferred_method: method }))}
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
                              paymentDetailsForm.preferred_method === method
                                ? 'bg-emerald-600 text-white'
                                : 'bg-[var(--background-subtle)] text-[var(--text-secondary)] hover:bg-[var(--background-subtle)]'
                            }`}
                            data-testid={`payment-method-${method}`}
                          >
                            {method === 'direct_deposit' ? 'Direct Deposit' : method === 'check' ? 'Check' : 'Cash'}
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Direct Deposit Fields */}
                    {paymentDetailsForm.preferred_method === 'direct_deposit' && (
                      <div className="grid grid-cols-2 gap-3 p-4 bg-[var(--background-paper)] rounded-lg border">
                        <div>
                          <Label className="text-xs">Bank Name</Label>
                          <Input
                            value={paymentDetailsForm.bank_name}
                            onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, bank_name: e.target.value }))}
                            placeholder="e.g., Chase Bank"
                            className="mt-1"
                            data-testid="bank-name-input"
                          />
                        </div>
                        <div>
                          <Label className="text-xs">Account Type</Label>
                          <select
                            value={paymentDetailsForm.account_type}
                            onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, account_type: e.target.value }))}
                            className="w-full mt-1 p-2 border rounded-lg text-sm"
                            data-testid="account-type-select"
                          >
                            <option value="checking">Checking</option>
                            <option value="savings">Savings</option>
                          </select>
                        </div>
                        <div>
                          <Label className="text-xs">Routing Number</Label>
                          <Input
                            value={paymentDetailsForm.routing_number}
                            onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, routing_number: e.target.value }))}
                            placeholder="9 digits"
                            maxLength={9}
                            className="mt-1"
                            data-testid="routing-number-input"
                          />
                        </div>
                        <div>
                          <Label className="text-xs">Account Number</Label>
                          <Input
                            value={paymentDetailsForm.account_number}
                            onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, account_number: e.target.value }))}
                            placeholder="Account number"
                            className="mt-1"
                            data-testid="account-number-input"
                          />
                        </div>
                      </div>
                    )}

                    {/* Check Fields */}
                    {paymentDetailsForm.preferred_method === 'check' && (
                      <div className="p-4 bg-[var(--background-paper)] rounded-lg border space-y-3">
                        <p className="text-sm text-[var(--text-muted)]">Check will be mailed to:</p>
                        <div>
                          <Label className="text-xs">Payee Name</Label>
                          <Input
                            value={paymentDetailsForm.check_payee_name}
                            onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, check_payee_name: e.target.value }))}
                            placeholder="Name on check"
                            className="mt-1"
                            data-testid="check-payee-input"
                          />
                        </div>
                        <div>
                          <Label className="text-xs">Mailing Address</Label>
                          <Input
                            value={paymentDetailsForm.check_address}
                            onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, check_address: e.target.value }))}
                            placeholder="Street address"
                            className="mt-1"
                            data-testid="check-address-input"
                          />
                        </div>
                        <div className="grid grid-cols-3 gap-2">
                          <div>
                            <Label className="text-xs">City</Label>
                            <Input
                              value={paymentDetailsForm.check_city}
                              onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, check_city: e.target.value }))}
                              className="mt-1"
                            />
                          </div>
                          <div>
                            <Label className="text-xs">State</Label>
                            <Input
                              value={paymentDetailsForm.check_state}
                              onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, check_state: e.target.value }))}
                              className="mt-1"
                            />
                          </div>
                          <div>
                            <Label className="text-xs">ZIP</Label>
                            <Input
                              value={paymentDetailsForm.check_zip}
                              onChange={(e) => setPaymentDetailsForm(prev => ({ ...prev, check_zip: e.target.value }))}
                              className="mt-1"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Cash Note */}
                    {paymentDetailsForm.preferred_method === 'cash' && (
                      <div className="p-4 bg-[var(--warning)]/10 rounded-lg border border-[var(--warning)]/30">
                        <p className="text-sm text-amber-700">
                          Cash payments will be recorded manually. No additional details required.
                        </p>
                      </div>
                    )}

                    {/* Save Button */}
                    <Button
                      onClick={handleSavePaymentDetails}
                      disabled={savingPaymentDetails}
                      className="w-full bg-emerald-600 hover:bg-emerald-700 text-white"
                      data-testid="save-payment-details-btn"
                    >
                      {savingPaymentDetails ? 'Saving...' : 'Save Payment Details'}
                    </Button>
                  </div>
                ) : (
                  <div className="bg-[var(--background-paper)] rounded-lg p-4 space-y-3">
                    {workerFile.payment_details?.preferred_method ? (
                      <>
                        <div className="flex justify-between items-center">
                          <span className="text-[var(--text-secondary)]">Payment Method:</span>
                          <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                            workerFile.payment_details.preferred_method === 'direct_deposit' ? 'bg-emerald-100 text-emerald-700' :
                            workerFile.payment_details.preferred_method === 'check' ? 'bg-[#D4AF37]/10 text-[#D4AF37]' :
                            'bg-amber-100 text-amber-700'
                          }`}>
                            {workerFile.payment_details.preferred_method === 'direct_deposit' ? 'Direct Deposit' :
                             workerFile.payment_details.preferred_method === 'check' ? 'Check' : 'Cash'}
                          </span>
                        </div>

                        {workerFile.payment_details.preferred_method === 'direct_deposit' && (
                          <>
                            {workerFile.payment_details.bank_name && (
                              <div className="flex justify-between">
                                <span className="text-[var(--text-secondary)]">Bank:</span>
                                <span className="font-medium">{workerFile.payment_details.bank_name}</span>
                              </div>
                            )}
                            {workerFile.payment_details.account_type && (
                              <div className="flex justify-between">
                                <span className="text-[var(--text-secondary)]">Account Type:</span>
                                <span className="font-medium capitalize">{workerFile.payment_details.account_type}</span>
                              </div>
                            )}
                            {workerFile.payment_details.routing_number_display && (
                              <div className="flex justify-between">
                                <span className="text-[var(--text-secondary)]">Routing:</span>
                                <span className="font-mono">{workerFile.payment_details.routing_number_display}</span>
                              </div>
                            )}
                            {workerFile.payment_details.account_number_display && (
                              <div className="flex justify-between">
                                <span className="text-[var(--text-secondary)]">Account:</span>
                                <span className="font-mono">{workerFile.payment_details.account_number_display}</span>
                              </div>
                            )}
                          </>
                        )}

                        {workerFile.payment_details.preferred_method === 'check' && (
                          <div className="text-sm text-[var(--text-secondary)]">
                            <p className="font-medium mb-1">Mailing Address:</p>
                            <p>{workerFile.payment_details.check_payee_name}</p>
                            <p>{workerFile.payment_details.check_address}</p>
                            <p>{workerFile.payment_details.check_city}, {workerFile.payment_details.check_state} {workerFile.payment_details.check_zip}</p>
                          </div>
                        )}

                        {workerFile.payment_details.updated_at && (
                          <p className="text-xs text-gray-400 pt-2 border-t">
                            Last updated: {new Date(workerFile.payment_details.updated_at).toLocaleDateString()}
                          </p>
                        )}
                      </>
                    ) : (
                      <div className="text-center py-4">
                        <Banknote className="w-8 h-8 mx-auto text-gray-300 mb-2" />
                        <p className="text-[var(--text-muted)] italic">No payment details configured</p>
                        <p className="text-xs text-gray-400 mt-1">Click Edit to add bank or check details</p>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Agreements */}
              <div className="card p-4">
                <h3 className="font-semibold text-[var(--text-primary)] flex items-center gap-2 mb-3">
                  <CheckCircle className="w-5 h-5 text-[var(--success)]" />
                  Signed Agreements
                </h3>
                {workerFile.agreements?.agreements ? (
                  <div className="grid grid-cols-2 gap-2">
                    <div className={`flex items-center gap-2 p-2 rounded ${workerFile.agreements.agreements.contractor_1099?.agreed ? 'bg-[var(--success)]/10 text-green-700' : 'bg-[var(--background-subtle)] text-gray-400'}`}>
                      {workerFile.agreements.agreements.contractor_1099?.agreed ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
                      Employment Agreement
                    </div>
                    <div className={`flex items-center gap-2 p-2 rounded ${workerFile.agreements.agreements.background_check?.agreed ? 'bg-[var(--success)]/10 text-green-700' : 'bg-[var(--background-subtle)] text-gray-400'}`}>
                      {workerFile.agreements.agreements.background_check?.agreed ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
                      Background Check Consent
                    </div>
                    <div className={`flex items-center gap-2 p-2 rounded ${workerFile.agreements.agreements.liability_waiver?.agreed ? 'bg-[var(--success)]/10 text-green-700' : 'bg-[var(--background-subtle)] text-gray-400'}`}>
                      {workerFile.agreements.agreements.liability_waiver?.agreed ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
                      Liability Waiver
                    </div>
                    <div className={`flex items-center gap-2 p-2 rounded ${workerFile.agreements.agreements.confidentiality?.agreed ? 'bg-[var(--success)]/10 text-green-700' : 'bg-[var(--background-subtle)] text-gray-400'}`}>
                      {workerFile.agreements.agreements.confidentiality?.agreed ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
                      Confidentiality Agreement
                    </div>
                    <div className={`flex items-center gap-2 p-2 rounded ${workerFile.agreements.agreements.non_solicitation?.agreed ? 'bg-[var(--success)]/10 text-green-700' : 'bg-[var(--background-subtle)] text-gray-400'}`}>
                      {workerFile.agreements.agreements.non_solicitation?.agreed ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
                      Non-Solicitation Agreement
                    </div>
                  </div>
                ) : (
                  <p className="text-[var(--text-muted)] italic">No agreements signed yet</p>
                )}
              </div>

              {/* Onboarding Documents */}
              <div className="card p-4">
                <h3 className="font-semibold text-[var(--text-primary)] flex items-center gap-2 mb-3">
                  <Upload className="w-5 h-5 text-[#D4AF37]" />
                  Onboarding Documents ({workerFile.onboarding.progress_percent}% Complete)
                </h3>
                {workerFile.onboarding.documents?.length > 0 ? (
                  <div className="space-y-2">
                    {workerFile.onboarding.documents.map((doc) => (
                      <div key={doc.type || doc.id || doc.file_url} className="flex items-center justify-between p-2 bg-[var(--background-subtle)] rounded">
                        <span className="flex items-center gap-2">
                          <FileText className="w-4 h-4 text-gray-400" />
                          {doc.type?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                        </span>
                        <span className={`text-sm ${doc.status === 'uploaded' || doc.status === 'approved' ? 'text-[var(--success)]' : 'text-amber-600'}`}>
                          {doc.status?.toUpperCase()}
                        </span>
                        {doc.file_url && (
                          <a href={doc.file_url} target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:underline text-sm">
                            View
                          </a>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-[var(--text-muted)] italic">No documents uploaded yet</p>
                )}
              </div>

              {/* Completed Jobs */}
              <div className="card p-4">
                <h3 className="font-semibold text-[var(--text-primary)] flex items-center gap-2 mb-3">
                  <Briefcase className="w-5 h-5 text-[var(--success)]" />
                  Completed Jobs ({workerFile.completed_jobs?.length || 0})
                </h3>
                {workerFile.completed_jobs?.length > 0 ? (
                  <div className="space-y-2 max-h-48 overflow-y-auto">
                    {workerFile.completed_jobs.map(job => (
                      <div key={job.id} className="flex items-center justify-between p-2 bg-[var(--background-subtle)] rounded">
                        <div>
                          <p className="font-medium text-sm">{job.service_name || job.service_type}</p>
                          <p className="text-xs text-[var(--text-muted)]">{job.scheduled_date} • {job.customer_name}</p>
                        </div>
                        <span className="text-[var(--success)] font-medium">${job.total_amount?.toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-[var(--text-muted)] italic">No completed jobs yet</p>
                )}
              </div>

              {/* Pay Stubs */}
              <div className="card p-4">
                <h3 className="font-semibold text-[var(--text-primary)] flex items-center gap-2 mb-3">
                  <DollarSign className="w-5 h-5 text-[var(--success)]" />
                  Pay Stubs ({workerFile.pay_stubs?.length || 0})
                </h3>
                {workerFile.pay_stubs?.length > 0 ? (
                  <div className="space-y-2 max-h-48 overflow-y-auto">
                    {workerFile.pay_stubs.map(stub => (
                      <div key={stub.id} className="flex items-center justify-between p-2 bg-[var(--background-subtle)] rounded">
                        <div>
                          <p className="font-medium text-sm">Period: {stub.period_start} - {stub.period_end}</p>
                          <p className="text-xs text-[var(--text-muted)]">{stub.hours_worked}h worked</p>
                        </div>
                        <span className="text-[var(--success)] font-medium">${stub.net_pay?.toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-[var(--text-muted)] italic">No pay stubs yet</p>
                )}
              </div>
            </div>

            <div className="p-4 border-t bg-[var(--background-subtle)]">
              <Button variant="outline" className="w-full" onClick={() => setShowWorkerFileModal(false)}>
                Close Worker File
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Worker Assignment Email Preview Modal */}
      {emailPreviewModal.open && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-[var(--background-paper)] rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col"
          >
            <div className="p-6 border-b border-[var(--border-primary)] flex justify-between items-center">
              <div>
                <h2 className="text-xl font-bold font-['Cormorant_Garamond']">Customer Confirmation Email Preview</h2>
                <p className="text-sm text-[var(--text-muted)]">
                  Review and send the assignment confirmation email to the customer
                </p>
              </div>
              <Button 
                variant="ghost" 
                size="icon" 
                onClick={() => setEmailPreviewModal({ open: false, booking: null, worker: null, preview: null, loading: false, editedSubject: '', editedContent: '' })}
              >
                <X className="w-5 h-5" />
              </Button>
            </div>
            
            {emailPreviewModal.loading ? (
              <div className="flex-1 flex items-center justify-center p-12">
                <div className="animate-spin w-8 h-8 border-4 border-[var(--primary)] border-t-transparent rounded-full" />
                <p className="ml-4 text-[var(--text-muted)]">Generating email preview...</p>
              </div>
            ) : emailPreviewModal.preview ? (
              <>
                <div className="p-6 border-b border-gray-100 bg-[var(--background-subtle)]">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <Label className="text-xs text-[var(--text-muted)]">To:</Label>
                      <p className="font-medium">{emailPreviewModal.preview.customer_email}</p>
                    </div>
                    <div>
                      <Label className="text-xs text-[var(--text-muted)]">Customer:</Label>
                      <p className="font-medium">{emailPreviewModal.preview.customer_name}</p>
                    </div>
                  </div>
                  <div className="mt-4">
                    <Label className="text-xs text-[var(--text-muted)]">Subject:</Label>
                    <Input
                      value={emailPreviewModal.editedSubject}
                      onChange={(e) => setEmailPreviewModal(prev => ({ ...prev, editedSubject: e.target.value }))}
                      className="input-styled mt-1"
                    />
                  </div>
                </div>
                
                <div className="flex-1 overflow-y-auto p-6">
                  <div className="mb-4 flex items-center justify-between">
                    <Label className="text-sm font-semibold">Email Content (Editable)</Label>
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => setEmailPreviewModal(prev => ({ ...prev, editedContent: prev.preview.html_content }))}
                    >
                      Reset to Original
                    </Button>
                  </div>
                  
                  {/* HTML Preview - Using sandboxed iframe for XSS protection */}
                  <div className="border border-[var(--border-primary)] rounded-xl overflow-hidden">
                    <div className="bg-[var(--background-subtle)] px-4 py-2 border-b border-[var(--border-primary)] text-xs text-[var(--text-muted)]">
                      Email Preview
                    </div>
                    <iframe 
                      className="w-full bg-[var(--background-paper)]"
                      style={{ minHeight: '300px', border: 'none' }}
                      sandbox="allow-same-origin"
                      srcDoc={emailPreviewModal.editedContent}
                      title="Email Preview"
                    />
                  </div>
                  
                  {/* Worker Info Summary */}
                  {emailPreviewModal.preview.worker_info && (
                    <div className="mt-6 p-4 bg-[var(--success)]/10 border border-[var(--success)]/30 rounded-xl">
                      <h4 className="font-semibold text-[var(--success)] mb-2">Worker Details Included:</h4>
                      <div className="grid md:grid-cols-3 gap-4 text-sm">
                        <div>
                          <p className="text-green-700">Name: <strong>{emailPreviewModal.preview.worker_info.name}</strong></p>
                          <p className="text-green-700">Experience: <strong>{emailPreviewModal.preview.worker_info.years_of_experience}+ years</strong></p>
                        </div>
                        <div>
                          <p className="text-green-700">Rating: <strong>{emailPreviewModal.preview.worker_info.rating || 'New'} ⭐</strong></p>
                          <p className="text-green-700">Reviews: <strong>{emailPreviewModal.preview.worker_info.review_count}</strong></p>
                        </div>
                        <div>
                          <p className="text-green-700">Certifications: <strong>{emailPreviewModal.preview.worker_info.certifications?.length || 0}</strong></p>
                          <p className="text-green-700">Photo: <strong>{emailPreviewModal.preview.worker_info.photo_url ? 'Yes' : 'No'}</strong></p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                
                <div className="p-6 border-t border-[var(--border-primary)] flex justify-between items-center gap-4">
                  <div className="flex items-center gap-2">
                    <input type="checkbox" id="sendCopy" defaultChecked className="rounded" />
                    <Label htmlFor="sendCopy" className="text-sm text-[var(--text-muted)]">Send copy to owner</Label>
                  </div>
                  <div className="flex gap-3">
                    <Button 
                      variant="outline"
                      onClick={() => setEmailPreviewModal({ open: false, booking: null, worker: null, preview: null, loading: false, editedSubject: '', editedContent: '' })}
                    >
                      Skip Sending
                    </Button>
                    <Button 
                      className="btn-primary"
                      onClick={handleSendAssignmentEmail}
                    >
                      <Mail className="w-4 h-4 mr-2" />
                      Send to Customer
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex-1 flex items-center justify-center p-12">
                <p className="text-[var(--text-muted)]">No preview available</p>
              </div>
            )}
          </motion.div>
        </div>
      )}

      {/* Notes Modal */}
      <NotesModal
        isOpen={notesModal.open}
        onClose={() => setNotesModal({ open: false, entityType: '', entityId: '', entityName: '' })}
        entityType={notesModal.entityType}
        entityId={notesModal.entityId}
        entityName={notesModal.entityName}
      />

      {/* Video/Voice Call Modal */}
      {showCallModal && activeCall && (
        <VideoCallModal
          isOpen={showCallModal}
          onClose={() => {
            setActiveCall(null);
            setShowCallModal(false);
          }}
          callData={activeCall}
          currentUser={user}
          onCallEnd={() => {
            setActiveCall(null);
            setShowCallModal(false);
          }}
        />
      )}

      {/* Incoming Call Modal */}
      {incomingCall && (
        <IncomingCallModal
          isOpen={!!incomingCall}
          caller={incomingCall?.otherParty}
          callType={incomingCall?.callType}
          onAccept={() => {
            setActiveCall({ ...incomingCall, direction: 'incoming' });
            setIncomingCall(null);
            setShowCallModal(true);
          }}
          onDecline={() => {
            setIncomingCall(null);
          }}
        />
      )}

      {/* Owner Job Workflow Modal - Same experience as workers */}
      <ServiceWorkflowRouter
        isOpen={showOwnerWorkflowModal}
        onClose={() => {
          setShowOwnerWorkflowModal(false);
          setOwnerWorkflowJob(null);
        }}
        job={ownerWorkflowJob}
        worker={user}
        onWorkflowComplete={(completionData) => {
          console.log('Owner workflow completed:', completionData);
          setShowOwnerWorkflowModal(false);
          setOwnerWorkflowJob(null);
          fetchOwnerAssignedJobs();
          fetchAllData();
          toast.success('Job workflow completed!');
        }}
      />

      {/* Floating Support Button for Owner */}
      <SupportButton 
        currentUser={user}
        onStartCall={(callData) => {
          setActiveCall(callData);
          setShowCallModal(true);
        }}
      />

      {/* Booking Action Modal - Full Workflow Prompts */}
      {bookingActionModal.open && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={() => setBookingActionModal({ open: false, bookingId: null, action: null, booking: null })}>
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-[var(--background-paper)] rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div className={`p-6 border-b border-[var(--border-primary)] ${
              bookingActionModal.action === 'confirm' ? 'bg-gradient-to-r from-emerald-500/10 to-green-500/10' :
              bookingActionModal.action === 'start' ? 'bg-gradient-to-r from-[#D4AF37]/10 to-amber-500/10' :
              bookingActionModal.action === 'complete' ? 'bg-gradient-to-r from-blue-500/10 to-indigo-500/10' :
              'bg-gradient-to-r from-red-500/10 to-rose-500/10'
            }`}>
              <div className="flex items-center gap-3">
                {bookingActionModal.action === 'confirm' && <CheckCircle className="w-8 h-8 text-emerald-500" />}
                {bookingActionModal.action === 'start' && <Play className="w-8 h-8 text-[#D4AF37]" />}
                {bookingActionModal.action === 'complete' && <CheckCircle className="w-8 h-8 text-blue-500" />}
                {bookingActionModal.action === 'cancel' && <X className="w-8 h-8 text-red-500" />}
                <div>
                  <h2 className="text-xl font-bold font-['Cormorant_Garamond']">
                    {bookingActionModal.action === 'confirm' && 'Confirm Booking'}
                    {bookingActionModal.action === 'start' && 'Start Job'}
                    {bookingActionModal.action === 'complete' && 'Complete Job'}
                    {bookingActionModal.action === 'cancel' && 'Cancel Booking'}
                  </h2>
                  <p className="text-sm text-[var(--text-muted)]">
                    {bookingActionModal.booking?.service_name} • {bookingActionModal.booking?.customer_name}
                  </p>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="p-6 space-y-4">
              {/* Booking Summary */}
              <div className="bg-[var(--background-subtle)] rounded-xl p-4">
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <span className="text-[var(--text-muted)]">Service:</span>
                    <p className="font-medium">{bookingActionModal.booking?.service_name}</p>
                  </div>
                  <div>
                    <span className="text-[var(--text-muted)]">Date:</span>
                    <p className="font-medium">{bookingActionModal.booking?.scheduled_date}</p>
                  </div>
                  <div>
                    <span className="text-[var(--text-muted)]">Time:</span>
                    <p className="font-medium">{bookingActionModal.booking?.scheduled_time}</p>
                  </div>
                  <div>
                    <span className="text-[var(--text-muted)]">Duration:</span>
                    <p className="font-medium">{bookingActionModal.booking?.duration_hours}h</p>
                  </div>
                </div>
              </div>

              {/* CONFIRM ACTION FORM */}
              {bookingActionModal.action === 'confirm' && (
                <>
                  <div>
                    <label className="block text-sm font-medium mb-2">Price (adjust if needed)</label>
                    <div className="relative">
                      <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-muted)]" />
                      <input
                        type="number"
                        step="0.01"
                        value={actionFormData.price_override || ''}
                        onChange={(e) => setActionFormData({...actionFormData, price_override: e.target.value})}
                        className="w-full pl-10 pr-4 py-3 rounded-xl border border-[var(--border-primary)] bg-[var(--background)] focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--primary)]"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Estimated Duration (hours)</label>
                    <input
                      type="number"
                      step="0.5"
                      value={actionFormData.estimated_duration || ''}
                      onChange={(e) => setActionFormData({...actionFormData, estimated_duration: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl border border-[var(--border-primary)] bg-[var(--background)] focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Notes for Customer (optional)</label>
                    <textarea
                      value={actionFormData.notes}
                      onChange={(e) => setActionFormData({...actionFormData, notes: e.target.value})}
                      placeholder="Any special instructions or notes..."
                      className="w-full px-4 py-3 rounded-xl border border-[var(--border-primary)] bg-[var(--background)] focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--primary)] min-h-[80px]"
                    />
                  </div>
                  <label className="flex items-center gap-3 p-3 bg-[var(--background-subtle)] rounded-xl cursor-pointer">
                    <input
                      type="checkbox"
                      checked={actionFormData.send_confirmation_email}
                      onChange={(e) => setActionFormData({...actionFormData, send_confirmation_email: e.target.checked})}
                      className="w-5 h-5 rounded border-[var(--border-primary)]"
                    />
                    <div>
                      <span className="font-medium">Send Confirmation Email</span>
                      <p className="text-xs text-[var(--text-muted)]">Customer will receive booking confirmation</p>
                    </div>
                  </label>
                </>
              )}

              {/* START JOB FORM */}
              {bookingActionModal.action === 'start' && (
                <>
                  <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                    <div className="flex items-center gap-2 text-amber-700 font-medium mb-2">
                      <Clock className="w-5 h-5" />
                      Clock-In Confirmation
                    </div>
                    <p className="text-sm text-amber-600">
                      This will record the job start time as <strong>{new Date().toLocaleTimeString()}</strong>
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Start Notes (optional)</label>
                    <textarea
                      value={actionFormData.notes}
                      onChange={(e) => setActionFormData({...actionFormData, notes: e.target.value})}
                      placeholder="Any notes about starting the job..."
                      className="w-full px-4 py-3 rounded-xl border border-[var(--border-primary)] bg-[var(--background)] focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--primary)] min-h-[80px]"
                    />
                  </div>
                  <label className="flex items-center gap-3 p-3 bg-[var(--background-subtle)] rounded-xl cursor-pointer">
                    <input
                      type="checkbox"
                      checked={actionFormData.notify_customer}
                      onChange={(e) => setActionFormData({...actionFormData, notify_customer: e.target.checked})}
                      className="w-5 h-5 rounded border-[var(--border-primary)]"
                    />
                    <div>
                      <span className="font-medium">Notify Customer</span>
                      <p className="text-xs text-[var(--text-muted)]">Send Job Started notification</p>
                    </div>
                  </label>
                </>
              )}

              {/* COMPLETE JOB FORM */}
              {bookingActionModal.action === 'complete' && (
                <>
                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                    <div className="flex items-center gap-2 text-blue-700 font-medium mb-2">
                      <CheckCircle className="w-5 h-5" />
                      Job Completion
                    </div>
                    <p className="text-sm text-blue-600">
                      Mark this job as completed. Customer will be notified.
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Completion Notes *</label>
                    <textarea
                      value={actionFormData.completion_notes}
                      onChange={(e) => setActionFormData({...actionFormData, completion_notes: e.target.value, notes: e.target.value})}
                      placeholder="Describe work completed, any issues, etc..."
                      className="w-full px-4 py-3 rounded-xl border border-[var(--border-primary)] bg-[var(--background)] focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--primary)] min-h-[100px]"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Final Price (if different)</label>
                    <div className="relative">
                      <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-muted)]" />
                      <input
                        type="number"
                        step="0.01"
                        value={actionFormData.price_override || ''}
                        onChange={(e) => setActionFormData({...actionFormData, price_override: e.target.value})}
                        className="w-full pl-10 pr-4 py-3 rounded-xl border border-[var(--border-primary)] bg-[var(--background)] focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--primary)]"
                        placeholder={bookingActionModal.booking?.total_amount?.toString()}
                      />
                    </div>
                  </div>
                  <label className="flex items-center gap-3 p-3 bg-[var(--background-subtle)] rounded-xl cursor-pointer">
                    <input
                      type="checkbox"
                      checked={actionFormData.notify_customer}
                      onChange={(e) => setActionFormData({...actionFormData, notify_customer: e.target.checked})}
                      className="w-5 h-5 rounded border-[var(--border-primary)]"
                    />
                    <div>
                      <span className="font-medium">Send Completion Notification</span>
                      <p className="text-xs text-[var(--text-muted)]">Customer will receive job completion email</p>
                    </div>
                  </label>
                </>
              )}

              {/* CANCEL FORM */}
              {bookingActionModal.action === 'cancel' && (
                <>
                  <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                    <div className="flex items-center gap-2 text-red-700 font-medium mb-2">
                      <AlertTriangle className="w-5 h-5" />
                      Cancel Booking
                    </div>
                    <p className="text-sm text-red-600">
                      This action cannot be undone. The customer will be notified.
                    </p>
                  </div>
                  
                  {/* Reschedule Option */}
                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                    <label className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={actionFormData.offer_reschedule}
                        onChange={(e) => setActionFormData({...actionFormData, offer_reschedule: e.target.checked})}
                        className="w-5 h-5 rounded border-blue-300 text-blue-600"
                      />
                      <div>
                        <span className="font-medium text-blue-700">Offer Reschedule Instead</span>
                        <p className="text-xs text-blue-600">Contact customer to reschedule rather than cancel</p>
                      </div>
                    </label>
                    
                    {actionFormData.offer_reschedule && (
                      <div className="mt-4 grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-xs font-medium text-blue-700 mb-1">New Date</label>
                          <input
                            type="date"
                            value={actionFormData.reschedule_date || ''}
                            onChange={(e) => setActionFormData({...actionFormData, reschedule_date: e.target.value})}
                            className="w-full px-3 py-2 rounded-lg border border-blue-300 bg-white text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-blue-700 mb-1">New Time</label>
                          <input
                            type="time"
                            value={actionFormData.reschedule_time || ''}
                            onChange={(e) => setActionFormData({...actionFormData, reschedule_time: e.target.value})}
                            className="w-full px-3 py-2 rounded-lg border border-blue-300 bg-white text-sm"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium mb-2">Cancellation Reason *</label>
                    <select
                      value={actionFormData.cancellation_reason}
                      onChange={(e) => setActionFormData({...actionFormData, cancellation_reason: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl border border-[var(--border-primary)] bg-[var(--background)] focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--primary)]"
                      required
                    >
                      <option value="">Select a reason...</option>
                      <option value="customer_request">Customer Request</option>
                      <option value="scheduling_conflict">Scheduling Conflict</option>
                      <option value="no_worker_available">No Worker Available</option>
                      <option value="service_unavailable">Service Unavailable</option>
                      <option value="weather">Weather Conditions</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Additional Notes</label>
                    <textarea
                      value={actionFormData.notes}
                      onChange={(e) => setActionFormData({...actionFormData, notes: e.target.value})}
                      placeholder="Any additional details..."
                      className="w-full px-4 py-3 rounded-xl border border-[var(--border-primary)] bg-[var(--background)] focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--primary)] min-h-[80px]"
                    />
                  </div>
                  <label className="flex items-center gap-3 p-3 bg-[var(--background-subtle)] rounded-xl cursor-pointer">
                    <input
                      type="checkbox"
                      checked={actionFormData.notify_customer}
                      onChange={(e) => setActionFormData({...actionFormData, notify_customer: e.target.checked})}
                      className="w-5 h-5 rounded border-[var(--border-primary)]"
                    />
                    <div>
                      <span className="font-medium">Notify Customer</span>
                      <p className="text-xs text-[var(--text-muted)]">Send {actionFormData.offer_reschedule ? 'reschedule' : 'cancellation'} notification via email</p>
                    </div>
                  </label>
                </>
              )}
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-[var(--border-primary)] flex gap-3">
              <Button
                variant="outline"
                className="flex-1"
                onClick={() => setBookingActionModal({ open: false, bookingId: null, action: null, booking: null })}
              >
                Close
              </Button>
              <Button
                className={`flex-1 ${
                  bookingActionModal.action === 'confirm' ? 'bg-emerald-500 hover:bg-emerald-600' :
                  bookingActionModal.action === 'start' ? 'bg-[#D4AF37] hover:bg-[#E6C965] text-black' :
                  bookingActionModal.action === 'complete' ? 'bg-blue-500 hover:bg-blue-600' :
                  actionFormData.offer_reschedule ? 'bg-blue-500 hover:bg-blue-600' :
                  'bg-red-500 hover:bg-red-600'
                } text-white`}
                onClick={executeBookingAction}
                disabled={bookingActionModal.action === 'cancel' && !actionFormData.cancellation_reason}
              >
                {bookingActionModal.action === 'confirm' && 'Confirm Booking'}
                {bookingActionModal.action === 'start' && 'Start Job'}
                {bookingActionModal.action === 'complete' && 'Mark Complete'}
                {bookingActionModal.action === 'cancel' && (actionFormData.offer_reschedule ? 'Reschedule Booking' : 'Cancel Booking')}
              </Button>
            </div>
          </motion.div>
        </div>
      )}

      {/* Mobile Bottom Navigation - Owner: Overview | Rides | Bookings | More */}
      <BottomNavBar
        tabs={[
          { id: 'overview', label: 'Overview', icon: 'Home' },
          { id: 'rides', label: 'Rides', icon: 'Car' },
          { id: 'bookings', label: 'Bookings', icon: 'Calendar' },
          { id: 'more', label: 'More', icon: 'MoreHorizontal' },
        ]}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        moreMenuItems={[
          { id: 'quick-actions', label: 'Quick Actions', isDivider: true },
          { id: 'phone', label: 'Phone Booking', icon: 'Phone' },
          { id: 'services', label: 'Service Types', isDivider: true },
          { id: 'courier-bookings', label: 'Courier', icon: 'Package' },
          { id: 'errands-bookings', label: 'Errands', icon: 'ShoppingBag' },
          { id: 'laundry-bookings', label: 'Laundry', icon: 'Shirt' },
          { id: 'business', label: 'Business', isDivider: true },
          { id: 'workers', label: 'Workers', icon: 'Users' },
          { id: 'customers', label: 'Customers', icon: 'UserCheck' },
          { id: 'reviews', label: 'Reviews', icon: 'Star' },
          { id: 'analytics', label: 'Analytics', icon: 'BarChart3' },
          { id: 'maps', label: 'Driver Map', icon: 'MapPin' },
          { id: 'admin', label: 'Admin', isDivider: true },
          { id: 'services', label: 'Services', icon: 'Briefcase' },
          { id: 'pricing', label: 'Pricing', icon: 'DollarSign' },
          { id: 'settings', label: 'Settings', icon: 'Settings' },
        ]}
        badge={{}}
      />
      
      {/* Notification Preferences Modal */}
      <NotificationPreferences 
        isOpen={showNotificationPrefs} 
        onClose={() => setShowNotificationPrefs(false)} 
      />
    </div>
  );
};

export default OwnerDashboard;
